
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a3e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a3e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2RmP6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hDFHz"));

});
parcelRegister("hDFHz", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $cd766d4f12ec0e30$export$ffb0004e005737fa; }, function (v) { return $cd766d4f12ec0e30$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $cd766d4f12ec0e30$export$34b9dba7ce09269b; }, function (v) { return $cd766d4f12ec0e30$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $cd766d4f12ec0e30$export$25062201e9e25d76; }, function (v) { return $cd766d4f12ec0e30$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cd766d4f12ec0e30$export$ffb0004e005737fa;
var $cd766d4f12ec0e30$export$34b9dba7ce09269b;
var $cd766d4f12ec0e30$export$25062201e9e25d76;
"use strict";

var $6YKZt = parcelRequire("6YKZt");
var $cd766d4f12ec0e30$var$k = Symbol.for("react.element"), $cd766d4f12ec0e30$var$l = Symbol.for("react.fragment"), $cd766d4f12ec0e30$var$m = Object.prototype.hasOwnProperty, $cd766d4f12ec0e30$var$n = $6YKZt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $cd766d4f12ec0e30$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cd766d4f12ec0e30$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$cd766d4f12ec0e30$var$m.call(a, b) && !$cd766d4f12ec0e30$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $cd766d4f12ec0e30$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $cd766d4f12ec0e30$var$n.current
    };
}
$cd766d4f12ec0e30$export$ffb0004e005737fa = $cd766d4f12ec0e30$var$l;
$cd766d4f12ec0e30$export$34b9dba7ce09269b = $cd766d4f12ec0e30$var$q;
$cd766d4f12ec0e30$export$25062201e9e25d76 = $cd766d4f12ec0e30$var$q;

});
parcelRegister("6YKZt", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fotmt"));

});
parcelRegister("fotmt", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b34fdf7f3419fa3e$export$dca3b0875bd9a954; }, function (v) { return $b34fdf7f3419fa3e$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b34fdf7f3419fa3e$export$16fa2f45be04daa8; }, function (v) { return $b34fdf7f3419fa3e$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b34fdf7f3419fa3e$export$ffb0004e005737fa; }, function (v) { return $b34fdf7f3419fa3e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b34fdf7f3419fa3e$export$e2c29f18771995cb; }, function (v) { return $b34fdf7f3419fa3e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b34fdf7f3419fa3e$export$221d75b3f55bb0bd; }, function (v) { return $b34fdf7f3419fa3e$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b34fdf7f3419fa3e$export$5f8d39834fd61797; }, function (v) { return $b34fdf7f3419fa3e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b34fdf7f3419fa3e$export$74bf444e3cd11ea5; }, function (v) { return $b34fdf7f3419fa3e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b34fdf7f3419fa3e$export$ae55be85d98224ed; }, function (v) { return $b34fdf7f3419fa3e$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b34fdf7f3419fa3e$export$e530037191fcd5d7; }, function (v) { return $b34fdf7f3419fa3e$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b34fdf7f3419fa3e$export$fd42f52fd3ae1109; }, function (v) { return $b34fdf7f3419fa3e$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b34fdf7f3419fa3e$export$c8a8987d4410bf2d; }, function (v) { return $b34fdf7f3419fa3e$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b34fdf7f3419fa3e$export$d38cd72104c1f0e9; }, function (v) { return $b34fdf7f3419fa3e$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b34fdf7f3419fa3e$export$7d1e3a5e95ceca43; }, function (v) { return $b34fdf7f3419fa3e$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b34fdf7f3419fa3e$export$257a8862b851cb5b; }, function (v) { return $b34fdf7f3419fa3e$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b34fdf7f3419fa3e$export$a8257692ac88316c; }, function (v) { return $b34fdf7f3419fa3e$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b34fdf7f3419fa3e$export$488013bae63b21da; }, function (v) { return $b34fdf7f3419fa3e$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b34fdf7f3419fa3e$export$7c73462e0d25e514; }, function (v) { return $b34fdf7f3419fa3e$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b34fdf7f3419fa3e$export$7568632d0d33d16d; }, function (v) { return $b34fdf7f3419fa3e$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b34fdf7f3419fa3e$export$88948ce120ea2619; }, function (v) { return $b34fdf7f3419fa3e$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b34fdf7f3419fa3e$export$35808ee640e87ca7; }, function (v) { return $b34fdf7f3419fa3e$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b34fdf7f3419fa3e$export$fae74005e78b1a27; }, function (v) { return $b34fdf7f3419fa3e$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b34fdf7f3419fa3e$export$dc8fbce3eb94dc1e; }, function (v) { return $b34fdf7f3419fa3e$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b34fdf7f3419fa3e$export$6a7bc4e911dc01cf; }, function (v) { return $b34fdf7f3419fa3e$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b34fdf7f3419fa3e$export$6d9c69b0de29b591; }, function (v) { return $b34fdf7f3419fa3e$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b34fdf7f3419fa3e$export$f680877a34711e37; }, function (v) { return $b34fdf7f3419fa3e$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b34fdf7f3419fa3e$export$d5a552a76deda3c2; }, function (v) { return $b34fdf7f3419fa3e$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b34fdf7f3419fa3e$export$aaabe4eda9ed9969; }, function (v) { return $b34fdf7f3419fa3e$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b34fdf7f3419fa3e$export$e5c5a5f917a5871c; }, function (v) { return $b34fdf7f3419fa3e$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b34fdf7f3419fa3e$export$1538c33de8887b59; }, function (v) { return $b34fdf7f3419fa3e$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b34fdf7f3419fa3e$export$13e3392192263954; }, function (v) { return $b34fdf7f3419fa3e$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b34fdf7f3419fa3e$export$b8f5890fc79d6aca; }, function (v) { return $b34fdf7f3419fa3e$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b34fdf7f3419fa3e$export$60241385465d0a34; }, function (v) { return $b34fdf7f3419fa3e$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b34fdf7f3419fa3e$export$306c0aa65ff9ec16; }, function (v) { return $b34fdf7f3419fa3e$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b34fdf7f3419fa3e$export$7b286972b8d8ccbf; }, function (v) { return $b34fdf7f3419fa3e$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b34fdf7f3419fa3e$export$83d89fbfd8236492; }, function (v) { return $b34fdf7f3419fa3e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b34fdf7f3419fa3e$export$dca3b0875bd9a954;
var $b34fdf7f3419fa3e$export$16fa2f45be04daa8;
var $b34fdf7f3419fa3e$export$ffb0004e005737fa;
var $b34fdf7f3419fa3e$export$e2c29f18771995cb;
var $b34fdf7f3419fa3e$export$221d75b3f55bb0bd;
var $b34fdf7f3419fa3e$export$5f8d39834fd61797;
var $b34fdf7f3419fa3e$export$74bf444e3cd11ea5;
var $b34fdf7f3419fa3e$export$ae55be85d98224ed;
var $b34fdf7f3419fa3e$export$e530037191fcd5d7;
var $b34fdf7f3419fa3e$export$fd42f52fd3ae1109;
var $b34fdf7f3419fa3e$export$c8a8987d4410bf2d;
var $b34fdf7f3419fa3e$export$d38cd72104c1f0e9;
var $b34fdf7f3419fa3e$export$7d1e3a5e95ceca43;
var $b34fdf7f3419fa3e$export$257a8862b851cb5b;
var $b34fdf7f3419fa3e$export$a8257692ac88316c;
var $b34fdf7f3419fa3e$export$488013bae63b21da;
var $b34fdf7f3419fa3e$export$7c73462e0d25e514;
var $b34fdf7f3419fa3e$export$7568632d0d33d16d;
var $b34fdf7f3419fa3e$export$88948ce120ea2619;
var $b34fdf7f3419fa3e$export$35808ee640e87ca7;
var $b34fdf7f3419fa3e$export$fae74005e78b1a27;
var $b34fdf7f3419fa3e$export$dc8fbce3eb94dc1e;
var $b34fdf7f3419fa3e$export$6a7bc4e911dc01cf;
var $b34fdf7f3419fa3e$export$6d9c69b0de29b591;
var $b34fdf7f3419fa3e$export$f680877a34711e37;
var $b34fdf7f3419fa3e$export$d5a552a76deda3c2;
var $b34fdf7f3419fa3e$export$aaabe4eda9ed9969;
var $b34fdf7f3419fa3e$export$e5c5a5f917a5871c;
var $b34fdf7f3419fa3e$export$1538c33de8887b59;
var $b34fdf7f3419fa3e$export$13e3392192263954;
var $b34fdf7f3419fa3e$export$b8f5890fc79d6aca;
var $b34fdf7f3419fa3e$export$60241385465d0a34;
var $b34fdf7f3419fa3e$export$306c0aa65ff9ec16;
var $b34fdf7f3419fa3e$export$7b286972b8d8ccbf;
var $b34fdf7f3419fa3e$export$83d89fbfd8236492;
"use strict";
var $b34fdf7f3419fa3e$var$l = Symbol.for("react.element"), $b34fdf7f3419fa3e$var$n = Symbol.for("react.portal"), $b34fdf7f3419fa3e$var$p = Symbol.for("react.fragment"), $b34fdf7f3419fa3e$var$q = Symbol.for("react.strict_mode"), $b34fdf7f3419fa3e$var$r = Symbol.for("react.profiler"), $b34fdf7f3419fa3e$var$t = Symbol.for("react.provider"), $b34fdf7f3419fa3e$var$u = Symbol.for("react.context"), $b34fdf7f3419fa3e$var$v = Symbol.for("react.forward_ref"), $b34fdf7f3419fa3e$var$w = Symbol.for("react.suspense"), $b34fdf7f3419fa3e$var$x = Symbol.for("react.memo"), $b34fdf7f3419fa3e$var$y = Symbol.for("react.lazy"), $b34fdf7f3419fa3e$var$z = Symbol.iterator;
function $b34fdf7f3419fa3e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b34fdf7f3419fa3e$var$z && a[$b34fdf7f3419fa3e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b34fdf7f3419fa3e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b34fdf7f3419fa3e$var$C = Object.assign, $b34fdf7f3419fa3e$var$D = {};
function $b34fdf7f3419fa3e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b34fdf7f3419fa3e$var$D;
    this.updater = e || $b34fdf7f3419fa3e$var$B;
}
$b34fdf7f3419fa3e$var$E.prototype.isReactComponent = {};
$b34fdf7f3419fa3e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b34fdf7f3419fa3e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b34fdf7f3419fa3e$var$F() {}
$b34fdf7f3419fa3e$var$F.prototype = $b34fdf7f3419fa3e$var$E.prototype;
function $b34fdf7f3419fa3e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b34fdf7f3419fa3e$var$D;
    this.updater = e || $b34fdf7f3419fa3e$var$B;
}
var $b34fdf7f3419fa3e$var$H = $b34fdf7f3419fa3e$var$G.prototype = new $b34fdf7f3419fa3e$var$F;
$b34fdf7f3419fa3e$var$H.constructor = $b34fdf7f3419fa3e$var$G;
$b34fdf7f3419fa3e$var$C($b34fdf7f3419fa3e$var$H, $b34fdf7f3419fa3e$var$E.prototype);
$b34fdf7f3419fa3e$var$H.isPureReactComponent = !0;
var $b34fdf7f3419fa3e$var$I = Array.isArray, $b34fdf7f3419fa3e$var$J = Object.prototype.hasOwnProperty, $b34fdf7f3419fa3e$var$K = {
    current: null
}, $b34fdf7f3419fa3e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b34fdf7f3419fa3e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b34fdf7f3419fa3e$var$J.call(b, d) && !$b34fdf7f3419fa3e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b34fdf7f3419fa3e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b34fdf7f3419fa3e$var$K.current
    };
}
function $b34fdf7f3419fa3e$var$N(a, b) {
    return {
        $$typeof: $b34fdf7f3419fa3e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b34fdf7f3419fa3e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b34fdf7f3419fa3e$var$l;
}
function $b34fdf7f3419fa3e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b34fdf7f3419fa3e$var$P = /\/+/g;
function $b34fdf7f3419fa3e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b34fdf7f3419fa3e$var$escape("" + a.key) : b.toString(36);
}
function $b34fdf7f3419fa3e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b34fdf7f3419fa3e$var$l:
                case $b34fdf7f3419fa3e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b34fdf7f3419fa3e$var$Q(h, 0) : d, $b34fdf7f3419fa3e$var$I(c) ? (e = "", null != a && (e = a.replace($b34fdf7f3419fa3e$var$P, "$&/") + "/"), $b34fdf7f3419fa3e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b34fdf7f3419fa3e$var$O(c) && (c = $b34fdf7f3419fa3e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b34fdf7f3419fa3e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b34fdf7f3419fa3e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b34fdf7f3419fa3e$var$Q(k, g);
        h += $b34fdf7f3419fa3e$var$R(k, b, e, f, c);
    }
    else if (f = $b34fdf7f3419fa3e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b34fdf7f3419fa3e$var$Q(k, g++), h += $b34fdf7f3419fa3e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b34fdf7f3419fa3e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b34fdf7f3419fa3e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b34fdf7f3419fa3e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b34fdf7f3419fa3e$var$U = {
    current: null
}, $b34fdf7f3419fa3e$var$V = {
    transition: null
}, $b34fdf7f3419fa3e$var$W = {
    ReactCurrentDispatcher: $b34fdf7f3419fa3e$var$U,
    ReactCurrentBatchConfig: $b34fdf7f3419fa3e$var$V,
    ReactCurrentOwner: $b34fdf7f3419fa3e$var$K
};
$b34fdf7f3419fa3e$export$dca3b0875bd9a954 = {
    map: $b34fdf7f3419fa3e$var$S,
    forEach: function(a, b, e) {
        $b34fdf7f3419fa3e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b34fdf7f3419fa3e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b34fdf7f3419fa3e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b34fdf7f3419fa3e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b34fdf7f3419fa3e$export$16fa2f45be04daa8 = $b34fdf7f3419fa3e$var$E;
$b34fdf7f3419fa3e$export$ffb0004e005737fa = $b34fdf7f3419fa3e$var$p;
$b34fdf7f3419fa3e$export$e2c29f18771995cb = $b34fdf7f3419fa3e$var$r;
$b34fdf7f3419fa3e$export$221d75b3f55bb0bd = $b34fdf7f3419fa3e$var$G;
$b34fdf7f3419fa3e$export$5f8d39834fd61797 = $b34fdf7f3419fa3e$var$q;
$b34fdf7f3419fa3e$export$74bf444e3cd11ea5 = $b34fdf7f3419fa3e$var$w;
$b34fdf7f3419fa3e$export$ae55be85d98224ed = $b34fdf7f3419fa3e$var$W;
$b34fdf7f3419fa3e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b34fdf7f3419fa3e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b34fdf7f3419fa3e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b34fdf7f3419fa3e$var$J.call(b, f) && !$b34fdf7f3419fa3e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b34fdf7f3419fa3e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b34fdf7f3419fa3e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b34fdf7f3419fa3e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b34fdf7f3419fa3e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b34fdf7f3419fa3e$export$c8a8987d4410bf2d = $b34fdf7f3419fa3e$var$M;
$b34fdf7f3419fa3e$export$d38cd72104c1f0e9 = function(a) {
    var b = $b34fdf7f3419fa3e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b34fdf7f3419fa3e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b34fdf7f3419fa3e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b34fdf7f3419fa3e$var$v,
        render: a
    };
};
$b34fdf7f3419fa3e$export$a8257692ac88316c = $b34fdf7f3419fa3e$var$O;
$b34fdf7f3419fa3e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b34fdf7f3419fa3e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b34fdf7f3419fa3e$var$T
    };
};
$b34fdf7f3419fa3e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b34fdf7f3419fa3e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b34fdf7f3419fa3e$export$7568632d0d33d16d = function(a) {
    var b = $b34fdf7f3419fa3e$var$V.transition;
    $b34fdf7f3419fa3e$var$V.transition = {};
    try {
        a();
    } finally{
        $b34fdf7f3419fa3e$var$V.transition = b;
    }
};
$b34fdf7f3419fa3e$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b34fdf7f3419fa3e$export$35808ee640e87ca7 = function(a, b) {
    return $b34fdf7f3419fa3e$var$U.current.useCallback(a, b);
};
$b34fdf7f3419fa3e$export$fae74005e78b1a27 = function(a) {
    return $b34fdf7f3419fa3e$var$U.current.useContext(a);
};
$b34fdf7f3419fa3e$export$dc8fbce3eb94dc1e = function() {};
$b34fdf7f3419fa3e$export$6a7bc4e911dc01cf = function(a) {
    return $b34fdf7f3419fa3e$var$U.current.useDeferredValue(a);
};
$b34fdf7f3419fa3e$export$6d9c69b0de29b591 = function(a, b) {
    return $b34fdf7f3419fa3e$var$U.current.useEffect(a, b);
};
$b34fdf7f3419fa3e$export$f680877a34711e37 = function() {
    return $b34fdf7f3419fa3e$var$U.current.useId();
};
$b34fdf7f3419fa3e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b34fdf7f3419fa3e$var$U.current.useImperativeHandle(a, b, e);
};
$b34fdf7f3419fa3e$export$aaabe4eda9ed9969 = function(a, b) {
    return $b34fdf7f3419fa3e$var$U.current.useInsertionEffect(a, b);
};
$b34fdf7f3419fa3e$export$e5c5a5f917a5871c = function(a, b) {
    return $b34fdf7f3419fa3e$var$U.current.useLayoutEffect(a, b);
};
$b34fdf7f3419fa3e$export$1538c33de8887b59 = function(a, b) {
    return $b34fdf7f3419fa3e$var$U.current.useMemo(a, b);
};
$b34fdf7f3419fa3e$export$13e3392192263954 = function(a, b, e) {
    return $b34fdf7f3419fa3e$var$U.current.useReducer(a, b, e);
};
$b34fdf7f3419fa3e$export$b8f5890fc79d6aca = function(a) {
    return $b34fdf7f3419fa3e$var$U.current.useRef(a);
};
$b34fdf7f3419fa3e$export$60241385465d0a34 = function(a) {
    return $b34fdf7f3419fa3e$var$U.current.useState(a);
};
$b34fdf7f3419fa3e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b34fdf7f3419fa3e$var$U.current.useSyncExternalStore(a, b, e);
};
$b34fdf7f3419fa3e$export$7b286972b8d8ccbf = function() {
    return $b34fdf7f3419fa3e$var$U.current.useTransition();
};
$b34fdf7f3419fa3e$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("bjEOX", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $83d1223ef65e1cdf$export$ae55be85d98224ed; }, function (v) { return $83d1223ef65e1cdf$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $83d1223ef65e1cdf$export$d39a5bbd09211389; }, function (v) { return $83d1223ef65e1cdf$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $83d1223ef65e1cdf$export$882461b6382ed46c; }, function (v) { return $83d1223ef65e1cdf$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $83d1223ef65e1cdf$export$466bfc07425424d5; }, function (v) { return $83d1223ef65e1cdf$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $83d1223ef65e1cdf$export$cd75ccfd720a3cd4; }, function (v) { return $83d1223ef65e1cdf$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $83d1223ef65e1cdf$export$fa8d919ba61d84db; }, function (v) { return $83d1223ef65e1cdf$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $83d1223ef65e1cdf$export$757ceba2d55c277e; }, function (v) { return $83d1223ef65e1cdf$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $83d1223ef65e1cdf$export$b3890eb0ae9dca99; }, function (v) { return $83d1223ef65e1cdf$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $83d1223ef65e1cdf$export$502457920280e6be; }, function (v) { return $83d1223ef65e1cdf$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $83d1223ef65e1cdf$export$c78a37762a8d58e1; }, function (v) { return $83d1223ef65e1cdf$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $83d1223ef65e1cdf$export$dc54d992c10e8a18; }, function (v) { return $83d1223ef65e1cdf$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $83d1223ef65e1cdf$export$83d89fbfd8236492; }, function (v) { return $83d1223ef65e1cdf$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $83d1223ef65e1cdf$export$ae55be85d98224ed;
var $83d1223ef65e1cdf$export$d39a5bbd09211389;
var $83d1223ef65e1cdf$export$882461b6382ed46c;
var $83d1223ef65e1cdf$export$466bfc07425424d5;
var $83d1223ef65e1cdf$export$cd75ccfd720a3cd4;
var $83d1223ef65e1cdf$export$fa8d919ba61d84db;
var $83d1223ef65e1cdf$export$757ceba2d55c277e;
var $83d1223ef65e1cdf$export$b3890eb0ae9dca99;
var $83d1223ef65e1cdf$export$502457920280e6be;
var $83d1223ef65e1cdf$export$c78a37762a8d58e1;
var $83d1223ef65e1cdf$export$dc54d992c10e8a18;
var $83d1223ef65e1cdf$export$83d89fbfd8236492;
"use strict";

var $6YKZt = parcelRequire("6YKZt");

var $hMJeX = parcelRequire("hMJeX");
function $83d1223ef65e1cdf$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $83d1223ef65e1cdf$var$da = new Set, $83d1223ef65e1cdf$var$ea = {};
function $83d1223ef65e1cdf$var$fa(a, b) {
    $83d1223ef65e1cdf$var$ha(a, b);
    $83d1223ef65e1cdf$var$ha(a + "Capture", b);
}
function $83d1223ef65e1cdf$var$ha(a, b) {
    $83d1223ef65e1cdf$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$83d1223ef65e1cdf$var$da.add(b[a]);
}
var $83d1223ef65e1cdf$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $83d1223ef65e1cdf$var$ja = Object.prototype.hasOwnProperty, $83d1223ef65e1cdf$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $83d1223ef65e1cdf$var$la = {}, $83d1223ef65e1cdf$var$ma = {};
function $83d1223ef65e1cdf$var$oa(a) {
    if ($83d1223ef65e1cdf$var$ja.call($83d1223ef65e1cdf$var$ma, a)) return !0;
    if ($83d1223ef65e1cdf$var$ja.call($83d1223ef65e1cdf$var$la, a)) return !1;
    if ($83d1223ef65e1cdf$var$ka.test(a)) return $83d1223ef65e1cdf$var$ma[a] = !0;
    $83d1223ef65e1cdf$var$la[a] = !0;
    return !1;
}
function $83d1223ef65e1cdf$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $83d1223ef65e1cdf$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $83d1223ef65e1cdf$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $83d1223ef65e1cdf$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $83d1223ef65e1cdf$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $83d1223ef65e1cdf$var$z[b] = new $83d1223ef65e1cdf$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $83d1223ef65e1cdf$var$ra = /[\-:]([a-z])/g;
function $83d1223ef65e1cdf$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($83d1223ef65e1cdf$var$ra, $83d1223ef65e1cdf$var$sa);
    $83d1223ef65e1cdf$var$z[b] = new $83d1223ef65e1cdf$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($83d1223ef65e1cdf$var$ra, $83d1223ef65e1cdf$var$sa);
    $83d1223ef65e1cdf$var$z[b] = new $83d1223ef65e1cdf$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($83d1223ef65e1cdf$var$ra, $83d1223ef65e1cdf$var$sa);
    $83d1223ef65e1cdf$var$z[b] = new $83d1223ef65e1cdf$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$83d1223ef65e1cdf$var$z.xlinkHref = new $83d1223ef65e1cdf$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $83d1223ef65e1cdf$var$z[a] = new $83d1223ef65e1cdf$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $83d1223ef65e1cdf$var$ta(a, b, c, d) {
    var e = $83d1223ef65e1cdf$var$z.hasOwnProperty(b) ? $83d1223ef65e1cdf$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $83d1223ef65e1cdf$var$qa(b, c, e, d) && (c = null), d || null === e ? $83d1223ef65e1cdf$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $83d1223ef65e1cdf$var$ua = $6YKZt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $83d1223ef65e1cdf$var$va = Symbol.for("react.element"), $83d1223ef65e1cdf$var$wa = Symbol.for("react.portal"), $83d1223ef65e1cdf$var$ya = Symbol.for("react.fragment"), $83d1223ef65e1cdf$var$za = Symbol.for("react.strict_mode"), $83d1223ef65e1cdf$var$Aa = Symbol.for("react.profiler"), $83d1223ef65e1cdf$var$Ba = Symbol.for("react.provider"), $83d1223ef65e1cdf$var$Ca = Symbol.for("react.context"), $83d1223ef65e1cdf$var$Da = Symbol.for("react.forward_ref"), $83d1223ef65e1cdf$var$Ea = Symbol.for("react.suspense"), $83d1223ef65e1cdf$var$Fa = Symbol.for("react.suspense_list"), $83d1223ef65e1cdf$var$Ga = Symbol.for("react.memo"), $83d1223ef65e1cdf$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $83d1223ef65e1cdf$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $83d1223ef65e1cdf$var$Ja = Symbol.iterator;
function $83d1223ef65e1cdf$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $83d1223ef65e1cdf$var$Ja && a[$83d1223ef65e1cdf$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $83d1223ef65e1cdf$var$A = Object.assign, $83d1223ef65e1cdf$var$La;
function $83d1223ef65e1cdf$var$Ma(a) {
    if (void 0 === $83d1223ef65e1cdf$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $83d1223ef65e1cdf$var$La = b && b[1] || "";
    }
    return "\n" + $83d1223ef65e1cdf$var$La + a;
}
var $83d1223ef65e1cdf$var$Na = !1;
function $83d1223ef65e1cdf$var$Oa(a, b) {
    if (!a || $83d1223ef65e1cdf$var$Na) return "";
    $83d1223ef65e1cdf$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $83d1223ef65e1cdf$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $83d1223ef65e1cdf$var$Ma(a) : "";
}
function $83d1223ef65e1cdf$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $83d1223ef65e1cdf$var$Ma(a.type);
        case 16:
            return $83d1223ef65e1cdf$var$Ma("Lazy");
        case 13:
            return $83d1223ef65e1cdf$var$Ma("Suspense");
        case 19:
            return $83d1223ef65e1cdf$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $83d1223ef65e1cdf$var$Oa(a.type, !1), a;
        case 11:
            return a = $83d1223ef65e1cdf$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $83d1223ef65e1cdf$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $83d1223ef65e1cdf$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $83d1223ef65e1cdf$var$ya:
            return "Fragment";
        case $83d1223ef65e1cdf$var$wa:
            return "Portal";
        case $83d1223ef65e1cdf$var$Aa:
            return "Profiler";
        case $83d1223ef65e1cdf$var$za:
            return "StrictMode";
        case $83d1223ef65e1cdf$var$Ea:
            return "Suspense";
        case $83d1223ef65e1cdf$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $83d1223ef65e1cdf$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $83d1223ef65e1cdf$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $83d1223ef65e1cdf$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $83d1223ef65e1cdf$var$Ga:
            return b = a.displayName || null, null !== b ? b : $83d1223ef65e1cdf$var$Qa(a.type) || "Memo";
        case $83d1223ef65e1cdf$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $83d1223ef65e1cdf$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $83d1223ef65e1cdf$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $83d1223ef65e1cdf$var$Qa(b);
        case 8:
            return b === $83d1223ef65e1cdf$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $83d1223ef65e1cdf$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $83d1223ef65e1cdf$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $83d1223ef65e1cdf$var$Ua(a) {
    var b = $83d1223ef65e1cdf$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $83d1223ef65e1cdf$var$Va(a) {
    a._valueTracker || (a._valueTracker = $83d1223ef65e1cdf$var$Ua(a));
}
function $83d1223ef65e1cdf$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $83d1223ef65e1cdf$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $83d1223ef65e1cdf$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $83d1223ef65e1cdf$var$Ya(a, b) {
    var c = b.checked;
    return $83d1223ef65e1cdf$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $83d1223ef65e1cdf$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $83d1223ef65e1cdf$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $83d1223ef65e1cdf$var$ab(a, b) {
    b = b.checked;
    null != b && $83d1223ef65e1cdf$var$ta(a, "checked", b, !1);
}
function $83d1223ef65e1cdf$var$bb(a, b) {
    $83d1223ef65e1cdf$var$ab(a, b);
    var c = $83d1223ef65e1cdf$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $83d1223ef65e1cdf$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $83d1223ef65e1cdf$var$cb(a, b.type, $83d1223ef65e1cdf$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $83d1223ef65e1cdf$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $83d1223ef65e1cdf$var$cb(a, b, c) {
    if ("number" !== b || $83d1223ef65e1cdf$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $83d1223ef65e1cdf$var$eb = Array.isArray;
function $83d1223ef65e1cdf$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $83d1223ef65e1cdf$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $83d1223ef65e1cdf$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($83d1223ef65e1cdf$var$p(91));
    return $83d1223ef65e1cdf$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $83d1223ef65e1cdf$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($83d1223ef65e1cdf$var$p(92));
            if ($83d1223ef65e1cdf$var$eb(c)) {
                if (1 < c.length) throw Error($83d1223ef65e1cdf$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $83d1223ef65e1cdf$var$Sa(c)
    };
}
function $83d1223ef65e1cdf$var$ib(a, b) {
    var c = $83d1223ef65e1cdf$var$Sa(b.value), d = $83d1223ef65e1cdf$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $83d1223ef65e1cdf$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $83d1223ef65e1cdf$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $83d1223ef65e1cdf$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $83d1223ef65e1cdf$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $83d1223ef65e1cdf$var$mb, $83d1223ef65e1cdf$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $83d1223ef65e1cdf$var$mb = $83d1223ef65e1cdf$var$mb || document.createElement("div");
        $83d1223ef65e1cdf$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $83d1223ef65e1cdf$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $83d1223ef65e1cdf$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $83d1223ef65e1cdf$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $83d1223ef65e1cdf$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($83d1223ef65e1cdf$var$pb).forEach(function(a) {
    $83d1223ef65e1cdf$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $83d1223ef65e1cdf$var$pb[b] = $83d1223ef65e1cdf$var$pb[a];
    });
});
function $83d1223ef65e1cdf$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $83d1223ef65e1cdf$var$pb.hasOwnProperty(a) && $83d1223ef65e1cdf$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $83d1223ef65e1cdf$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $83d1223ef65e1cdf$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $83d1223ef65e1cdf$var$tb = $83d1223ef65e1cdf$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $83d1223ef65e1cdf$var$ub(a, b) {
    if (b) {
        if ($83d1223ef65e1cdf$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($83d1223ef65e1cdf$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($83d1223ef65e1cdf$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($83d1223ef65e1cdf$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($83d1223ef65e1cdf$var$p(62));
    }
}
function $83d1223ef65e1cdf$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $83d1223ef65e1cdf$var$wb = null;
function $83d1223ef65e1cdf$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $83d1223ef65e1cdf$var$yb = null, $83d1223ef65e1cdf$var$zb = null, $83d1223ef65e1cdf$var$Ab = null;
function $83d1223ef65e1cdf$var$Bb(a) {
    if (a = $83d1223ef65e1cdf$var$Cb(a)) {
        if ("function" !== typeof $83d1223ef65e1cdf$var$yb) throw Error($83d1223ef65e1cdf$var$p(280));
        var b = a.stateNode;
        b && (b = $83d1223ef65e1cdf$var$Db(b), $83d1223ef65e1cdf$var$yb(a.stateNode, a.type, b));
    }
}
function $83d1223ef65e1cdf$var$Eb(a) {
    $83d1223ef65e1cdf$var$zb ? $83d1223ef65e1cdf$var$Ab ? $83d1223ef65e1cdf$var$Ab.push(a) : $83d1223ef65e1cdf$var$Ab = [
        a
    ] : $83d1223ef65e1cdf$var$zb = a;
}
function $83d1223ef65e1cdf$var$Fb() {
    if ($83d1223ef65e1cdf$var$zb) {
        var a = $83d1223ef65e1cdf$var$zb, b = $83d1223ef65e1cdf$var$Ab;
        $83d1223ef65e1cdf$var$Ab = $83d1223ef65e1cdf$var$zb = null;
        $83d1223ef65e1cdf$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$83d1223ef65e1cdf$var$Bb(b[a]);
    }
}
function $83d1223ef65e1cdf$var$Gb(a, b) {
    return a(b);
}
function $83d1223ef65e1cdf$var$Hb() {}
var $83d1223ef65e1cdf$var$Ib = !1;
function $83d1223ef65e1cdf$var$Jb(a, b, c) {
    if ($83d1223ef65e1cdf$var$Ib) return a(b, c);
    $83d1223ef65e1cdf$var$Ib = !0;
    try {
        return $83d1223ef65e1cdf$var$Gb(a, b, c);
    } finally{
        if ($83d1223ef65e1cdf$var$Ib = !1, null !== $83d1223ef65e1cdf$var$zb || null !== $83d1223ef65e1cdf$var$Ab) $83d1223ef65e1cdf$var$Hb(), $83d1223ef65e1cdf$var$Fb();
    }
}
function $83d1223ef65e1cdf$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $83d1223ef65e1cdf$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($83d1223ef65e1cdf$var$p(231, b, typeof c));
    return c;
}
var $83d1223ef65e1cdf$var$Lb = !1;
if ($83d1223ef65e1cdf$var$ia) try {
    var $83d1223ef65e1cdf$var$Mb = {};
    Object.defineProperty($83d1223ef65e1cdf$var$Mb, "passive", {
        get: function() {
            $83d1223ef65e1cdf$var$Lb = !0;
        }
    });
    window.addEventListener("test", $83d1223ef65e1cdf$var$Mb, $83d1223ef65e1cdf$var$Mb);
    window.removeEventListener("test", $83d1223ef65e1cdf$var$Mb, $83d1223ef65e1cdf$var$Mb);
} catch (a) {
    $83d1223ef65e1cdf$var$Lb = !1;
}
function $83d1223ef65e1cdf$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $83d1223ef65e1cdf$var$Ob = !1, $83d1223ef65e1cdf$var$Pb = null, $83d1223ef65e1cdf$var$Qb = !1, $83d1223ef65e1cdf$var$Rb = null, $83d1223ef65e1cdf$var$Sb = {
    onError: function(a) {
        $83d1223ef65e1cdf$var$Ob = !0;
        $83d1223ef65e1cdf$var$Pb = a;
    }
};
function $83d1223ef65e1cdf$var$Tb(a, b, c, d, e, f, g, h, k) {
    $83d1223ef65e1cdf$var$Ob = !1;
    $83d1223ef65e1cdf$var$Pb = null;
    $83d1223ef65e1cdf$var$Nb.apply($83d1223ef65e1cdf$var$Sb, arguments);
}
function $83d1223ef65e1cdf$var$Ub(a, b, c, d, e, f, g, h, k) {
    $83d1223ef65e1cdf$var$Tb.apply(this, arguments);
    if ($83d1223ef65e1cdf$var$Ob) {
        if ($83d1223ef65e1cdf$var$Ob) {
            var l = $83d1223ef65e1cdf$var$Pb;
            $83d1223ef65e1cdf$var$Ob = !1;
            $83d1223ef65e1cdf$var$Pb = null;
        } else throw Error($83d1223ef65e1cdf$var$p(198));
        $83d1223ef65e1cdf$var$Qb || ($83d1223ef65e1cdf$var$Qb = !0, $83d1223ef65e1cdf$var$Rb = l);
    }
}
function $83d1223ef65e1cdf$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $83d1223ef65e1cdf$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $83d1223ef65e1cdf$var$Xb(a) {
    if ($83d1223ef65e1cdf$var$Vb(a) !== a) throw Error($83d1223ef65e1cdf$var$p(188));
}
function $83d1223ef65e1cdf$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $83d1223ef65e1cdf$var$Vb(a);
        if (null === b) throw Error($83d1223ef65e1cdf$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $83d1223ef65e1cdf$var$Xb(e), a;
                if (f === d) return $83d1223ef65e1cdf$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($83d1223ef65e1cdf$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($83d1223ef65e1cdf$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($83d1223ef65e1cdf$var$p(190));
    }
    if (3 !== c.tag) throw Error($83d1223ef65e1cdf$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $83d1223ef65e1cdf$var$Zb(a) {
    a = $83d1223ef65e1cdf$var$Yb(a);
    return null !== a ? $83d1223ef65e1cdf$var$$b(a) : null;
}
function $83d1223ef65e1cdf$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $83d1223ef65e1cdf$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $83d1223ef65e1cdf$var$ac = $hMJeX.unstable_scheduleCallback, $83d1223ef65e1cdf$var$bc = $hMJeX.unstable_cancelCallback, $83d1223ef65e1cdf$var$cc = $hMJeX.unstable_shouldYield, $83d1223ef65e1cdf$var$dc = $hMJeX.unstable_requestPaint, $83d1223ef65e1cdf$var$B = $hMJeX.unstable_now, $83d1223ef65e1cdf$var$ec = $hMJeX.unstable_getCurrentPriorityLevel, $83d1223ef65e1cdf$var$fc = $hMJeX.unstable_ImmediatePriority, $83d1223ef65e1cdf$var$gc = $hMJeX.unstable_UserBlockingPriority, $83d1223ef65e1cdf$var$hc = $hMJeX.unstable_NormalPriority, $83d1223ef65e1cdf$var$ic = $hMJeX.unstable_LowPriority, $83d1223ef65e1cdf$var$jc = $hMJeX.unstable_IdlePriority, $83d1223ef65e1cdf$var$kc = null, $83d1223ef65e1cdf$var$lc = null;
function $83d1223ef65e1cdf$var$mc(a) {
    if ($83d1223ef65e1cdf$var$lc && "function" === typeof $83d1223ef65e1cdf$var$lc.onCommitFiberRoot) try {
        $83d1223ef65e1cdf$var$lc.onCommitFiberRoot($83d1223ef65e1cdf$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $83d1223ef65e1cdf$var$oc = Math.clz32 ? Math.clz32 : $83d1223ef65e1cdf$var$nc, $83d1223ef65e1cdf$var$pc = Math.log, $83d1223ef65e1cdf$var$qc = Math.LN2;
function $83d1223ef65e1cdf$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($83d1223ef65e1cdf$var$pc(a) / $83d1223ef65e1cdf$var$qc | 0) | 0;
}
var $83d1223ef65e1cdf$var$rc = 64, $83d1223ef65e1cdf$var$sc = 4194304;
function $83d1223ef65e1cdf$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $83d1223ef65e1cdf$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $83d1223ef65e1cdf$var$tc(h) : (f &= g, 0 !== f && (d = $83d1223ef65e1cdf$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $83d1223ef65e1cdf$var$tc(g) : 0 !== f && (d = $83d1223ef65e1cdf$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $83d1223ef65e1cdf$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $83d1223ef65e1cdf$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $83d1223ef65e1cdf$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $83d1223ef65e1cdf$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $83d1223ef65e1cdf$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $83d1223ef65e1cdf$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $83d1223ef65e1cdf$var$yc() {
    var a = $83d1223ef65e1cdf$var$rc;
    $83d1223ef65e1cdf$var$rc <<= 1;
    0 === ($83d1223ef65e1cdf$var$rc & 4194240) && ($83d1223ef65e1cdf$var$rc = 64);
    return a;
}
function $83d1223ef65e1cdf$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $83d1223ef65e1cdf$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $83d1223ef65e1cdf$var$oc(b);
    a[b] = c;
}
function $83d1223ef65e1cdf$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $83d1223ef65e1cdf$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $83d1223ef65e1cdf$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $83d1223ef65e1cdf$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $83d1223ef65e1cdf$var$C = 0;
function $83d1223ef65e1cdf$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $83d1223ef65e1cdf$var$Ec, $83d1223ef65e1cdf$var$Fc, $83d1223ef65e1cdf$var$Gc, $83d1223ef65e1cdf$var$Hc, $83d1223ef65e1cdf$var$Ic, $83d1223ef65e1cdf$var$Jc = !1, $83d1223ef65e1cdf$var$Kc = [], $83d1223ef65e1cdf$var$Lc = null, $83d1223ef65e1cdf$var$Mc = null, $83d1223ef65e1cdf$var$Nc = null, $83d1223ef65e1cdf$var$Oc = new Map, $83d1223ef65e1cdf$var$Pc = new Map, $83d1223ef65e1cdf$var$Qc = [], $83d1223ef65e1cdf$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $83d1223ef65e1cdf$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $83d1223ef65e1cdf$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $83d1223ef65e1cdf$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $83d1223ef65e1cdf$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $83d1223ef65e1cdf$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $83d1223ef65e1cdf$var$Pc.delete(b.pointerId);
    }
}
function $83d1223ef65e1cdf$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $83d1223ef65e1cdf$var$Cb(b), null !== b && $83d1223ef65e1cdf$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $83d1223ef65e1cdf$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $83d1223ef65e1cdf$var$Lc = $83d1223ef65e1cdf$var$Tc($83d1223ef65e1cdf$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $83d1223ef65e1cdf$var$Mc = $83d1223ef65e1cdf$var$Tc($83d1223ef65e1cdf$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $83d1223ef65e1cdf$var$Nc = $83d1223ef65e1cdf$var$Tc($83d1223ef65e1cdf$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $83d1223ef65e1cdf$var$Oc.set(f, $83d1223ef65e1cdf$var$Tc($83d1223ef65e1cdf$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $83d1223ef65e1cdf$var$Pc.set(f, $83d1223ef65e1cdf$var$Tc($83d1223ef65e1cdf$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $83d1223ef65e1cdf$var$Vc(a) {
    var b = $83d1223ef65e1cdf$var$Wc(a.target);
    if (null !== b) {
        var c = $83d1223ef65e1cdf$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $83d1223ef65e1cdf$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $83d1223ef65e1cdf$var$Ic(a.priority, function() {
                        $83d1223ef65e1cdf$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $83d1223ef65e1cdf$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $83d1223ef65e1cdf$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $83d1223ef65e1cdf$var$wb = d;
            c.target.dispatchEvent(d);
            $83d1223ef65e1cdf$var$wb = null;
        } else return b = $83d1223ef65e1cdf$var$Cb(c), null !== b && $83d1223ef65e1cdf$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $83d1223ef65e1cdf$var$Zc(a, b, c) {
    $83d1223ef65e1cdf$var$Xc(a) && c.delete(b);
}
function $83d1223ef65e1cdf$var$$c() {
    $83d1223ef65e1cdf$var$Jc = !1;
    null !== $83d1223ef65e1cdf$var$Lc && $83d1223ef65e1cdf$var$Xc($83d1223ef65e1cdf$var$Lc) && ($83d1223ef65e1cdf$var$Lc = null);
    null !== $83d1223ef65e1cdf$var$Mc && $83d1223ef65e1cdf$var$Xc($83d1223ef65e1cdf$var$Mc) && ($83d1223ef65e1cdf$var$Mc = null);
    null !== $83d1223ef65e1cdf$var$Nc && $83d1223ef65e1cdf$var$Xc($83d1223ef65e1cdf$var$Nc) && ($83d1223ef65e1cdf$var$Nc = null);
    $83d1223ef65e1cdf$var$Oc.forEach($83d1223ef65e1cdf$var$Zc);
    $83d1223ef65e1cdf$var$Pc.forEach($83d1223ef65e1cdf$var$Zc);
}
function $83d1223ef65e1cdf$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $83d1223ef65e1cdf$var$Jc || ($83d1223ef65e1cdf$var$Jc = !0, $hMJeX.unstable_scheduleCallback($hMJeX.unstable_NormalPriority, $83d1223ef65e1cdf$var$$c)));
}
function $83d1223ef65e1cdf$var$bd(a) {
    function b(b) {
        return $83d1223ef65e1cdf$var$ad(b, a);
    }
    if (0 < $83d1223ef65e1cdf$var$Kc.length) {
        $83d1223ef65e1cdf$var$ad($83d1223ef65e1cdf$var$Kc[0], a);
        for(var c = 1; c < $83d1223ef65e1cdf$var$Kc.length; c++){
            var d = $83d1223ef65e1cdf$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $83d1223ef65e1cdf$var$Lc && $83d1223ef65e1cdf$var$ad($83d1223ef65e1cdf$var$Lc, a);
    null !== $83d1223ef65e1cdf$var$Mc && $83d1223ef65e1cdf$var$ad($83d1223ef65e1cdf$var$Mc, a);
    null !== $83d1223ef65e1cdf$var$Nc && $83d1223ef65e1cdf$var$ad($83d1223ef65e1cdf$var$Nc, a);
    $83d1223ef65e1cdf$var$Oc.forEach(b);
    $83d1223ef65e1cdf$var$Pc.forEach(b);
    for(c = 0; c < $83d1223ef65e1cdf$var$Qc.length; c++)d = $83d1223ef65e1cdf$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $83d1223ef65e1cdf$var$Qc.length && (c = $83d1223ef65e1cdf$var$Qc[0], null === c.blockedOn);)$83d1223ef65e1cdf$var$Vc(c), null === c.blockedOn && $83d1223ef65e1cdf$var$Qc.shift();
}
var $83d1223ef65e1cdf$var$cd = $83d1223ef65e1cdf$var$ua.ReactCurrentBatchConfig, $83d1223ef65e1cdf$var$dd = !0;
function $83d1223ef65e1cdf$var$ed(a, b, c, d) {
    var e = $83d1223ef65e1cdf$var$C, f = $83d1223ef65e1cdf$var$cd.transition;
    $83d1223ef65e1cdf$var$cd.transition = null;
    try {
        $83d1223ef65e1cdf$var$C = 1, $83d1223ef65e1cdf$var$fd(a, b, c, d);
    } finally{
        $83d1223ef65e1cdf$var$C = e, $83d1223ef65e1cdf$var$cd.transition = f;
    }
}
function $83d1223ef65e1cdf$var$gd(a, b, c, d) {
    var e = $83d1223ef65e1cdf$var$C, f = $83d1223ef65e1cdf$var$cd.transition;
    $83d1223ef65e1cdf$var$cd.transition = null;
    try {
        $83d1223ef65e1cdf$var$C = 4, $83d1223ef65e1cdf$var$fd(a, b, c, d);
    } finally{
        $83d1223ef65e1cdf$var$C = e, $83d1223ef65e1cdf$var$cd.transition = f;
    }
}
function $83d1223ef65e1cdf$var$fd(a, b, c, d) {
    if ($83d1223ef65e1cdf$var$dd) {
        var e = $83d1223ef65e1cdf$var$Yc(a, b, c, d);
        if (null === e) $83d1223ef65e1cdf$var$hd(a, b, d, $83d1223ef65e1cdf$var$id, c), $83d1223ef65e1cdf$var$Sc(a, d);
        else if ($83d1223ef65e1cdf$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($83d1223ef65e1cdf$var$Sc(a, d), b & 4 && -1 < $83d1223ef65e1cdf$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $83d1223ef65e1cdf$var$Cb(e);
                null !== f && $83d1223ef65e1cdf$var$Ec(f);
                f = $83d1223ef65e1cdf$var$Yc(a, b, c, d);
                null === f && $83d1223ef65e1cdf$var$hd(a, b, d, $83d1223ef65e1cdf$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $83d1223ef65e1cdf$var$hd(a, b, d, null, c);
    }
}
var $83d1223ef65e1cdf$var$id = null;
function $83d1223ef65e1cdf$var$Yc(a, b, c, d) {
    $83d1223ef65e1cdf$var$id = null;
    a = $83d1223ef65e1cdf$var$xb(d);
    a = $83d1223ef65e1cdf$var$Wc(a);
    if (null !== a) {
        if (b = $83d1223ef65e1cdf$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $83d1223ef65e1cdf$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $83d1223ef65e1cdf$var$id = a;
    return null;
}
function $83d1223ef65e1cdf$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($83d1223ef65e1cdf$var$ec()){
                case $83d1223ef65e1cdf$var$fc:
                    return 1;
                case $83d1223ef65e1cdf$var$gc:
                    return 4;
                case $83d1223ef65e1cdf$var$hc:
                case $83d1223ef65e1cdf$var$ic:
                    return 16;
                case $83d1223ef65e1cdf$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $83d1223ef65e1cdf$var$kd = null, $83d1223ef65e1cdf$var$ld = null, $83d1223ef65e1cdf$var$md = null;
function $83d1223ef65e1cdf$var$nd() {
    if ($83d1223ef65e1cdf$var$md) return $83d1223ef65e1cdf$var$md;
    var a, b = $83d1223ef65e1cdf$var$ld, c = b.length, d, e = "value" in $83d1223ef65e1cdf$var$kd ? $83d1223ef65e1cdf$var$kd.value : $83d1223ef65e1cdf$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $83d1223ef65e1cdf$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $83d1223ef65e1cdf$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $83d1223ef65e1cdf$var$pd() {
    return !0;
}
function $83d1223ef65e1cdf$var$qd() {
    return !1;
}
function $83d1223ef65e1cdf$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $83d1223ef65e1cdf$var$pd : $83d1223ef65e1cdf$var$qd;
        this.isPropagationStopped = $83d1223ef65e1cdf$var$qd;
        return this;
    }
    $83d1223ef65e1cdf$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $83d1223ef65e1cdf$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $83d1223ef65e1cdf$var$pd);
        },
        persist: function() {},
        isPersistent: $83d1223ef65e1cdf$var$pd
    });
    return b;
}
var $83d1223ef65e1cdf$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $83d1223ef65e1cdf$var$td = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$sd), $83d1223ef65e1cdf$var$ud = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$sd, {
    view: 0,
    detail: 0
}), $83d1223ef65e1cdf$var$vd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$ud), $83d1223ef65e1cdf$var$wd, $83d1223ef65e1cdf$var$xd, $83d1223ef65e1cdf$var$yd, $83d1223ef65e1cdf$var$Ad = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $83d1223ef65e1cdf$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $83d1223ef65e1cdf$var$yd && ($83d1223ef65e1cdf$var$yd && "mousemove" === a.type ? ($83d1223ef65e1cdf$var$wd = a.screenX - $83d1223ef65e1cdf$var$yd.screenX, $83d1223ef65e1cdf$var$xd = a.screenY - $83d1223ef65e1cdf$var$yd.screenY) : $83d1223ef65e1cdf$var$xd = $83d1223ef65e1cdf$var$wd = 0, $83d1223ef65e1cdf$var$yd = a);
        return $83d1223ef65e1cdf$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $83d1223ef65e1cdf$var$xd;
    }
}), $83d1223ef65e1cdf$var$Bd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Ad), $83d1223ef65e1cdf$var$Cd = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$Ad, {
    dataTransfer: 0
}), $83d1223ef65e1cdf$var$Dd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Cd), $83d1223ef65e1cdf$var$Ed = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$ud, {
    relatedTarget: 0
}), $83d1223ef65e1cdf$var$Fd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Ed), $83d1223ef65e1cdf$var$Gd = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $83d1223ef65e1cdf$var$Hd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Gd), $83d1223ef65e1cdf$var$Id = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $83d1223ef65e1cdf$var$Jd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Id), $83d1223ef65e1cdf$var$Kd = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$sd, {
    data: 0
}), $83d1223ef65e1cdf$var$Ld = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Kd), $83d1223ef65e1cdf$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $83d1223ef65e1cdf$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $83d1223ef65e1cdf$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $83d1223ef65e1cdf$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $83d1223ef65e1cdf$var$Od[a]) ? !!b[a] : !1;
}
function $83d1223ef65e1cdf$var$zd() {
    return $83d1223ef65e1cdf$var$Pd;
}
var $83d1223ef65e1cdf$var$Qd = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $83d1223ef65e1cdf$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $83d1223ef65e1cdf$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $83d1223ef65e1cdf$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $83d1223ef65e1cdf$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $83d1223ef65e1cdf$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $83d1223ef65e1cdf$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $83d1223ef65e1cdf$var$Rd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Qd), $83d1223ef65e1cdf$var$Sd = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $83d1223ef65e1cdf$var$Td = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Sd), $83d1223ef65e1cdf$var$Ud = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $83d1223ef65e1cdf$var$zd
}), $83d1223ef65e1cdf$var$Vd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Ud), $83d1223ef65e1cdf$var$Wd = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $83d1223ef65e1cdf$var$Xd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Wd), $83d1223ef65e1cdf$var$Yd = $83d1223ef65e1cdf$var$A({}, $83d1223ef65e1cdf$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $83d1223ef65e1cdf$var$Zd = $83d1223ef65e1cdf$var$rd($83d1223ef65e1cdf$var$Yd), $83d1223ef65e1cdf$var$$d = [
    9,
    13,
    27,
    32
], $83d1223ef65e1cdf$var$ae = $83d1223ef65e1cdf$var$ia && "CompositionEvent" in window, $83d1223ef65e1cdf$var$be = null;
$83d1223ef65e1cdf$var$ia && "documentMode" in document && ($83d1223ef65e1cdf$var$be = document.documentMode);
var $83d1223ef65e1cdf$var$ce = $83d1223ef65e1cdf$var$ia && "TextEvent" in window && !$83d1223ef65e1cdf$var$be, $83d1223ef65e1cdf$var$de = $83d1223ef65e1cdf$var$ia && (!$83d1223ef65e1cdf$var$ae || $83d1223ef65e1cdf$var$be && 8 < $83d1223ef65e1cdf$var$be && 11 >= $83d1223ef65e1cdf$var$be), $83d1223ef65e1cdf$var$ee = String.fromCharCode(32), $83d1223ef65e1cdf$var$fe = !1;
function $83d1223ef65e1cdf$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $83d1223ef65e1cdf$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $83d1223ef65e1cdf$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $83d1223ef65e1cdf$var$ie = !1;
function $83d1223ef65e1cdf$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $83d1223ef65e1cdf$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $83d1223ef65e1cdf$var$fe = !0;
            return $83d1223ef65e1cdf$var$ee;
        case "textInput":
            return a = b.data, a === $83d1223ef65e1cdf$var$ee && $83d1223ef65e1cdf$var$fe ? null : a;
        default:
            return null;
    }
}
function $83d1223ef65e1cdf$var$ke(a, b) {
    if ($83d1223ef65e1cdf$var$ie) return "compositionend" === a || !$83d1223ef65e1cdf$var$ae && $83d1223ef65e1cdf$var$ge(a, b) ? (a = $83d1223ef65e1cdf$var$nd(), $83d1223ef65e1cdf$var$md = $83d1223ef65e1cdf$var$ld = $83d1223ef65e1cdf$var$kd = null, $83d1223ef65e1cdf$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $83d1223ef65e1cdf$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $83d1223ef65e1cdf$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $83d1223ef65e1cdf$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$83d1223ef65e1cdf$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $83d1223ef65e1cdf$var$ne(a, b, c, d) {
    $83d1223ef65e1cdf$var$Eb(d);
    b = $83d1223ef65e1cdf$var$oe(b, "onChange");
    0 < b.length && (c = new $83d1223ef65e1cdf$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $83d1223ef65e1cdf$var$pe = null, $83d1223ef65e1cdf$var$qe = null;
function $83d1223ef65e1cdf$var$re(a) {
    $83d1223ef65e1cdf$var$se(a, 0);
}
function $83d1223ef65e1cdf$var$te(a) {
    var b = $83d1223ef65e1cdf$var$ue(a);
    if ($83d1223ef65e1cdf$var$Wa(b)) return a;
}
function $83d1223ef65e1cdf$var$ve(a, b) {
    if ("change" === a) return b;
}
var $83d1223ef65e1cdf$var$we = !1;
if ($83d1223ef65e1cdf$var$ia) {
    var $83d1223ef65e1cdf$var$xe;
    if ($83d1223ef65e1cdf$var$ia) {
        var $83d1223ef65e1cdf$var$ye = "oninput" in document;
        if (!$83d1223ef65e1cdf$var$ye) {
            var $83d1223ef65e1cdf$var$ze = document.createElement("div");
            $83d1223ef65e1cdf$var$ze.setAttribute("oninput", "return;");
            $83d1223ef65e1cdf$var$ye = "function" === typeof $83d1223ef65e1cdf$var$ze.oninput;
        }
        $83d1223ef65e1cdf$var$xe = $83d1223ef65e1cdf$var$ye;
    } else $83d1223ef65e1cdf$var$xe = !1;
    $83d1223ef65e1cdf$var$we = $83d1223ef65e1cdf$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $83d1223ef65e1cdf$var$Ae() {
    $83d1223ef65e1cdf$var$pe && ($83d1223ef65e1cdf$var$pe.detachEvent("onpropertychange", $83d1223ef65e1cdf$var$Be), $83d1223ef65e1cdf$var$qe = $83d1223ef65e1cdf$var$pe = null);
}
function $83d1223ef65e1cdf$var$Be(a) {
    if ("value" === a.propertyName && $83d1223ef65e1cdf$var$te($83d1223ef65e1cdf$var$qe)) {
        var b = [];
        $83d1223ef65e1cdf$var$ne(b, $83d1223ef65e1cdf$var$qe, a, $83d1223ef65e1cdf$var$xb(a));
        $83d1223ef65e1cdf$var$Jb($83d1223ef65e1cdf$var$re, b);
    }
}
function $83d1223ef65e1cdf$var$Ce(a, b, c) {
    "focusin" === a ? ($83d1223ef65e1cdf$var$Ae(), $83d1223ef65e1cdf$var$pe = b, $83d1223ef65e1cdf$var$qe = c, $83d1223ef65e1cdf$var$pe.attachEvent("onpropertychange", $83d1223ef65e1cdf$var$Be)) : "focusout" === a && $83d1223ef65e1cdf$var$Ae();
}
function $83d1223ef65e1cdf$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $83d1223ef65e1cdf$var$te($83d1223ef65e1cdf$var$qe);
}
function $83d1223ef65e1cdf$var$Ee(a, b) {
    if ("click" === a) return $83d1223ef65e1cdf$var$te(b);
}
function $83d1223ef65e1cdf$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $83d1223ef65e1cdf$var$te(b);
}
function $83d1223ef65e1cdf$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $83d1223ef65e1cdf$var$He = "function" === typeof Object.is ? Object.is : $83d1223ef65e1cdf$var$Ge;
function $83d1223ef65e1cdf$var$Ie(a, b) {
    if ($83d1223ef65e1cdf$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$83d1223ef65e1cdf$var$ja.call(b, e) || !$83d1223ef65e1cdf$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $83d1223ef65e1cdf$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $83d1223ef65e1cdf$var$Ke(a, b) {
    var c = $83d1223ef65e1cdf$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $83d1223ef65e1cdf$var$Je(c);
    }
}
function $83d1223ef65e1cdf$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $83d1223ef65e1cdf$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $83d1223ef65e1cdf$var$Me() {
    for(var a = window, b = $83d1223ef65e1cdf$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $83d1223ef65e1cdf$var$Xa(a.document);
    }
    return b;
}
function $83d1223ef65e1cdf$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $83d1223ef65e1cdf$var$Oe(a) {
    var b = $83d1223ef65e1cdf$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $83d1223ef65e1cdf$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $83d1223ef65e1cdf$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $83d1223ef65e1cdf$var$Ke(c, f);
                var g = $83d1223ef65e1cdf$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $83d1223ef65e1cdf$var$Pe = $83d1223ef65e1cdf$var$ia && "documentMode" in document && 11 >= document.documentMode, $83d1223ef65e1cdf$var$Qe = null, $83d1223ef65e1cdf$var$Re = null, $83d1223ef65e1cdf$var$Se = null, $83d1223ef65e1cdf$var$Te = !1;
function $83d1223ef65e1cdf$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $83d1223ef65e1cdf$var$Te || null == $83d1223ef65e1cdf$var$Qe || $83d1223ef65e1cdf$var$Qe !== $83d1223ef65e1cdf$var$Xa(d) || (d = $83d1223ef65e1cdf$var$Qe, "selectionStart" in d && $83d1223ef65e1cdf$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $83d1223ef65e1cdf$var$Se && $83d1223ef65e1cdf$var$Ie($83d1223ef65e1cdf$var$Se, d) || ($83d1223ef65e1cdf$var$Se = d, d = $83d1223ef65e1cdf$var$oe($83d1223ef65e1cdf$var$Re, "onSelect"), 0 < d.length && (b = new $83d1223ef65e1cdf$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $83d1223ef65e1cdf$var$Qe)));
}
function $83d1223ef65e1cdf$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $83d1223ef65e1cdf$var$We = {
    animationend: $83d1223ef65e1cdf$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $83d1223ef65e1cdf$var$Ve("Animation", "AnimationIteration"),
    animationstart: $83d1223ef65e1cdf$var$Ve("Animation", "AnimationStart"),
    transitionend: $83d1223ef65e1cdf$var$Ve("Transition", "TransitionEnd")
}, $83d1223ef65e1cdf$var$Xe = {}, $83d1223ef65e1cdf$var$Ye = {};
$83d1223ef65e1cdf$var$ia && ($83d1223ef65e1cdf$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $83d1223ef65e1cdf$var$We.animationend.animation, delete $83d1223ef65e1cdf$var$We.animationiteration.animation, delete $83d1223ef65e1cdf$var$We.animationstart.animation), "TransitionEvent" in window || delete $83d1223ef65e1cdf$var$We.transitionend.transition);
function $83d1223ef65e1cdf$var$Ze(a) {
    if ($83d1223ef65e1cdf$var$Xe[a]) return $83d1223ef65e1cdf$var$Xe[a];
    if (!$83d1223ef65e1cdf$var$We[a]) return a;
    var b = $83d1223ef65e1cdf$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $83d1223ef65e1cdf$var$Ye) return $83d1223ef65e1cdf$var$Xe[a] = b[c];
    return a;
}
var $83d1223ef65e1cdf$var$$e = $83d1223ef65e1cdf$var$Ze("animationend"), $83d1223ef65e1cdf$var$af = $83d1223ef65e1cdf$var$Ze("animationiteration"), $83d1223ef65e1cdf$var$bf = $83d1223ef65e1cdf$var$Ze("animationstart"), $83d1223ef65e1cdf$var$cf = $83d1223ef65e1cdf$var$Ze("transitionend"), $83d1223ef65e1cdf$var$df = new Map, $83d1223ef65e1cdf$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $83d1223ef65e1cdf$var$ff(a, b) {
    $83d1223ef65e1cdf$var$df.set(a, b);
    $83d1223ef65e1cdf$var$fa(b, [
        a
    ]);
}
for(var $83d1223ef65e1cdf$var$gf = 0; $83d1223ef65e1cdf$var$gf < $83d1223ef65e1cdf$var$ef.length; $83d1223ef65e1cdf$var$gf++){
    var $83d1223ef65e1cdf$var$hf = $83d1223ef65e1cdf$var$ef[$83d1223ef65e1cdf$var$gf], $83d1223ef65e1cdf$var$jf = $83d1223ef65e1cdf$var$hf.toLowerCase(), $83d1223ef65e1cdf$var$kf = $83d1223ef65e1cdf$var$hf[0].toUpperCase() + $83d1223ef65e1cdf$var$hf.slice(1);
    $83d1223ef65e1cdf$var$ff($83d1223ef65e1cdf$var$jf, "on" + $83d1223ef65e1cdf$var$kf);
}
$83d1223ef65e1cdf$var$ff($83d1223ef65e1cdf$var$$e, "onAnimationEnd");
$83d1223ef65e1cdf$var$ff($83d1223ef65e1cdf$var$af, "onAnimationIteration");
$83d1223ef65e1cdf$var$ff($83d1223ef65e1cdf$var$bf, "onAnimationStart");
$83d1223ef65e1cdf$var$ff("dblclick", "onDoubleClick");
$83d1223ef65e1cdf$var$ff("focusin", "onFocus");
$83d1223ef65e1cdf$var$ff("focusout", "onBlur");
$83d1223ef65e1cdf$var$ff($83d1223ef65e1cdf$var$cf, "onTransitionEnd");
$83d1223ef65e1cdf$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$83d1223ef65e1cdf$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$83d1223ef65e1cdf$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$83d1223ef65e1cdf$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$83d1223ef65e1cdf$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$83d1223ef65e1cdf$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$83d1223ef65e1cdf$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$83d1223ef65e1cdf$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$83d1223ef65e1cdf$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$83d1223ef65e1cdf$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $83d1223ef65e1cdf$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $83d1223ef65e1cdf$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($83d1223ef65e1cdf$var$lf));
function $83d1223ef65e1cdf$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $83d1223ef65e1cdf$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $83d1223ef65e1cdf$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $83d1223ef65e1cdf$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $83d1223ef65e1cdf$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($83d1223ef65e1cdf$var$Qb) throw a = $83d1223ef65e1cdf$var$Rb, $83d1223ef65e1cdf$var$Qb = !1, $83d1223ef65e1cdf$var$Rb = null, a;
}
function $83d1223ef65e1cdf$var$D(a, b) {
    var c = b[$83d1223ef65e1cdf$var$of];
    void 0 === c && (c = b[$83d1223ef65e1cdf$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($83d1223ef65e1cdf$var$pf(b, a, 2, !1), c.add(d));
}
function $83d1223ef65e1cdf$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $83d1223ef65e1cdf$var$pf(c, a, d, b);
}
var $83d1223ef65e1cdf$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $83d1223ef65e1cdf$var$sf(a) {
    if (!a[$83d1223ef65e1cdf$var$rf]) {
        a[$83d1223ef65e1cdf$var$rf] = !0;
        $83d1223ef65e1cdf$var$da.forEach(function(b) {
            "selectionchange" !== b && ($83d1223ef65e1cdf$var$mf.has(b) || $83d1223ef65e1cdf$var$qf(b, !1, a), $83d1223ef65e1cdf$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$83d1223ef65e1cdf$var$rf] || (b[$83d1223ef65e1cdf$var$rf] = !0, $83d1223ef65e1cdf$var$qf("selectionchange", !1, b));
    }
}
function $83d1223ef65e1cdf$var$pf(a, b, c, d) {
    switch($83d1223ef65e1cdf$var$jd(b)){
        case 1:
            var e = $83d1223ef65e1cdf$var$ed;
            break;
        case 4:
            e = $83d1223ef65e1cdf$var$gd;
            break;
        default:
            e = $83d1223ef65e1cdf$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$83d1223ef65e1cdf$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $83d1223ef65e1cdf$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $83d1223ef65e1cdf$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $83d1223ef65e1cdf$var$Jb(function() {
        var d = f, e = $83d1223ef65e1cdf$var$xb(c), g = [];
        a: {
            var h = $83d1223ef65e1cdf$var$df.get(a);
            if (void 0 !== h) {
                var k = $83d1223ef65e1cdf$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $83d1223ef65e1cdf$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $83d1223ef65e1cdf$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $83d1223ef65e1cdf$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $83d1223ef65e1cdf$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $83d1223ef65e1cdf$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $83d1223ef65e1cdf$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $83d1223ef65e1cdf$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $83d1223ef65e1cdf$var$Vd;
                        break;
                    case $83d1223ef65e1cdf$var$$e:
                    case $83d1223ef65e1cdf$var$af:
                    case $83d1223ef65e1cdf$var$bf:
                        k = $83d1223ef65e1cdf$var$Hd;
                        break;
                    case $83d1223ef65e1cdf$var$cf:
                        k = $83d1223ef65e1cdf$var$Xd;
                        break;
                    case "scroll":
                        k = $83d1223ef65e1cdf$var$vd;
                        break;
                    case "wheel":
                        k = $83d1223ef65e1cdf$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $83d1223ef65e1cdf$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $83d1223ef65e1cdf$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $83d1223ef65e1cdf$var$Kb(w, x), null != F && t.push($83d1223ef65e1cdf$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $83d1223ef65e1cdf$var$wb && (n = c.relatedTarget || c.fromElement) && ($83d1223ef65e1cdf$var$Wc(n) || n[$83d1223ef65e1cdf$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $83d1223ef65e1cdf$var$Wc(n) : null, null !== n && (J = $83d1223ef65e1cdf$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $83d1223ef65e1cdf$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $83d1223ef65e1cdf$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $83d1223ef65e1cdf$var$ue(k);
                        u = null == n ? h : $83d1223ef65e1cdf$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $83d1223ef65e1cdf$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $83d1223ef65e1cdf$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $83d1223ef65e1cdf$var$vf(F))u++;
                            for(; 0 < w - u;)t = $83d1223ef65e1cdf$var$vf(t), w--;
                            for(; 0 < u - w;)x = $83d1223ef65e1cdf$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $83d1223ef65e1cdf$var$vf(t);
                                x = $83d1223ef65e1cdf$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $83d1223ef65e1cdf$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $83d1223ef65e1cdf$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $83d1223ef65e1cdf$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $83d1223ef65e1cdf$var$ve;
                else if ($83d1223ef65e1cdf$var$me(h)) {
                    if ($83d1223ef65e1cdf$var$we) na = $83d1223ef65e1cdf$var$Fe;
                    else {
                        na = $83d1223ef65e1cdf$var$De;
                        var xa = $83d1223ef65e1cdf$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $83d1223ef65e1cdf$var$Ee);
                if (na && (na = na(a, d))) {
                    $83d1223ef65e1cdf$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $83d1223ef65e1cdf$var$cb(h, "number", h.value);
            }
            xa = d ? $83d1223ef65e1cdf$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($83d1223ef65e1cdf$var$me(xa) || "true" === xa.contentEditable) $83d1223ef65e1cdf$var$Qe = xa, $83d1223ef65e1cdf$var$Re = d, $83d1223ef65e1cdf$var$Se = null;
                    break;
                case "focusout":
                    $83d1223ef65e1cdf$var$Se = $83d1223ef65e1cdf$var$Re = $83d1223ef65e1cdf$var$Qe = null;
                    break;
                case "mousedown":
                    $83d1223ef65e1cdf$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $83d1223ef65e1cdf$var$Te = !1;
                    $83d1223ef65e1cdf$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($83d1223ef65e1cdf$var$Pe) break;
                case "keydown":
                case "keyup":
                    $83d1223ef65e1cdf$var$Ue(g, c, e);
            }
            var $a;
            if ($83d1223ef65e1cdf$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $83d1223ef65e1cdf$var$ie ? $83d1223ef65e1cdf$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($83d1223ef65e1cdf$var$de && "ko" !== c.locale && ($83d1223ef65e1cdf$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $83d1223ef65e1cdf$var$ie && ($a = $83d1223ef65e1cdf$var$nd()) : ($83d1223ef65e1cdf$var$kd = e, $83d1223ef65e1cdf$var$ld = "value" in $83d1223ef65e1cdf$var$kd ? $83d1223ef65e1cdf$var$kd.value : $83d1223ef65e1cdf$var$kd.textContent, $83d1223ef65e1cdf$var$ie = !0)), xa = $83d1223ef65e1cdf$var$oe(d, ba), 0 < xa.length && (ba = new $83d1223ef65e1cdf$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $83d1223ef65e1cdf$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $83d1223ef65e1cdf$var$ce ? $83d1223ef65e1cdf$var$je(a, c) : $83d1223ef65e1cdf$var$ke(a, c)) d = $83d1223ef65e1cdf$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $83d1223ef65e1cdf$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $83d1223ef65e1cdf$var$se(g, b);
    });
}
function $83d1223ef65e1cdf$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $83d1223ef65e1cdf$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $83d1223ef65e1cdf$var$Kb(a, c), null != f && d.unshift($83d1223ef65e1cdf$var$tf(a, f, e)), f = $83d1223ef65e1cdf$var$Kb(a, b), null != f && d.push($83d1223ef65e1cdf$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $83d1223ef65e1cdf$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $83d1223ef65e1cdf$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $83d1223ef65e1cdf$var$Kb(c, f), null != k && g.unshift($83d1223ef65e1cdf$var$tf(c, k, h))) : e || (k = $83d1223ef65e1cdf$var$Kb(c, f), null != k && g.push($83d1223ef65e1cdf$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $83d1223ef65e1cdf$var$xf = /\r\n?/g, $83d1223ef65e1cdf$var$yf = /\u0000|\uFFFD/g;
function $83d1223ef65e1cdf$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($83d1223ef65e1cdf$var$xf, "\n").replace($83d1223ef65e1cdf$var$yf, "");
}
function $83d1223ef65e1cdf$var$Af(a, b, c) {
    b = $83d1223ef65e1cdf$var$zf(b);
    if ($83d1223ef65e1cdf$var$zf(a) !== b && c) throw Error($83d1223ef65e1cdf$var$p(425));
}
function $83d1223ef65e1cdf$var$Bf() {}
var $83d1223ef65e1cdf$var$Cf = null, $83d1223ef65e1cdf$var$Df = null;
function $83d1223ef65e1cdf$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $83d1223ef65e1cdf$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $83d1223ef65e1cdf$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $83d1223ef65e1cdf$var$Hf = "function" === typeof Promise ? Promise : void 0, $83d1223ef65e1cdf$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $83d1223ef65e1cdf$var$Hf ? function(a) {
    return $83d1223ef65e1cdf$var$Hf.resolve(null).then(a).catch($83d1223ef65e1cdf$var$If);
} : $83d1223ef65e1cdf$var$Ff;
function $83d1223ef65e1cdf$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $83d1223ef65e1cdf$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $83d1223ef65e1cdf$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $83d1223ef65e1cdf$var$bd(b);
}
function $83d1223ef65e1cdf$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $83d1223ef65e1cdf$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $83d1223ef65e1cdf$var$Nf = Math.random().toString(36).slice(2), $83d1223ef65e1cdf$var$Of = "__reactFiber$" + $83d1223ef65e1cdf$var$Nf, $83d1223ef65e1cdf$var$Pf = "__reactProps$" + $83d1223ef65e1cdf$var$Nf, $83d1223ef65e1cdf$var$uf = "__reactContainer$" + $83d1223ef65e1cdf$var$Nf, $83d1223ef65e1cdf$var$of = "__reactEvents$" + $83d1223ef65e1cdf$var$Nf, $83d1223ef65e1cdf$var$Qf = "__reactListeners$" + $83d1223ef65e1cdf$var$Nf, $83d1223ef65e1cdf$var$Rf = "__reactHandles$" + $83d1223ef65e1cdf$var$Nf;
function $83d1223ef65e1cdf$var$Wc(a) {
    var b = a[$83d1223ef65e1cdf$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$83d1223ef65e1cdf$var$uf] || c[$83d1223ef65e1cdf$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $83d1223ef65e1cdf$var$Mf(a); null !== a;){
                if (c = a[$83d1223ef65e1cdf$var$Of]) return c;
                a = $83d1223ef65e1cdf$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $83d1223ef65e1cdf$var$Cb(a) {
    a = a[$83d1223ef65e1cdf$var$Of] || a[$83d1223ef65e1cdf$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $83d1223ef65e1cdf$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($83d1223ef65e1cdf$var$p(33));
}
function $83d1223ef65e1cdf$var$Db(a) {
    return a[$83d1223ef65e1cdf$var$Pf] || null;
}
var $83d1223ef65e1cdf$var$Sf = [], $83d1223ef65e1cdf$var$Tf = -1;
function $83d1223ef65e1cdf$var$Uf(a) {
    return {
        current: a
    };
}
function $83d1223ef65e1cdf$var$E(a) {
    0 > $83d1223ef65e1cdf$var$Tf || (a.current = $83d1223ef65e1cdf$var$Sf[$83d1223ef65e1cdf$var$Tf], $83d1223ef65e1cdf$var$Sf[$83d1223ef65e1cdf$var$Tf] = null, $83d1223ef65e1cdf$var$Tf--);
}
function $83d1223ef65e1cdf$var$G(a, b) {
    $83d1223ef65e1cdf$var$Tf++;
    $83d1223ef65e1cdf$var$Sf[$83d1223ef65e1cdf$var$Tf] = a.current;
    a.current = b;
}
var $83d1223ef65e1cdf$var$Vf = {}, $83d1223ef65e1cdf$var$H = $83d1223ef65e1cdf$var$Uf($83d1223ef65e1cdf$var$Vf), $83d1223ef65e1cdf$var$Wf = $83d1223ef65e1cdf$var$Uf(!1), $83d1223ef65e1cdf$var$Xf = $83d1223ef65e1cdf$var$Vf;
function $83d1223ef65e1cdf$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $83d1223ef65e1cdf$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $83d1223ef65e1cdf$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $83d1223ef65e1cdf$var$$f() {
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Wf);
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$H);
}
function $83d1223ef65e1cdf$var$ag(a, b, c) {
    if ($83d1223ef65e1cdf$var$H.current !== $83d1223ef65e1cdf$var$Vf) throw Error($83d1223ef65e1cdf$var$p(168));
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$H, b);
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Wf, c);
}
function $83d1223ef65e1cdf$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($83d1223ef65e1cdf$var$p(108, $83d1223ef65e1cdf$var$Ra(a) || "Unknown", e));
    return $83d1223ef65e1cdf$var$A({}, c, d);
}
function $83d1223ef65e1cdf$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $83d1223ef65e1cdf$var$Vf;
    $83d1223ef65e1cdf$var$Xf = $83d1223ef65e1cdf$var$H.current;
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$H, a);
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Wf, $83d1223ef65e1cdf$var$Wf.current);
    return !0;
}
function $83d1223ef65e1cdf$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($83d1223ef65e1cdf$var$p(169));
    c ? (a = $83d1223ef65e1cdf$var$bg(a, b, $83d1223ef65e1cdf$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Wf), $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$H), $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$H, a)) : $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Wf);
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Wf, c);
}
var $83d1223ef65e1cdf$var$eg = null, $83d1223ef65e1cdf$var$fg = !1, $83d1223ef65e1cdf$var$gg = !1;
function $83d1223ef65e1cdf$var$hg(a) {
    null === $83d1223ef65e1cdf$var$eg ? $83d1223ef65e1cdf$var$eg = [
        a
    ] : $83d1223ef65e1cdf$var$eg.push(a);
}
function $83d1223ef65e1cdf$var$ig(a) {
    $83d1223ef65e1cdf$var$fg = !0;
    $83d1223ef65e1cdf$var$hg(a);
}
function $83d1223ef65e1cdf$var$jg() {
    if (!$83d1223ef65e1cdf$var$gg && null !== $83d1223ef65e1cdf$var$eg) {
        $83d1223ef65e1cdf$var$gg = !0;
        var a = 0, b = $83d1223ef65e1cdf$var$C;
        try {
            var c = $83d1223ef65e1cdf$var$eg;
            for($83d1223ef65e1cdf$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $83d1223ef65e1cdf$var$eg = null;
            $83d1223ef65e1cdf$var$fg = !1;
        } catch (e) {
            throw null !== $83d1223ef65e1cdf$var$eg && ($83d1223ef65e1cdf$var$eg = $83d1223ef65e1cdf$var$eg.slice(a + 1)), $83d1223ef65e1cdf$var$ac($83d1223ef65e1cdf$var$fc, $83d1223ef65e1cdf$var$jg), e;
        } finally{
            $83d1223ef65e1cdf$var$C = b, $83d1223ef65e1cdf$var$gg = !1;
        }
    }
    return null;
}
var $83d1223ef65e1cdf$var$kg = [], $83d1223ef65e1cdf$var$lg = 0, $83d1223ef65e1cdf$var$mg = null, $83d1223ef65e1cdf$var$ng = 0, $83d1223ef65e1cdf$var$og = [], $83d1223ef65e1cdf$var$pg = 0, $83d1223ef65e1cdf$var$qg = null, $83d1223ef65e1cdf$var$rg = 1, $83d1223ef65e1cdf$var$sg = "";
function $83d1223ef65e1cdf$var$tg(a, b) {
    $83d1223ef65e1cdf$var$kg[$83d1223ef65e1cdf$var$lg++] = $83d1223ef65e1cdf$var$ng;
    $83d1223ef65e1cdf$var$kg[$83d1223ef65e1cdf$var$lg++] = $83d1223ef65e1cdf$var$mg;
    $83d1223ef65e1cdf$var$mg = a;
    $83d1223ef65e1cdf$var$ng = b;
}
function $83d1223ef65e1cdf$var$ug(a, b, c) {
    $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg++] = $83d1223ef65e1cdf$var$rg;
    $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg++] = $83d1223ef65e1cdf$var$sg;
    $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg++] = $83d1223ef65e1cdf$var$qg;
    $83d1223ef65e1cdf$var$qg = a;
    var d = $83d1223ef65e1cdf$var$rg;
    a = $83d1223ef65e1cdf$var$sg;
    var e = 32 - $83d1223ef65e1cdf$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $83d1223ef65e1cdf$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $83d1223ef65e1cdf$var$rg = 1 << 32 - $83d1223ef65e1cdf$var$oc(b) + e | c << e | d;
        $83d1223ef65e1cdf$var$sg = f + a;
    } else $83d1223ef65e1cdf$var$rg = 1 << f | c << e | d, $83d1223ef65e1cdf$var$sg = a;
}
function $83d1223ef65e1cdf$var$vg(a) {
    null !== a.return && ($83d1223ef65e1cdf$var$tg(a, 1), $83d1223ef65e1cdf$var$ug(a, 1, 0));
}
function $83d1223ef65e1cdf$var$wg(a) {
    for(; a === $83d1223ef65e1cdf$var$mg;)$83d1223ef65e1cdf$var$mg = $83d1223ef65e1cdf$var$kg[--$83d1223ef65e1cdf$var$lg], $83d1223ef65e1cdf$var$kg[$83d1223ef65e1cdf$var$lg] = null, $83d1223ef65e1cdf$var$ng = $83d1223ef65e1cdf$var$kg[--$83d1223ef65e1cdf$var$lg], $83d1223ef65e1cdf$var$kg[$83d1223ef65e1cdf$var$lg] = null;
    for(; a === $83d1223ef65e1cdf$var$qg;)$83d1223ef65e1cdf$var$qg = $83d1223ef65e1cdf$var$og[--$83d1223ef65e1cdf$var$pg], $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg] = null, $83d1223ef65e1cdf$var$sg = $83d1223ef65e1cdf$var$og[--$83d1223ef65e1cdf$var$pg], $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg] = null, $83d1223ef65e1cdf$var$rg = $83d1223ef65e1cdf$var$og[--$83d1223ef65e1cdf$var$pg], $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg] = null;
}
var $83d1223ef65e1cdf$var$xg = null, $83d1223ef65e1cdf$var$yg = null, $83d1223ef65e1cdf$var$I = !1, $83d1223ef65e1cdf$var$zg = null;
function $83d1223ef65e1cdf$var$Ag(a, b) {
    var c = $83d1223ef65e1cdf$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $83d1223ef65e1cdf$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $83d1223ef65e1cdf$var$xg = a, $83d1223ef65e1cdf$var$yg = $83d1223ef65e1cdf$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $83d1223ef65e1cdf$var$xg = a, $83d1223ef65e1cdf$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $83d1223ef65e1cdf$var$qg ? {
                id: $83d1223ef65e1cdf$var$rg,
                overflow: $83d1223ef65e1cdf$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $83d1223ef65e1cdf$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $83d1223ef65e1cdf$var$xg = a, $83d1223ef65e1cdf$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $83d1223ef65e1cdf$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $83d1223ef65e1cdf$var$Eg(a) {
    if ($83d1223ef65e1cdf$var$I) {
        var b = $83d1223ef65e1cdf$var$yg;
        if (b) {
            var c = b;
            if (!$83d1223ef65e1cdf$var$Cg(a, b)) {
                if ($83d1223ef65e1cdf$var$Dg(a)) throw Error($83d1223ef65e1cdf$var$p(418));
                b = $83d1223ef65e1cdf$var$Lf(c.nextSibling);
                var d = $83d1223ef65e1cdf$var$xg;
                b && $83d1223ef65e1cdf$var$Cg(a, b) ? $83d1223ef65e1cdf$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $83d1223ef65e1cdf$var$I = !1, $83d1223ef65e1cdf$var$xg = a);
            }
        } else {
            if ($83d1223ef65e1cdf$var$Dg(a)) throw Error($83d1223ef65e1cdf$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $83d1223ef65e1cdf$var$I = !1;
            $83d1223ef65e1cdf$var$xg = a;
        }
    }
}
function $83d1223ef65e1cdf$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $83d1223ef65e1cdf$var$xg = a;
}
function $83d1223ef65e1cdf$var$Gg(a) {
    if (a !== $83d1223ef65e1cdf$var$xg) return !1;
    if (!$83d1223ef65e1cdf$var$I) return $83d1223ef65e1cdf$var$Fg(a), $83d1223ef65e1cdf$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$83d1223ef65e1cdf$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $83d1223ef65e1cdf$var$yg)) {
        if ($83d1223ef65e1cdf$var$Dg(a)) throw $83d1223ef65e1cdf$var$Hg(), Error($83d1223ef65e1cdf$var$p(418));
        for(; b;)$83d1223ef65e1cdf$var$Ag(a, b), b = $83d1223ef65e1cdf$var$Lf(b.nextSibling);
    }
    $83d1223ef65e1cdf$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($83d1223ef65e1cdf$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $83d1223ef65e1cdf$var$yg = $83d1223ef65e1cdf$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $83d1223ef65e1cdf$var$yg = null;
        }
    } else $83d1223ef65e1cdf$var$yg = $83d1223ef65e1cdf$var$xg ? $83d1223ef65e1cdf$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $83d1223ef65e1cdf$var$Hg() {
    for(var a = $83d1223ef65e1cdf$var$yg; a;)a = $83d1223ef65e1cdf$var$Lf(a.nextSibling);
}
function $83d1223ef65e1cdf$var$Ig() {
    $83d1223ef65e1cdf$var$yg = $83d1223ef65e1cdf$var$xg = null;
    $83d1223ef65e1cdf$var$I = !1;
}
function $83d1223ef65e1cdf$var$Jg(a) {
    null === $83d1223ef65e1cdf$var$zg ? $83d1223ef65e1cdf$var$zg = [
        a
    ] : $83d1223ef65e1cdf$var$zg.push(a);
}
var $83d1223ef65e1cdf$var$Kg = $83d1223ef65e1cdf$var$ua.ReactCurrentBatchConfig;
function $83d1223ef65e1cdf$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $83d1223ef65e1cdf$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $83d1223ef65e1cdf$var$Mg = $83d1223ef65e1cdf$var$Uf(null), $83d1223ef65e1cdf$var$Ng = null, $83d1223ef65e1cdf$var$Og = null, $83d1223ef65e1cdf$var$Pg = null;
function $83d1223ef65e1cdf$var$Qg() {
    $83d1223ef65e1cdf$var$Pg = $83d1223ef65e1cdf$var$Og = $83d1223ef65e1cdf$var$Ng = null;
}
function $83d1223ef65e1cdf$var$Rg(a) {
    var b = $83d1223ef65e1cdf$var$Mg.current;
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Mg);
    a._currentValue = b;
}
function $83d1223ef65e1cdf$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $83d1223ef65e1cdf$var$Tg(a, b) {
    $83d1223ef65e1cdf$var$Ng = a;
    $83d1223ef65e1cdf$var$Pg = $83d1223ef65e1cdf$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($83d1223ef65e1cdf$var$Ug = !0), a.firstContext = null);
}
function $83d1223ef65e1cdf$var$Vg(a) {
    var b = a._currentValue;
    if ($83d1223ef65e1cdf$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $83d1223ef65e1cdf$var$Og) {
            if (null === $83d1223ef65e1cdf$var$Ng) throw Error($83d1223ef65e1cdf$var$p(308));
            $83d1223ef65e1cdf$var$Og = a;
            $83d1223ef65e1cdf$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $83d1223ef65e1cdf$var$Og = $83d1223ef65e1cdf$var$Og.next = a;
    }
    return b;
}
var $83d1223ef65e1cdf$var$Wg = null;
function $83d1223ef65e1cdf$var$Xg(a) {
    null === $83d1223ef65e1cdf$var$Wg ? $83d1223ef65e1cdf$var$Wg = [
        a
    ] : $83d1223ef65e1cdf$var$Wg.push(a);
}
function $83d1223ef65e1cdf$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $83d1223ef65e1cdf$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $83d1223ef65e1cdf$var$Zg(a, d);
}
function $83d1223ef65e1cdf$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $83d1223ef65e1cdf$var$$g = !1;
function $83d1223ef65e1cdf$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $83d1223ef65e1cdf$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $83d1223ef65e1cdf$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $83d1223ef65e1cdf$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($83d1223ef65e1cdf$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $83d1223ef65e1cdf$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $83d1223ef65e1cdf$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $83d1223ef65e1cdf$var$Zg(a, c);
}
function $83d1223ef65e1cdf$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $83d1223ef65e1cdf$var$Cc(a, c);
    }
}
function $83d1223ef65e1cdf$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $83d1223ef65e1cdf$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $83d1223ef65e1cdf$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $83d1223ef65e1cdf$var$A({}, q, r);
                            break a;
                        case 2:
                            $83d1223ef65e1cdf$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $83d1223ef65e1cdf$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $83d1223ef65e1cdf$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($83d1223ef65e1cdf$var$p(191, e));
            e.call(d);
        }
    }
}
var $83d1223ef65e1cdf$var$jh = (new $6YKZt.Component).refs;
function $83d1223ef65e1cdf$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $83d1223ef65e1cdf$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $83d1223ef65e1cdf$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $83d1223ef65e1cdf$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $83d1223ef65e1cdf$var$L(), e = $83d1223ef65e1cdf$var$lh(a), f = $83d1223ef65e1cdf$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $83d1223ef65e1cdf$var$dh(a, f, e);
        null !== b && ($83d1223ef65e1cdf$var$mh(b, a, e, d), $83d1223ef65e1cdf$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $83d1223ef65e1cdf$var$L(), e = $83d1223ef65e1cdf$var$lh(a), f = $83d1223ef65e1cdf$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $83d1223ef65e1cdf$var$dh(a, f, e);
        null !== b && ($83d1223ef65e1cdf$var$mh(b, a, e, d), $83d1223ef65e1cdf$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $83d1223ef65e1cdf$var$L(), d = $83d1223ef65e1cdf$var$lh(a), e = $83d1223ef65e1cdf$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $83d1223ef65e1cdf$var$dh(a, e, d);
        null !== b && ($83d1223ef65e1cdf$var$mh(b, a, d, c), $83d1223ef65e1cdf$var$eh(b, a, d));
    }
};
function $83d1223ef65e1cdf$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$83d1223ef65e1cdf$var$Ie(c, d) || !$83d1223ef65e1cdf$var$Ie(e, f) : !0;
}
function $83d1223ef65e1cdf$var$ph(a, b, c) {
    var d = !1, e = $83d1223ef65e1cdf$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $83d1223ef65e1cdf$var$Vg(f) : (e = $83d1223ef65e1cdf$var$Zf(b) ? $83d1223ef65e1cdf$var$Xf : $83d1223ef65e1cdf$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $83d1223ef65e1cdf$var$Yf(a, e) : $83d1223ef65e1cdf$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $83d1223ef65e1cdf$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $83d1223ef65e1cdf$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $83d1223ef65e1cdf$var$nh.enqueueReplaceState(b, b.state, null);
}
function $83d1223ef65e1cdf$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $83d1223ef65e1cdf$var$jh;
    $83d1223ef65e1cdf$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $83d1223ef65e1cdf$var$Vg(f) : (f = $83d1223ef65e1cdf$var$Zf(b) ? $83d1223ef65e1cdf$var$Xf : $83d1223ef65e1cdf$var$H.current, e.context = $83d1223ef65e1cdf$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($83d1223ef65e1cdf$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $83d1223ef65e1cdf$var$nh.enqueueReplaceState(e, e.state, null), $83d1223ef65e1cdf$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $83d1223ef65e1cdf$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($83d1223ef65e1cdf$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($83d1223ef65e1cdf$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $83d1223ef65e1cdf$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($83d1223ef65e1cdf$var$p(284));
        if (!c._owner) throw Error($83d1223ef65e1cdf$var$p(290, a));
    }
    return a;
}
function $83d1223ef65e1cdf$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($83d1223ef65e1cdf$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $83d1223ef65e1cdf$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $83d1223ef65e1cdf$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $83d1223ef65e1cdf$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $83d1223ef65e1cdf$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $83d1223ef65e1cdf$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $83d1223ef65e1cdf$var$Ha && $83d1223ef65e1cdf$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $83d1223ef65e1cdf$var$sh(a, b, c), d.return = a, d;
        d = $83d1223ef65e1cdf$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $83d1223ef65e1cdf$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $83d1223ef65e1cdf$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $83d1223ef65e1cdf$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $83d1223ef65e1cdf$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $83d1223ef65e1cdf$var$va:
                    return c = $83d1223ef65e1cdf$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $83d1223ef65e1cdf$var$sh(a, null, b), c.return = a, c;
                case $83d1223ef65e1cdf$var$wa:
                    return b = $83d1223ef65e1cdf$var$zh(b, a.mode, c), b.return = a, b;
                case $83d1223ef65e1cdf$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($83d1223ef65e1cdf$var$eb(b) || $83d1223ef65e1cdf$var$Ka(b)) return b = $83d1223ef65e1cdf$var$Ah(b, a.mode, c, null), b.return = a, b;
            $83d1223ef65e1cdf$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $83d1223ef65e1cdf$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $83d1223ef65e1cdf$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $83d1223ef65e1cdf$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($83d1223ef65e1cdf$var$eb(c) || $83d1223ef65e1cdf$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $83d1223ef65e1cdf$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $83d1223ef65e1cdf$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $83d1223ef65e1cdf$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $83d1223ef65e1cdf$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($83d1223ef65e1cdf$var$eb(d) || $83d1223ef65e1cdf$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $83d1223ef65e1cdf$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $83d1223ef65e1cdf$var$I && $83d1223ef65e1cdf$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $83d1223ef65e1cdf$var$I && $83d1223ef65e1cdf$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $83d1223ef65e1cdf$var$I && $83d1223ef65e1cdf$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $83d1223ef65e1cdf$var$Ka(h);
        if ("function" !== typeof l) throw Error($83d1223ef65e1cdf$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($83d1223ef65e1cdf$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $83d1223ef65e1cdf$var$I && $83d1223ef65e1cdf$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $83d1223ef65e1cdf$var$I && $83d1223ef65e1cdf$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $83d1223ef65e1cdf$var$I && $83d1223ef65e1cdf$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $83d1223ef65e1cdf$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $83d1223ef65e1cdf$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $83d1223ef65e1cdf$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $83d1223ef65e1cdf$var$Ha && $83d1223ef65e1cdf$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $83d1223ef65e1cdf$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $83d1223ef65e1cdf$var$ya ? (d = $83d1223ef65e1cdf$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $83d1223ef65e1cdf$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $83d1223ef65e1cdf$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $83d1223ef65e1cdf$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $83d1223ef65e1cdf$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $83d1223ef65e1cdf$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($83d1223ef65e1cdf$var$eb(f)) return n(a, d, f, h);
            if ($83d1223ef65e1cdf$var$Ka(f)) return t(a, d, f, h);
            $83d1223ef65e1cdf$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $83d1223ef65e1cdf$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $83d1223ef65e1cdf$var$Bh = $83d1223ef65e1cdf$var$vh(!0), $83d1223ef65e1cdf$var$Ch = $83d1223ef65e1cdf$var$vh(!1), $83d1223ef65e1cdf$var$Dh = {}, $83d1223ef65e1cdf$var$Eh = $83d1223ef65e1cdf$var$Uf($83d1223ef65e1cdf$var$Dh), $83d1223ef65e1cdf$var$Fh = $83d1223ef65e1cdf$var$Uf($83d1223ef65e1cdf$var$Dh), $83d1223ef65e1cdf$var$Gh = $83d1223ef65e1cdf$var$Uf($83d1223ef65e1cdf$var$Dh);
function $83d1223ef65e1cdf$var$Hh(a) {
    if (a === $83d1223ef65e1cdf$var$Dh) throw Error($83d1223ef65e1cdf$var$p(174));
    return a;
}
function $83d1223ef65e1cdf$var$Ih(a, b) {
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Gh, b);
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Fh, a);
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Eh, $83d1223ef65e1cdf$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $83d1223ef65e1cdf$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $83d1223ef65e1cdf$var$lb(b, a);
    }
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Eh);
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Eh, b);
}
function $83d1223ef65e1cdf$var$Jh() {
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Eh);
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Fh);
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Gh);
}
function $83d1223ef65e1cdf$var$Kh(a) {
    $83d1223ef65e1cdf$var$Hh($83d1223ef65e1cdf$var$Gh.current);
    var b = $83d1223ef65e1cdf$var$Hh($83d1223ef65e1cdf$var$Eh.current);
    var c = $83d1223ef65e1cdf$var$lb(b, a.type);
    b !== c && ($83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Fh, a), $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Eh, c));
}
function $83d1223ef65e1cdf$var$Lh(a) {
    $83d1223ef65e1cdf$var$Fh.current === a && ($83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Eh), $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Fh));
}
var $83d1223ef65e1cdf$var$M = $83d1223ef65e1cdf$var$Uf(0);
function $83d1223ef65e1cdf$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $83d1223ef65e1cdf$var$Nh = [];
function $83d1223ef65e1cdf$var$Oh() {
    for(var a = 0; a < $83d1223ef65e1cdf$var$Nh.length; a++)$83d1223ef65e1cdf$var$Nh[a]._workInProgressVersionPrimary = null;
    $83d1223ef65e1cdf$var$Nh.length = 0;
}
var $83d1223ef65e1cdf$var$Ph = $83d1223ef65e1cdf$var$ua.ReactCurrentDispatcher, $83d1223ef65e1cdf$var$Qh = $83d1223ef65e1cdf$var$ua.ReactCurrentBatchConfig, $83d1223ef65e1cdf$var$Rh = 0, $83d1223ef65e1cdf$var$N = null, $83d1223ef65e1cdf$var$O = null, $83d1223ef65e1cdf$var$P = null, $83d1223ef65e1cdf$var$Sh = !1, $83d1223ef65e1cdf$var$Th = !1, $83d1223ef65e1cdf$var$Uh = 0, $83d1223ef65e1cdf$var$Vh = 0;
function $83d1223ef65e1cdf$var$Q() {
    throw Error($83d1223ef65e1cdf$var$p(321));
}
function $83d1223ef65e1cdf$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$83d1223ef65e1cdf$var$He(a[c], b[c])) return !1;
    return !0;
}
function $83d1223ef65e1cdf$var$Xh(a, b, c, d, e, f) {
    $83d1223ef65e1cdf$var$Rh = f;
    $83d1223ef65e1cdf$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $83d1223ef65e1cdf$var$Ph.current = null === a || null === a.memoizedState ? $83d1223ef65e1cdf$var$Yh : $83d1223ef65e1cdf$var$Zh;
    a = c(d, e);
    if ($83d1223ef65e1cdf$var$Th) {
        f = 0;
        do {
            $83d1223ef65e1cdf$var$Th = !1;
            $83d1223ef65e1cdf$var$Uh = 0;
            if (25 <= f) throw Error($83d1223ef65e1cdf$var$p(301));
            f += 1;
            $83d1223ef65e1cdf$var$P = $83d1223ef65e1cdf$var$O = null;
            b.updateQueue = null;
            $83d1223ef65e1cdf$var$Ph.current = $83d1223ef65e1cdf$var$$h;
            a = c(d, e);
        }while ($83d1223ef65e1cdf$var$Th);
    }
    $83d1223ef65e1cdf$var$Ph.current = $83d1223ef65e1cdf$var$ai;
    b = null !== $83d1223ef65e1cdf$var$O && null !== $83d1223ef65e1cdf$var$O.next;
    $83d1223ef65e1cdf$var$Rh = 0;
    $83d1223ef65e1cdf$var$P = $83d1223ef65e1cdf$var$O = $83d1223ef65e1cdf$var$N = null;
    $83d1223ef65e1cdf$var$Sh = !1;
    if (b) throw Error($83d1223ef65e1cdf$var$p(300));
    return a;
}
function $83d1223ef65e1cdf$var$bi() {
    var a = 0 !== $83d1223ef65e1cdf$var$Uh;
    $83d1223ef65e1cdf$var$Uh = 0;
    return a;
}
function $83d1223ef65e1cdf$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $83d1223ef65e1cdf$var$P ? $83d1223ef65e1cdf$var$N.memoizedState = $83d1223ef65e1cdf$var$P = a : $83d1223ef65e1cdf$var$P = $83d1223ef65e1cdf$var$P.next = a;
    return $83d1223ef65e1cdf$var$P;
}
function $83d1223ef65e1cdf$var$di() {
    if (null === $83d1223ef65e1cdf$var$O) {
        var a = $83d1223ef65e1cdf$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $83d1223ef65e1cdf$var$O.next;
    var b = null === $83d1223ef65e1cdf$var$P ? $83d1223ef65e1cdf$var$N.memoizedState : $83d1223ef65e1cdf$var$P.next;
    if (null !== b) $83d1223ef65e1cdf$var$P = b, $83d1223ef65e1cdf$var$O = a;
    else {
        if (null === a) throw Error($83d1223ef65e1cdf$var$p(310));
        $83d1223ef65e1cdf$var$O = a;
        a = {
            memoizedState: $83d1223ef65e1cdf$var$O.memoizedState,
            baseState: $83d1223ef65e1cdf$var$O.baseState,
            baseQueue: $83d1223ef65e1cdf$var$O.baseQueue,
            queue: $83d1223ef65e1cdf$var$O.queue,
            next: null
        };
        null === $83d1223ef65e1cdf$var$P ? $83d1223ef65e1cdf$var$N.memoizedState = $83d1223ef65e1cdf$var$P = a : $83d1223ef65e1cdf$var$P = $83d1223ef65e1cdf$var$P.next = a;
    }
    return $83d1223ef65e1cdf$var$P;
}
function $83d1223ef65e1cdf$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $83d1223ef65e1cdf$var$fi(a) {
    var b = $83d1223ef65e1cdf$var$di(), c = b.queue;
    if (null === c) throw Error($83d1223ef65e1cdf$var$p(311));
    c.lastRenderedReducer = a;
    var d = $83d1223ef65e1cdf$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($83d1223ef65e1cdf$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $83d1223ef65e1cdf$var$N.lanes |= m;
                $83d1223ef65e1cdf$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $83d1223ef65e1cdf$var$He(d, b.memoizedState) || ($83d1223ef65e1cdf$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $83d1223ef65e1cdf$var$N.lanes |= f, $83d1223ef65e1cdf$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $83d1223ef65e1cdf$var$gi(a) {
    var b = $83d1223ef65e1cdf$var$di(), c = b.queue;
    if (null === c) throw Error($83d1223ef65e1cdf$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $83d1223ef65e1cdf$var$He(f, b.memoizedState) || ($83d1223ef65e1cdf$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $83d1223ef65e1cdf$var$hi() {}
function $83d1223ef65e1cdf$var$ii(a, b) {
    var c = $83d1223ef65e1cdf$var$N, d = $83d1223ef65e1cdf$var$di(), e = b(), f = !$83d1223ef65e1cdf$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $83d1223ef65e1cdf$var$Ug = !0);
    d = d.queue;
    $83d1223ef65e1cdf$var$ji($83d1223ef65e1cdf$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $83d1223ef65e1cdf$var$P && $83d1223ef65e1cdf$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $83d1223ef65e1cdf$var$li(9, $83d1223ef65e1cdf$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $83d1223ef65e1cdf$var$R) throw Error($83d1223ef65e1cdf$var$p(349));
        0 !== ($83d1223ef65e1cdf$var$Rh & 30) || $83d1223ef65e1cdf$var$ni(c, b, e);
    }
    return e;
}
function $83d1223ef65e1cdf$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $83d1223ef65e1cdf$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $83d1223ef65e1cdf$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $83d1223ef65e1cdf$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $83d1223ef65e1cdf$var$oi(b) && $83d1223ef65e1cdf$var$pi(a);
}
function $83d1223ef65e1cdf$var$ki(a, b, c) {
    return c(function() {
        $83d1223ef65e1cdf$var$oi(b) && $83d1223ef65e1cdf$var$pi(a);
    });
}
function $83d1223ef65e1cdf$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$83d1223ef65e1cdf$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $83d1223ef65e1cdf$var$pi(a) {
    var b = $83d1223ef65e1cdf$var$Zg(a, 1);
    null !== b && $83d1223ef65e1cdf$var$mh(b, a, 1, -1);
}
function $83d1223ef65e1cdf$var$qi(a) {
    var b = $83d1223ef65e1cdf$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $83d1223ef65e1cdf$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $83d1223ef65e1cdf$var$ri.bind(null, $83d1223ef65e1cdf$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $83d1223ef65e1cdf$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $83d1223ef65e1cdf$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $83d1223ef65e1cdf$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $83d1223ef65e1cdf$var$si() {
    return $83d1223ef65e1cdf$var$di().memoizedState;
}
function $83d1223ef65e1cdf$var$ti(a, b, c, d) {
    var e = $83d1223ef65e1cdf$var$ci();
    $83d1223ef65e1cdf$var$N.flags |= a;
    e.memoizedState = $83d1223ef65e1cdf$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $83d1223ef65e1cdf$var$ui(a, b, c, d) {
    var e = $83d1223ef65e1cdf$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $83d1223ef65e1cdf$var$O) {
        var g = $83d1223ef65e1cdf$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $83d1223ef65e1cdf$var$Wh(d, g.deps)) {
            e.memoizedState = $83d1223ef65e1cdf$var$li(b, c, f, d);
            return;
        }
    }
    $83d1223ef65e1cdf$var$N.flags |= a;
    e.memoizedState = $83d1223ef65e1cdf$var$li(1 | b, c, f, d);
}
function $83d1223ef65e1cdf$var$vi(a, b) {
    return $83d1223ef65e1cdf$var$ti(8390656, 8, a, b);
}
function $83d1223ef65e1cdf$var$ji(a, b) {
    return $83d1223ef65e1cdf$var$ui(2048, 8, a, b);
}
function $83d1223ef65e1cdf$var$wi(a, b) {
    return $83d1223ef65e1cdf$var$ui(4, 2, a, b);
}
function $83d1223ef65e1cdf$var$xi(a, b) {
    return $83d1223ef65e1cdf$var$ui(4, 4, a, b);
}
function $83d1223ef65e1cdf$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $83d1223ef65e1cdf$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $83d1223ef65e1cdf$var$ui(4, 4, $83d1223ef65e1cdf$var$yi.bind(null, b, a), c);
}
function $83d1223ef65e1cdf$var$Ai() {}
function $83d1223ef65e1cdf$var$Bi(a, b) {
    var c = $83d1223ef65e1cdf$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $83d1223ef65e1cdf$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $83d1223ef65e1cdf$var$Ci(a, b) {
    var c = $83d1223ef65e1cdf$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $83d1223ef65e1cdf$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $83d1223ef65e1cdf$var$Di(a, b, c) {
    if (0 === ($83d1223ef65e1cdf$var$Rh & 21)) return a.baseState && (a.baseState = !1, $83d1223ef65e1cdf$var$Ug = !0), a.memoizedState = c;
    $83d1223ef65e1cdf$var$He(c, b) || (c = $83d1223ef65e1cdf$var$yc(), $83d1223ef65e1cdf$var$N.lanes |= c, $83d1223ef65e1cdf$var$hh |= c, a.baseState = !0);
    return b;
}
function $83d1223ef65e1cdf$var$Ei(a, b) {
    var c = $83d1223ef65e1cdf$var$C;
    $83d1223ef65e1cdf$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $83d1223ef65e1cdf$var$Qh.transition;
    $83d1223ef65e1cdf$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $83d1223ef65e1cdf$var$C = c, $83d1223ef65e1cdf$var$Qh.transition = d;
    }
}
function $83d1223ef65e1cdf$var$Fi() {
    return $83d1223ef65e1cdf$var$di().memoizedState;
}
function $83d1223ef65e1cdf$var$Gi(a, b, c) {
    var d = $83d1223ef65e1cdf$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($83d1223ef65e1cdf$var$Hi(a)) $83d1223ef65e1cdf$var$Ii(b, c);
    else if (c = $83d1223ef65e1cdf$var$Yg(a, b, c, d), null !== c) {
        var e = $83d1223ef65e1cdf$var$L();
        $83d1223ef65e1cdf$var$mh(c, a, d, e);
        $83d1223ef65e1cdf$var$Ji(c, b, d);
    }
}
function $83d1223ef65e1cdf$var$ri(a, b, c) {
    var d = $83d1223ef65e1cdf$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($83d1223ef65e1cdf$var$Hi(a)) $83d1223ef65e1cdf$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($83d1223ef65e1cdf$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $83d1223ef65e1cdf$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $83d1223ef65e1cdf$var$Yg(a, b, e, d);
        null !== c && (e = $83d1223ef65e1cdf$var$L(), $83d1223ef65e1cdf$var$mh(c, a, d, e), $83d1223ef65e1cdf$var$Ji(c, b, d));
    }
}
function $83d1223ef65e1cdf$var$Hi(a) {
    var b = a.alternate;
    return a === $83d1223ef65e1cdf$var$N || null !== b && b === $83d1223ef65e1cdf$var$N;
}
function $83d1223ef65e1cdf$var$Ii(a, b) {
    $83d1223ef65e1cdf$var$Th = $83d1223ef65e1cdf$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $83d1223ef65e1cdf$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $83d1223ef65e1cdf$var$Cc(a, c);
    }
}
var $83d1223ef65e1cdf$var$ai = {
    readContext: $83d1223ef65e1cdf$var$Vg,
    useCallback: $83d1223ef65e1cdf$var$Q,
    useContext: $83d1223ef65e1cdf$var$Q,
    useEffect: $83d1223ef65e1cdf$var$Q,
    useImperativeHandle: $83d1223ef65e1cdf$var$Q,
    useInsertionEffect: $83d1223ef65e1cdf$var$Q,
    useLayoutEffect: $83d1223ef65e1cdf$var$Q,
    useMemo: $83d1223ef65e1cdf$var$Q,
    useReducer: $83d1223ef65e1cdf$var$Q,
    useRef: $83d1223ef65e1cdf$var$Q,
    useState: $83d1223ef65e1cdf$var$Q,
    useDebugValue: $83d1223ef65e1cdf$var$Q,
    useDeferredValue: $83d1223ef65e1cdf$var$Q,
    useTransition: $83d1223ef65e1cdf$var$Q,
    useMutableSource: $83d1223ef65e1cdf$var$Q,
    useSyncExternalStore: $83d1223ef65e1cdf$var$Q,
    useId: $83d1223ef65e1cdf$var$Q,
    unstable_isNewReconciler: !1
}, $83d1223ef65e1cdf$var$Yh = {
    readContext: $83d1223ef65e1cdf$var$Vg,
    useCallback: function(a, b) {
        $83d1223ef65e1cdf$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $83d1223ef65e1cdf$var$Vg,
    useEffect: $83d1223ef65e1cdf$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $83d1223ef65e1cdf$var$ti(4194308, 4, $83d1223ef65e1cdf$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $83d1223ef65e1cdf$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $83d1223ef65e1cdf$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $83d1223ef65e1cdf$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $83d1223ef65e1cdf$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $83d1223ef65e1cdf$var$Gi.bind(null, $83d1223ef65e1cdf$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $83d1223ef65e1cdf$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $83d1223ef65e1cdf$var$qi,
    useDebugValue: $83d1223ef65e1cdf$var$Ai,
    useDeferredValue: function(a) {
        return $83d1223ef65e1cdf$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $83d1223ef65e1cdf$var$qi(!1), b = a[0];
        a = $83d1223ef65e1cdf$var$Ei.bind(null, a[1]);
        $83d1223ef65e1cdf$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $83d1223ef65e1cdf$var$N, e = $83d1223ef65e1cdf$var$ci();
        if ($83d1223ef65e1cdf$var$I) {
            if (void 0 === c) throw Error($83d1223ef65e1cdf$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $83d1223ef65e1cdf$var$R) throw Error($83d1223ef65e1cdf$var$p(349));
            0 !== ($83d1223ef65e1cdf$var$Rh & 30) || $83d1223ef65e1cdf$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $83d1223ef65e1cdf$var$vi($83d1223ef65e1cdf$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $83d1223ef65e1cdf$var$li(9, $83d1223ef65e1cdf$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $83d1223ef65e1cdf$var$ci(), b = $83d1223ef65e1cdf$var$R.identifierPrefix;
        if ($83d1223ef65e1cdf$var$I) {
            var c = $83d1223ef65e1cdf$var$sg;
            var d = $83d1223ef65e1cdf$var$rg;
            c = (d & ~(1 << 32 - $83d1223ef65e1cdf$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $83d1223ef65e1cdf$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $83d1223ef65e1cdf$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $83d1223ef65e1cdf$var$Zh = {
    readContext: $83d1223ef65e1cdf$var$Vg,
    useCallback: $83d1223ef65e1cdf$var$Bi,
    useContext: $83d1223ef65e1cdf$var$Vg,
    useEffect: $83d1223ef65e1cdf$var$ji,
    useImperativeHandle: $83d1223ef65e1cdf$var$zi,
    useInsertionEffect: $83d1223ef65e1cdf$var$wi,
    useLayoutEffect: $83d1223ef65e1cdf$var$xi,
    useMemo: $83d1223ef65e1cdf$var$Ci,
    useReducer: $83d1223ef65e1cdf$var$fi,
    useRef: $83d1223ef65e1cdf$var$si,
    useState: function() {
        return $83d1223ef65e1cdf$var$fi($83d1223ef65e1cdf$var$ei);
    },
    useDebugValue: $83d1223ef65e1cdf$var$Ai,
    useDeferredValue: function(a) {
        var b = $83d1223ef65e1cdf$var$di();
        return $83d1223ef65e1cdf$var$Di(b, $83d1223ef65e1cdf$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $83d1223ef65e1cdf$var$fi($83d1223ef65e1cdf$var$ei)[0], b = $83d1223ef65e1cdf$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $83d1223ef65e1cdf$var$hi,
    useSyncExternalStore: $83d1223ef65e1cdf$var$ii,
    useId: $83d1223ef65e1cdf$var$Fi,
    unstable_isNewReconciler: !1
}, $83d1223ef65e1cdf$var$$h = {
    readContext: $83d1223ef65e1cdf$var$Vg,
    useCallback: $83d1223ef65e1cdf$var$Bi,
    useContext: $83d1223ef65e1cdf$var$Vg,
    useEffect: $83d1223ef65e1cdf$var$ji,
    useImperativeHandle: $83d1223ef65e1cdf$var$zi,
    useInsertionEffect: $83d1223ef65e1cdf$var$wi,
    useLayoutEffect: $83d1223ef65e1cdf$var$xi,
    useMemo: $83d1223ef65e1cdf$var$Ci,
    useReducer: $83d1223ef65e1cdf$var$gi,
    useRef: $83d1223ef65e1cdf$var$si,
    useState: function() {
        return $83d1223ef65e1cdf$var$gi($83d1223ef65e1cdf$var$ei);
    },
    useDebugValue: $83d1223ef65e1cdf$var$Ai,
    useDeferredValue: function(a) {
        var b = $83d1223ef65e1cdf$var$di();
        return null === $83d1223ef65e1cdf$var$O ? b.memoizedState = a : $83d1223ef65e1cdf$var$Di(b, $83d1223ef65e1cdf$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $83d1223ef65e1cdf$var$gi($83d1223ef65e1cdf$var$ei)[0], b = $83d1223ef65e1cdf$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $83d1223ef65e1cdf$var$hi,
    useSyncExternalStore: $83d1223ef65e1cdf$var$ii,
    useId: $83d1223ef65e1cdf$var$Fi,
    unstable_isNewReconciler: !1
};
function $83d1223ef65e1cdf$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $83d1223ef65e1cdf$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $83d1223ef65e1cdf$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $83d1223ef65e1cdf$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $83d1223ef65e1cdf$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $83d1223ef65e1cdf$var$Oi(a, b, c) {
    c = $83d1223ef65e1cdf$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $83d1223ef65e1cdf$var$Pi || ($83d1223ef65e1cdf$var$Pi = !0, $83d1223ef65e1cdf$var$Qi = d);
        $83d1223ef65e1cdf$var$Mi(a, b);
    };
    return c;
}
function $83d1223ef65e1cdf$var$Ri(a, b, c) {
    c = $83d1223ef65e1cdf$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $83d1223ef65e1cdf$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $83d1223ef65e1cdf$var$Mi(a, b);
        "function" !== typeof d && (null === $83d1223ef65e1cdf$var$Si ? $83d1223ef65e1cdf$var$Si = new Set([
            this
        ]) : $83d1223ef65e1cdf$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $83d1223ef65e1cdf$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $83d1223ef65e1cdf$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $83d1223ef65e1cdf$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $83d1223ef65e1cdf$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $83d1223ef65e1cdf$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $83d1223ef65e1cdf$var$ch(-1, 1), b.tag = 2, $83d1223ef65e1cdf$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $83d1223ef65e1cdf$var$Xi = $83d1223ef65e1cdf$var$ua.ReactCurrentOwner, $83d1223ef65e1cdf$var$Ug = !1;
function $83d1223ef65e1cdf$var$Yi(a, b, c, d) {
    b.child = null === a ? $83d1223ef65e1cdf$var$Ch(b, null, c, d) : $83d1223ef65e1cdf$var$Bh(b, a.child, c, d);
}
function $83d1223ef65e1cdf$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $83d1223ef65e1cdf$var$Tg(b, e);
    d = $83d1223ef65e1cdf$var$Xh(a, b, c, d, f, e);
    c = $83d1223ef65e1cdf$var$bi();
    if (null !== a && !$83d1223ef65e1cdf$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $83d1223ef65e1cdf$var$$i(a, b, e);
    $83d1223ef65e1cdf$var$I && c && $83d1223ef65e1cdf$var$vg(b);
    b.flags |= 1;
    $83d1223ef65e1cdf$var$Yi(a, b, d, e);
    return b.child;
}
function $83d1223ef65e1cdf$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$83d1223ef65e1cdf$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $83d1223ef65e1cdf$var$cj(a, b, f, d, e);
        a = $83d1223ef65e1cdf$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $83d1223ef65e1cdf$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $83d1223ef65e1cdf$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $83d1223ef65e1cdf$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $83d1223ef65e1cdf$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($83d1223ef65e1cdf$var$Ie(f, d) && a.ref === b.ref) {
            if ($83d1223ef65e1cdf$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($83d1223ef65e1cdf$var$Ug = !0);
            else return b.lanes = a.lanes, $83d1223ef65e1cdf$var$$i(a, b, e);
        }
    }
    return $83d1223ef65e1cdf$var$dj(a, b, c, d, e);
}
function $83d1223ef65e1cdf$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$fj, $83d1223ef65e1cdf$var$gj), $83d1223ef65e1cdf$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$fj, $83d1223ef65e1cdf$var$gj), $83d1223ef65e1cdf$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$fj, $83d1223ef65e1cdf$var$gj);
            $83d1223ef65e1cdf$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$fj, $83d1223ef65e1cdf$var$gj), $83d1223ef65e1cdf$var$gj |= d;
    $83d1223ef65e1cdf$var$Yi(a, b, e, c);
    return b.child;
}
function $83d1223ef65e1cdf$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $83d1223ef65e1cdf$var$dj(a, b, c, d, e) {
    var f = $83d1223ef65e1cdf$var$Zf(c) ? $83d1223ef65e1cdf$var$Xf : $83d1223ef65e1cdf$var$H.current;
    f = $83d1223ef65e1cdf$var$Yf(b, f);
    $83d1223ef65e1cdf$var$Tg(b, e);
    c = $83d1223ef65e1cdf$var$Xh(a, b, c, d, f, e);
    d = $83d1223ef65e1cdf$var$bi();
    if (null !== a && !$83d1223ef65e1cdf$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $83d1223ef65e1cdf$var$$i(a, b, e);
    $83d1223ef65e1cdf$var$I && d && $83d1223ef65e1cdf$var$vg(b);
    b.flags |= 1;
    $83d1223ef65e1cdf$var$Yi(a, b, c, e);
    return b.child;
}
function $83d1223ef65e1cdf$var$ij(a, b, c, d, e) {
    if ($83d1223ef65e1cdf$var$Zf(c)) {
        var f = !0;
        $83d1223ef65e1cdf$var$cg(b);
    } else f = !1;
    $83d1223ef65e1cdf$var$Tg(b, e);
    if (null === b.stateNode) $83d1223ef65e1cdf$var$jj(a, b), $83d1223ef65e1cdf$var$ph(b, c, d), $83d1223ef65e1cdf$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $83d1223ef65e1cdf$var$Vg(l) : (l = $83d1223ef65e1cdf$var$Zf(c) ? $83d1223ef65e1cdf$var$Xf : $83d1223ef65e1cdf$var$H.current, l = $83d1223ef65e1cdf$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $83d1223ef65e1cdf$var$qh(b, g, d, l);
        $83d1223ef65e1cdf$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $83d1223ef65e1cdf$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $83d1223ef65e1cdf$var$Wf.current || $83d1223ef65e1cdf$var$$g ? ("function" === typeof m && ($83d1223ef65e1cdf$var$kh(b, c, m, d), k = b.memoizedState), (h = $83d1223ef65e1cdf$var$$g || $83d1223ef65e1cdf$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $83d1223ef65e1cdf$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $83d1223ef65e1cdf$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $83d1223ef65e1cdf$var$Vg(k) : (k = $83d1223ef65e1cdf$var$Zf(c) ? $83d1223ef65e1cdf$var$Xf : $83d1223ef65e1cdf$var$H.current, k = $83d1223ef65e1cdf$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $83d1223ef65e1cdf$var$qh(b, g, d, k);
        $83d1223ef65e1cdf$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $83d1223ef65e1cdf$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $83d1223ef65e1cdf$var$Wf.current || $83d1223ef65e1cdf$var$$g ? ("function" === typeof y && ($83d1223ef65e1cdf$var$kh(b, c, y, d), n = b.memoizedState), (l = $83d1223ef65e1cdf$var$$g || $83d1223ef65e1cdf$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $83d1223ef65e1cdf$var$kj(a, b, c, d, f, e);
}
function $83d1223ef65e1cdf$var$kj(a, b, c, d, e, f) {
    $83d1223ef65e1cdf$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $83d1223ef65e1cdf$var$dg(b, c, !1), $83d1223ef65e1cdf$var$$i(a, b, f);
    d = b.stateNode;
    $83d1223ef65e1cdf$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $83d1223ef65e1cdf$var$Bh(b, a.child, null, f), b.child = $83d1223ef65e1cdf$var$Bh(b, null, h, f)) : $83d1223ef65e1cdf$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $83d1223ef65e1cdf$var$dg(b, c, !0);
    return b.child;
}
function $83d1223ef65e1cdf$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $83d1223ef65e1cdf$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $83d1223ef65e1cdf$var$ag(a, b.context, !1);
    $83d1223ef65e1cdf$var$Ih(a, b.containerInfo);
}
function $83d1223ef65e1cdf$var$mj(a, b, c, d, e) {
    $83d1223ef65e1cdf$var$Ig();
    $83d1223ef65e1cdf$var$Jg(e);
    b.flags |= 256;
    $83d1223ef65e1cdf$var$Yi(a, b, c, d);
    return b.child;
}
var $83d1223ef65e1cdf$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $83d1223ef65e1cdf$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $83d1223ef65e1cdf$var$pj(a, b, c) {
    var d = b.pendingProps, e = $83d1223ef65e1cdf$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, e & 1);
    if (null === a) {
        $83d1223ef65e1cdf$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $83d1223ef65e1cdf$var$qj(g, d, 0, null), a = $83d1223ef65e1cdf$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $83d1223ef65e1cdf$var$oj(c), b.memoizedState = $83d1223ef65e1cdf$var$nj, a) : $83d1223ef65e1cdf$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $83d1223ef65e1cdf$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $83d1223ef65e1cdf$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $83d1223ef65e1cdf$var$wh(h, f) : (f = $83d1223ef65e1cdf$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $83d1223ef65e1cdf$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $83d1223ef65e1cdf$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $83d1223ef65e1cdf$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $83d1223ef65e1cdf$var$rj(a, b) {
    b = $83d1223ef65e1cdf$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $83d1223ef65e1cdf$var$tj(a, b, c, d) {
    null !== d && $83d1223ef65e1cdf$var$Jg(d);
    $83d1223ef65e1cdf$var$Bh(b, a.child, null, c);
    a = $83d1223ef65e1cdf$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $83d1223ef65e1cdf$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $83d1223ef65e1cdf$var$Li(Error($83d1223ef65e1cdf$var$p(422))), $83d1223ef65e1cdf$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $83d1223ef65e1cdf$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $83d1223ef65e1cdf$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $83d1223ef65e1cdf$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $83d1223ef65e1cdf$var$oj(g);
        b.memoizedState = $83d1223ef65e1cdf$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $83d1223ef65e1cdf$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($83d1223ef65e1cdf$var$p(419));
        d = $83d1223ef65e1cdf$var$Li(f, d, void 0);
        return $83d1223ef65e1cdf$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($83d1223ef65e1cdf$var$Ug || h) {
        d = $83d1223ef65e1cdf$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $83d1223ef65e1cdf$var$Zg(a, e), $83d1223ef65e1cdf$var$mh(d, a, e, -1));
        }
        $83d1223ef65e1cdf$var$uj();
        d = $83d1223ef65e1cdf$var$Li(Error($83d1223ef65e1cdf$var$p(421)));
        return $83d1223ef65e1cdf$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $83d1223ef65e1cdf$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $83d1223ef65e1cdf$var$yg = $83d1223ef65e1cdf$var$Lf(e.nextSibling);
    $83d1223ef65e1cdf$var$xg = b;
    $83d1223ef65e1cdf$var$I = !0;
    $83d1223ef65e1cdf$var$zg = null;
    null !== a && ($83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg++] = $83d1223ef65e1cdf$var$rg, $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg++] = $83d1223ef65e1cdf$var$sg, $83d1223ef65e1cdf$var$og[$83d1223ef65e1cdf$var$pg++] = $83d1223ef65e1cdf$var$qg, $83d1223ef65e1cdf$var$rg = a.id, $83d1223ef65e1cdf$var$sg = a.overflow, $83d1223ef65e1cdf$var$qg = b);
    b = $83d1223ef65e1cdf$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $83d1223ef65e1cdf$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $83d1223ef65e1cdf$var$Sg(a.return, b, c);
}
function $83d1223ef65e1cdf$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $83d1223ef65e1cdf$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $83d1223ef65e1cdf$var$Yi(a, b, d.children, c);
    d = $83d1223ef65e1cdf$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $83d1223ef65e1cdf$var$wj(a, c, b);
            else if (19 === a.tag) $83d1223ef65e1cdf$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $83d1223ef65e1cdf$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $83d1223ef65e1cdf$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $83d1223ef65e1cdf$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $83d1223ef65e1cdf$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $83d1223ef65e1cdf$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $83d1223ef65e1cdf$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $83d1223ef65e1cdf$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $83d1223ef65e1cdf$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($83d1223ef65e1cdf$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $83d1223ef65e1cdf$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $83d1223ef65e1cdf$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $83d1223ef65e1cdf$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $83d1223ef65e1cdf$var$lj(b);
            $83d1223ef65e1cdf$var$Ig();
            break;
        case 5:
            $83d1223ef65e1cdf$var$Kh(b);
            break;
        case 1:
            $83d1223ef65e1cdf$var$Zf(b.type) && $83d1223ef65e1cdf$var$cg(b);
            break;
        case 4:
            $83d1223ef65e1cdf$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, $83d1223ef65e1cdf$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $83d1223ef65e1cdf$var$pj(a, b, c);
                $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, $83d1223ef65e1cdf$var$M.current & 1);
                a = $83d1223ef65e1cdf$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, $83d1223ef65e1cdf$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $83d1223ef65e1cdf$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, $83d1223ef65e1cdf$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $83d1223ef65e1cdf$var$ej(a, b, c);
    }
    return $83d1223ef65e1cdf$var$$i(a, b, c);
}
var $83d1223ef65e1cdf$var$Aj, $83d1223ef65e1cdf$var$Bj, $83d1223ef65e1cdf$var$Cj, $83d1223ef65e1cdf$var$Dj;
$83d1223ef65e1cdf$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$83d1223ef65e1cdf$var$Bj = function() {};
$83d1223ef65e1cdf$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $83d1223ef65e1cdf$var$Hh($83d1223ef65e1cdf$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $83d1223ef65e1cdf$var$Ya(a, e);
                d = $83d1223ef65e1cdf$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $83d1223ef65e1cdf$var$A({}, e, {
                    value: void 0
                });
                d = $83d1223ef65e1cdf$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $83d1223ef65e1cdf$var$gb(a, e);
                d = $83d1223ef65e1cdf$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $83d1223ef65e1cdf$var$Bf);
        }
        $83d1223ef65e1cdf$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($83d1223ef65e1cdf$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($83d1223ef65e1cdf$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $83d1223ef65e1cdf$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$83d1223ef65e1cdf$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $83d1223ef65e1cdf$var$Ej(a, b) {
    if (!$83d1223ef65e1cdf$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $83d1223ef65e1cdf$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $83d1223ef65e1cdf$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $83d1223ef65e1cdf$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $83d1223ef65e1cdf$var$S(b), null;
        case 1:
            return $83d1223ef65e1cdf$var$Zf(b.type) && $83d1223ef65e1cdf$var$$f(), $83d1223ef65e1cdf$var$S(b), null;
        case 3:
            d = b.stateNode;
            $83d1223ef65e1cdf$var$Jh();
            $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Wf);
            $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$H);
            $83d1223ef65e1cdf$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $83d1223ef65e1cdf$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $83d1223ef65e1cdf$var$zg && ($83d1223ef65e1cdf$var$Gj($83d1223ef65e1cdf$var$zg), $83d1223ef65e1cdf$var$zg = null));
            $83d1223ef65e1cdf$var$Bj(a, b);
            $83d1223ef65e1cdf$var$S(b);
            return null;
        case 5:
            $83d1223ef65e1cdf$var$Lh(b);
            var e = $83d1223ef65e1cdf$var$Hh($83d1223ef65e1cdf$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $83d1223ef65e1cdf$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($83d1223ef65e1cdf$var$p(166));
                    $83d1223ef65e1cdf$var$S(b);
                    return null;
                }
                a = $83d1223ef65e1cdf$var$Hh($83d1223ef65e1cdf$var$Eh.current);
                if ($83d1223ef65e1cdf$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$83d1223ef65e1cdf$var$Of] = b;
                    d[$83d1223ef65e1cdf$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $83d1223ef65e1cdf$var$D("cancel", d);
                            $83d1223ef65e1cdf$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $83d1223ef65e1cdf$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $83d1223ef65e1cdf$var$lf.length; e++)$83d1223ef65e1cdf$var$D($83d1223ef65e1cdf$var$lf[e], d);
                            break;
                        case "source":
                            $83d1223ef65e1cdf$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $83d1223ef65e1cdf$var$D("error", d);
                            $83d1223ef65e1cdf$var$D("load", d);
                            break;
                        case "details":
                            $83d1223ef65e1cdf$var$D("toggle", d);
                            break;
                        case "input":
                            $83d1223ef65e1cdf$var$Za(d, f);
                            $83d1223ef65e1cdf$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $83d1223ef65e1cdf$var$D("invalid", d);
                            break;
                        case "textarea":
                            $83d1223ef65e1cdf$var$hb(d, f), $83d1223ef65e1cdf$var$D("invalid", d);
                    }
                    $83d1223ef65e1cdf$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $83d1223ef65e1cdf$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $83d1223ef65e1cdf$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $83d1223ef65e1cdf$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $83d1223ef65e1cdf$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $83d1223ef65e1cdf$var$Va(d);
                            $83d1223ef65e1cdf$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $83d1223ef65e1cdf$var$Va(d);
                            $83d1223ef65e1cdf$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $83d1223ef65e1cdf$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $83d1223ef65e1cdf$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$83d1223ef65e1cdf$var$Of] = b;
                    a[$83d1223ef65e1cdf$var$Pf] = d;
                    $83d1223ef65e1cdf$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $83d1223ef65e1cdf$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $83d1223ef65e1cdf$var$D("cancel", a);
                                $83d1223ef65e1cdf$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $83d1223ef65e1cdf$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $83d1223ef65e1cdf$var$lf.length; e++)$83d1223ef65e1cdf$var$D($83d1223ef65e1cdf$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $83d1223ef65e1cdf$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $83d1223ef65e1cdf$var$D("error", a);
                                $83d1223ef65e1cdf$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $83d1223ef65e1cdf$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $83d1223ef65e1cdf$var$Za(a, d);
                                e = $83d1223ef65e1cdf$var$Ya(a, d);
                                $83d1223ef65e1cdf$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $83d1223ef65e1cdf$var$A({}, d, {
                                    value: void 0
                                });
                                $83d1223ef65e1cdf$var$D("invalid", a);
                                break;
                            case "textarea":
                                $83d1223ef65e1cdf$var$hb(a, d);
                                e = $83d1223ef65e1cdf$var$gb(a, d);
                                $83d1223ef65e1cdf$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $83d1223ef65e1cdf$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $83d1223ef65e1cdf$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $83d1223ef65e1cdf$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $83d1223ef65e1cdf$var$ob(a, k) : "number" === typeof k && $83d1223ef65e1cdf$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($83d1223ef65e1cdf$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $83d1223ef65e1cdf$var$D("scroll", a) : null != k && $83d1223ef65e1cdf$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $83d1223ef65e1cdf$var$Va(a);
                                $83d1223ef65e1cdf$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $83d1223ef65e1cdf$var$Va(a);
                                $83d1223ef65e1cdf$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $83d1223ef65e1cdf$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $83d1223ef65e1cdf$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $83d1223ef65e1cdf$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $83d1223ef65e1cdf$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $83d1223ef65e1cdf$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $83d1223ef65e1cdf$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($83d1223ef65e1cdf$var$p(166));
                c = $83d1223ef65e1cdf$var$Hh($83d1223ef65e1cdf$var$Gh.current);
                $83d1223ef65e1cdf$var$Hh($83d1223ef65e1cdf$var$Eh.current);
                if ($83d1223ef65e1cdf$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$83d1223ef65e1cdf$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $83d1223ef65e1cdf$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $83d1223ef65e1cdf$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $83d1223ef65e1cdf$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$83d1223ef65e1cdf$var$Of] = b, b.stateNode = d;
            }
            $83d1223ef65e1cdf$var$S(b);
            return null;
        case 13:
            $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($83d1223ef65e1cdf$var$I && null !== $83d1223ef65e1cdf$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $83d1223ef65e1cdf$var$Hg(), $83d1223ef65e1cdf$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $83d1223ef65e1cdf$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($83d1223ef65e1cdf$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($83d1223ef65e1cdf$var$p(317));
                        f[$83d1223ef65e1cdf$var$Of] = b;
                    } else $83d1223ef65e1cdf$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $83d1223ef65e1cdf$var$S(b);
                    f = !1;
                } else null !== $83d1223ef65e1cdf$var$zg && ($83d1223ef65e1cdf$var$Gj($83d1223ef65e1cdf$var$zg), $83d1223ef65e1cdf$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($83d1223ef65e1cdf$var$M.current & 1) ? 0 === $83d1223ef65e1cdf$var$T && ($83d1223ef65e1cdf$var$T = 3) : $83d1223ef65e1cdf$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $83d1223ef65e1cdf$var$S(b);
            return null;
        case 4:
            return $83d1223ef65e1cdf$var$Jh(), $83d1223ef65e1cdf$var$Bj(a, b), null === a && $83d1223ef65e1cdf$var$sf(b.stateNode.containerInfo), $83d1223ef65e1cdf$var$S(b), null;
        case 10:
            return $83d1223ef65e1cdf$var$Rg(b.type._context), $83d1223ef65e1cdf$var$S(b), null;
        case 17:
            return $83d1223ef65e1cdf$var$Zf(b.type) && $83d1223ef65e1cdf$var$$f(), $83d1223ef65e1cdf$var$S(b), null;
        case 19:
            $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$M);
            f = b.memoizedState;
            if (null === f) return $83d1223ef65e1cdf$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $83d1223ef65e1cdf$var$Ej(f, !1);
                else {
                    if (0 !== $83d1223ef65e1cdf$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $83d1223ef65e1cdf$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $83d1223ef65e1cdf$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, $83d1223ef65e1cdf$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $83d1223ef65e1cdf$var$B() > $83d1223ef65e1cdf$var$Hj && (b.flags |= 128, d = !0, $83d1223ef65e1cdf$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $83d1223ef65e1cdf$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $83d1223ef65e1cdf$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$83d1223ef65e1cdf$var$I) return $83d1223ef65e1cdf$var$S(b), null;
                    } else 2 * $83d1223ef65e1cdf$var$B() - f.renderingStartTime > $83d1223ef65e1cdf$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $83d1223ef65e1cdf$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $83d1223ef65e1cdf$var$B(), b.sibling = null, c = $83d1223ef65e1cdf$var$M.current, $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$M, d ? c & 1 | 2 : c & 1), b;
            $83d1223ef65e1cdf$var$S(b);
            return null;
        case 22:
        case 23:
            return $83d1223ef65e1cdf$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($83d1223ef65e1cdf$var$gj & 1073741824) && ($83d1223ef65e1cdf$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $83d1223ef65e1cdf$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($83d1223ef65e1cdf$var$p(156, b.tag));
}
function $83d1223ef65e1cdf$var$Jj(a, b) {
    $83d1223ef65e1cdf$var$wg(b);
    switch(b.tag){
        case 1:
            return $83d1223ef65e1cdf$var$Zf(b.type) && $83d1223ef65e1cdf$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $83d1223ef65e1cdf$var$Jh(), $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Wf), $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$H), $83d1223ef65e1cdf$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $83d1223ef65e1cdf$var$Lh(b), null;
        case 13:
            $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($83d1223ef65e1cdf$var$p(340));
                $83d1223ef65e1cdf$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$M), null;
        case 4:
            return $83d1223ef65e1cdf$var$Jh(), null;
        case 10:
            return $83d1223ef65e1cdf$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $83d1223ef65e1cdf$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $83d1223ef65e1cdf$var$Kj = !1, $83d1223ef65e1cdf$var$U = !1, $83d1223ef65e1cdf$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $83d1223ef65e1cdf$var$V = null;
function $83d1223ef65e1cdf$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $83d1223ef65e1cdf$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $83d1223ef65e1cdf$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $83d1223ef65e1cdf$var$W(a, b, d);
    }
}
var $83d1223ef65e1cdf$var$Oj = !1;
function $83d1223ef65e1cdf$var$Pj(a, b) {
    $83d1223ef65e1cdf$var$Cf = $83d1223ef65e1cdf$var$dd;
    a = $83d1223ef65e1cdf$var$Me();
    if ($83d1223ef65e1cdf$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $83d1223ef65e1cdf$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $83d1223ef65e1cdf$var$dd = !1;
    for($83d1223ef65e1cdf$var$V = b; null !== $83d1223ef65e1cdf$var$V;)if (b = $83d1223ef65e1cdf$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $83d1223ef65e1cdf$var$V = a;
    else for(; null !== $83d1223ef65e1cdf$var$V;){
        b = $83d1223ef65e1cdf$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $83d1223ef65e1cdf$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($83d1223ef65e1cdf$var$p(163));
            }
        } catch (F) {
            $83d1223ef65e1cdf$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $83d1223ef65e1cdf$var$V = a;
            break;
        }
        $83d1223ef65e1cdf$var$V = b.return;
    }
    n = $83d1223ef65e1cdf$var$Oj;
    $83d1223ef65e1cdf$var$Oj = !1;
    return n;
}
function $83d1223ef65e1cdf$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $83d1223ef65e1cdf$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $83d1223ef65e1cdf$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $83d1223ef65e1cdf$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $83d1223ef65e1cdf$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $83d1223ef65e1cdf$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$83d1223ef65e1cdf$var$Of], delete b[$83d1223ef65e1cdf$var$Pf], delete b[$83d1223ef65e1cdf$var$of], delete b[$83d1223ef65e1cdf$var$Qf], delete b[$83d1223ef65e1cdf$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $83d1223ef65e1cdf$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $83d1223ef65e1cdf$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $83d1223ef65e1cdf$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $83d1223ef65e1cdf$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $83d1223ef65e1cdf$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($83d1223ef65e1cdf$var$Wj(a, b, c), a = a.sibling; null !== a;)$83d1223ef65e1cdf$var$Wj(a, b, c), a = a.sibling;
}
function $83d1223ef65e1cdf$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($83d1223ef65e1cdf$var$Xj(a, b, c), a = a.sibling; null !== a;)$83d1223ef65e1cdf$var$Xj(a, b, c), a = a.sibling;
}
var $83d1223ef65e1cdf$var$X = null, $83d1223ef65e1cdf$var$Yj = !1;
function $83d1223ef65e1cdf$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$83d1223ef65e1cdf$var$ak(a, b, c), c = c.sibling;
}
function $83d1223ef65e1cdf$var$ak(a, b, c) {
    if ($83d1223ef65e1cdf$var$lc && "function" === typeof $83d1223ef65e1cdf$var$lc.onCommitFiberUnmount) try {
        $83d1223ef65e1cdf$var$lc.onCommitFiberUnmount($83d1223ef65e1cdf$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $83d1223ef65e1cdf$var$U || $83d1223ef65e1cdf$var$Mj(c, b);
        case 6:
            var d = $83d1223ef65e1cdf$var$X, e = $83d1223ef65e1cdf$var$Yj;
            $83d1223ef65e1cdf$var$X = null;
            $83d1223ef65e1cdf$var$Zj(a, b, c);
            $83d1223ef65e1cdf$var$X = d;
            $83d1223ef65e1cdf$var$Yj = e;
            null !== $83d1223ef65e1cdf$var$X && ($83d1223ef65e1cdf$var$Yj ? (a = $83d1223ef65e1cdf$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $83d1223ef65e1cdf$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $83d1223ef65e1cdf$var$X && ($83d1223ef65e1cdf$var$Yj ? (a = $83d1223ef65e1cdf$var$X, c = c.stateNode, 8 === a.nodeType ? $83d1223ef65e1cdf$var$Kf(a.parentNode, c) : 1 === a.nodeType && $83d1223ef65e1cdf$var$Kf(a, c), $83d1223ef65e1cdf$var$bd(a)) : $83d1223ef65e1cdf$var$Kf($83d1223ef65e1cdf$var$X, c.stateNode));
            break;
        case 4:
            d = $83d1223ef65e1cdf$var$X;
            e = $83d1223ef65e1cdf$var$Yj;
            $83d1223ef65e1cdf$var$X = c.stateNode.containerInfo;
            $83d1223ef65e1cdf$var$Yj = !0;
            $83d1223ef65e1cdf$var$Zj(a, b, c);
            $83d1223ef65e1cdf$var$X = d;
            $83d1223ef65e1cdf$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$83d1223ef65e1cdf$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $83d1223ef65e1cdf$var$Nj(c, b, g) : 0 !== (f & 4) && $83d1223ef65e1cdf$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $83d1223ef65e1cdf$var$Zj(a, b, c);
            break;
        case 1:
            if (!$83d1223ef65e1cdf$var$U && ($83d1223ef65e1cdf$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $83d1223ef65e1cdf$var$W(c, b, h);
            }
            $83d1223ef65e1cdf$var$Zj(a, b, c);
            break;
        case 21:
            $83d1223ef65e1cdf$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($83d1223ef65e1cdf$var$U = (d = $83d1223ef65e1cdf$var$U) || null !== c.memoizedState, $83d1223ef65e1cdf$var$Zj(a, b, c), $83d1223ef65e1cdf$var$U = d) : $83d1223ef65e1cdf$var$Zj(a, b, c);
            break;
        default:
            $83d1223ef65e1cdf$var$Zj(a, b, c);
    }
}
function $83d1223ef65e1cdf$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $83d1223ef65e1cdf$var$Lj);
        b.forEach(function(b) {
            var d = $83d1223ef65e1cdf$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $83d1223ef65e1cdf$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $83d1223ef65e1cdf$var$X = h.stateNode;
                        $83d1223ef65e1cdf$var$Yj = !1;
                        break a;
                    case 3:
                        $83d1223ef65e1cdf$var$X = h.stateNode.containerInfo;
                        $83d1223ef65e1cdf$var$Yj = !0;
                        break a;
                    case 4:
                        $83d1223ef65e1cdf$var$X = h.stateNode.containerInfo;
                        $83d1223ef65e1cdf$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $83d1223ef65e1cdf$var$X) throw Error($83d1223ef65e1cdf$var$p(160));
            $83d1223ef65e1cdf$var$ak(f, g, e);
            $83d1223ef65e1cdf$var$X = null;
            $83d1223ef65e1cdf$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $83d1223ef65e1cdf$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$83d1223ef65e1cdf$var$ek(b, a), b = b.sibling;
}
function $83d1223ef65e1cdf$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            if (d & 4) {
                try {
                    $83d1223ef65e1cdf$var$Qj(3, a, a.return), $83d1223ef65e1cdf$var$Rj(3, a);
                } catch (t) {
                    $83d1223ef65e1cdf$var$W(a, a.return, t);
                }
                try {
                    $83d1223ef65e1cdf$var$Qj(5, a, a.return);
                } catch (t) {
                    $83d1223ef65e1cdf$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            d & 512 && null !== c && $83d1223ef65e1cdf$var$Mj(c, c.return);
            break;
        case 5:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            d & 512 && null !== c && $83d1223ef65e1cdf$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $83d1223ef65e1cdf$var$ob(e, "");
                } catch (t) {
                    $83d1223ef65e1cdf$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $83d1223ef65e1cdf$var$ab(e, f);
                    $83d1223ef65e1cdf$var$vb(h, g);
                    var l = $83d1223ef65e1cdf$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $83d1223ef65e1cdf$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $83d1223ef65e1cdf$var$nb(e, q) : "children" === m ? $83d1223ef65e1cdf$var$ob(e, q) : $83d1223ef65e1cdf$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $83d1223ef65e1cdf$var$bb(e, f);
                            break;
                        case "textarea":
                            $83d1223ef65e1cdf$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $83d1223ef65e1cdf$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $83d1223ef65e1cdf$var$fb(e, !!f.multiple, f.defaultValue, !0) : $83d1223ef65e1cdf$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$83d1223ef65e1cdf$var$Pf] = f;
                } catch (t) {
                    $83d1223ef65e1cdf$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($83d1223ef65e1cdf$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $83d1223ef65e1cdf$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $83d1223ef65e1cdf$var$bd(b.containerInfo);
            } catch (t) {
                $83d1223ef65e1cdf$var$W(a, a.return, t);
            }
            break;
        case 4:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            break;
        case 13:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($83d1223ef65e1cdf$var$gk = $83d1223ef65e1cdf$var$B()));
            d & 4 && $83d1223ef65e1cdf$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($83d1223ef65e1cdf$var$U = (l = $83d1223ef65e1cdf$var$U) || m, $83d1223ef65e1cdf$var$dk(b, a), $83d1223ef65e1cdf$var$U = l) : $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($83d1223ef65e1cdf$var$V = a, m = a.child; null !== m;){
                    for(q = $83d1223ef65e1cdf$var$V = m; null !== $83d1223ef65e1cdf$var$V;){
                        r = $83d1223ef65e1cdf$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $83d1223ef65e1cdf$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $83d1223ef65e1cdf$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $83d1223ef65e1cdf$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $83d1223ef65e1cdf$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $83d1223ef65e1cdf$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $83d1223ef65e1cdf$var$V = y) : $83d1223ef65e1cdf$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $83d1223ef65e1cdf$var$rb("display", g));
                            } catch (t) {
                                $83d1223ef65e1cdf$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $83d1223ef65e1cdf$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $83d1223ef65e1cdf$var$dk(b, a);
            $83d1223ef65e1cdf$var$fk(a);
            d & 4 && $83d1223ef65e1cdf$var$bk(a);
            break;
        case 21:
            break;
        default:
            $83d1223ef65e1cdf$var$dk(b, a), $83d1223ef65e1cdf$var$fk(a);
    }
}
function $83d1223ef65e1cdf$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($83d1223ef65e1cdf$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($83d1223ef65e1cdf$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($83d1223ef65e1cdf$var$ob(e, ""), d.flags &= -33);
                    var f = $83d1223ef65e1cdf$var$Vj(a);
                    $83d1223ef65e1cdf$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $83d1223ef65e1cdf$var$Vj(a);
                    $83d1223ef65e1cdf$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($83d1223ef65e1cdf$var$p(161));
            }
        } catch (k) {
            $83d1223ef65e1cdf$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $83d1223ef65e1cdf$var$ik(a, b, c) {
    $83d1223ef65e1cdf$var$V = a;
    $83d1223ef65e1cdf$var$jk(a, b, c);
}
function $83d1223ef65e1cdf$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $83d1223ef65e1cdf$var$V;){
        var e = $83d1223ef65e1cdf$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $83d1223ef65e1cdf$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $83d1223ef65e1cdf$var$U;
                h = $83d1223ef65e1cdf$var$Kj;
                var l = $83d1223ef65e1cdf$var$U;
                $83d1223ef65e1cdf$var$Kj = g;
                if (($83d1223ef65e1cdf$var$U = k) && !l) for($83d1223ef65e1cdf$var$V = e; null !== $83d1223ef65e1cdf$var$V;)g = $83d1223ef65e1cdf$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $83d1223ef65e1cdf$var$kk(e) : null !== k ? (k.return = g, $83d1223ef65e1cdf$var$V = k) : $83d1223ef65e1cdf$var$kk(e);
                for(; null !== f;)$83d1223ef65e1cdf$var$V = f, $83d1223ef65e1cdf$var$jk(f, b, c), f = f.sibling;
                $83d1223ef65e1cdf$var$V = e;
                $83d1223ef65e1cdf$var$Kj = h;
                $83d1223ef65e1cdf$var$U = l;
            }
            $83d1223ef65e1cdf$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $83d1223ef65e1cdf$var$V = f) : $83d1223ef65e1cdf$var$lk(a, b, c);
    }
}
function $83d1223ef65e1cdf$var$lk(a) {
    for(; null !== $83d1223ef65e1cdf$var$V;){
        var b = $83d1223ef65e1cdf$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $83d1223ef65e1cdf$var$U || $83d1223ef65e1cdf$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$83d1223ef65e1cdf$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $83d1223ef65e1cdf$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $83d1223ef65e1cdf$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $83d1223ef65e1cdf$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $83d1223ef65e1cdf$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($83d1223ef65e1cdf$var$p(163));
                }
                $83d1223ef65e1cdf$var$U || b.flags & 512 && $83d1223ef65e1cdf$var$Sj(b);
            } catch (r) {
                $83d1223ef65e1cdf$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $83d1223ef65e1cdf$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $83d1223ef65e1cdf$var$V = c;
            break;
        }
        $83d1223ef65e1cdf$var$V = b.return;
    }
}
function $83d1223ef65e1cdf$var$hk(a) {
    for(; null !== $83d1223ef65e1cdf$var$V;){
        var b = $83d1223ef65e1cdf$var$V;
        if (b === a) {
            $83d1223ef65e1cdf$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $83d1223ef65e1cdf$var$V = c;
            break;
        }
        $83d1223ef65e1cdf$var$V = b.return;
    }
}
function $83d1223ef65e1cdf$var$kk(a) {
    for(; null !== $83d1223ef65e1cdf$var$V;){
        var b = $83d1223ef65e1cdf$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $83d1223ef65e1cdf$var$Rj(4, b);
                    } catch (k) {
                        $83d1223ef65e1cdf$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $83d1223ef65e1cdf$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $83d1223ef65e1cdf$var$Sj(b);
                    } catch (k) {
                        $83d1223ef65e1cdf$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $83d1223ef65e1cdf$var$Sj(b);
                    } catch (k) {
                        $83d1223ef65e1cdf$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $83d1223ef65e1cdf$var$W(b, b.return, k);
        }
        if (b === a) {
            $83d1223ef65e1cdf$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $83d1223ef65e1cdf$var$V = h;
            break;
        }
        $83d1223ef65e1cdf$var$V = b.return;
    }
}
var $83d1223ef65e1cdf$var$mk = Math.ceil, $83d1223ef65e1cdf$var$nk = $83d1223ef65e1cdf$var$ua.ReactCurrentDispatcher, $83d1223ef65e1cdf$var$ok = $83d1223ef65e1cdf$var$ua.ReactCurrentOwner, $83d1223ef65e1cdf$var$pk = $83d1223ef65e1cdf$var$ua.ReactCurrentBatchConfig, $83d1223ef65e1cdf$var$K = 0, $83d1223ef65e1cdf$var$R = null, $83d1223ef65e1cdf$var$Y = null, $83d1223ef65e1cdf$var$Z = 0, $83d1223ef65e1cdf$var$gj = 0, $83d1223ef65e1cdf$var$fj = $83d1223ef65e1cdf$var$Uf(0), $83d1223ef65e1cdf$var$T = 0, $83d1223ef65e1cdf$var$qk = null, $83d1223ef65e1cdf$var$hh = 0, $83d1223ef65e1cdf$var$rk = 0, $83d1223ef65e1cdf$var$sk = 0, $83d1223ef65e1cdf$var$tk = null, $83d1223ef65e1cdf$var$uk = null, $83d1223ef65e1cdf$var$gk = 0, $83d1223ef65e1cdf$var$Hj = Infinity, $83d1223ef65e1cdf$var$vk = null, $83d1223ef65e1cdf$var$Pi = !1, $83d1223ef65e1cdf$var$Qi = null, $83d1223ef65e1cdf$var$Si = null, $83d1223ef65e1cdf$var$wk = !1, $83d1223ef65e1cdf$var$xk = null, $83d1223ef65e1cdf$var$yk = 0, $83d1223ef65e1cdf$var$zk = 0, $83d1223ef65e1cdf$var$Ak = null, $83d1223ef65e1cdf$var$Bk = -1, $83d1223ef65e1cdf$var$Ck = 0;
function $83d1223ef65e1cdf$var$L() {
    return 0 !== ($83d1223ef65e1cdf$var$K & 6) ? $83d1223ef65e1cdf$var$B() : -1 !== $83d1223ef65e1cdf$var$Bk ? $83d1223ef65e1cdf$var$Bk : $83d1223ef65e1cdf$var$Bk = $83d1223ef65e1cdf$var$B();
}
function $83d1223ef65e1cdf$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($83d1223ef65e1cdf$var$K & 2) && 0 !== $83d1223ef65e1cdf$var$Z) return $83d1223ef65e1cdf$var$Z & -$83d1223ef65e1cdf$var$Z;
    if (null !== $83d1223ef65e1cdf$var$Kg.transition) return 0 === $83d1223ef65e1cdf$var$Ck && ($83d1223ef65e1cdf$var$Ck = $83d1223ef65e1cdf$var$yc()), $83d1223ef65e1cdf$var$Ck;
    a = $83d1223ef65e1cdf$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $83d1223ef65e1cdf$var$jd(a.type);
    return a;
}
function $83d1223ef65e1cdf$var$mh(a, b, c, d) {
    if (50 < $83d1223ef65e1cdf$var$zk) throw $83d1223ef65e1cdf$var$zk = 0, $83d1223ef65e1cdf$var$Ak = null, Error($83d1223ef65e1cdf$var$p(185));
    $83d1223ef65e1cdf$var$Ac(a, c, d);
    if (0 === ($83d1223ef65e1cdf$var$K & 2) || a !== $83d1223ef65e1cdf$var$R) a === $83d1223ef65e1cdf$var$R && (0 === ($83d1223ef65e1cdf$var$K & 2) && ($83d1223ef65e1cdf$var$rk |= c), 4 === $83d1223ef65e1cdf$var$T && $83d1223ef65e1cdf$var$Dk(a, $83d1223ef65e1cdf$var$Z)), $83d1223ef65e1cdf$var$Ek(a, d), 1 === c && 0 === $83d1223ef65e1cdf$var$K && 0 === (b.mode & 1) && ($83d1223ef65e1cdf$var$Hj = $83d1223ef65e1cdf$var$B() + 500, $83d1223ef65e1cdf$var$fg && $83d1223ef65e1cdf$var$jg());
}
function $83d1223ef65e1cdf$var$Ek(a, b) {
    var c = a.callbackNode;
    $83d1223ef65e1cdf$var$wc(a, b);
    var d = $83d1223ef65e1cdf$var$uc(a, a === $83d1223ef65e1cdf$var$R ? $83d1223ef65e1cdf$var$Z : 0);
    if (0 === d) null !== c && $83d1223ef65e1cdf$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $83d1223ef65e1cdf$var$bc(c);
        if (1 === b) 0 === a.tag ? $83d1223ef65e1cdf$var$ig($83d1223ef65e1cdf$var$Fk.bind(null, a)) : $83d1223ef65e1cdf$var$hg($83d1223ef65e1cdf$var$Fk.bind(null, a)), $83d1223ef65e1cdf$var$Jf(function() {
            0 === ($83d1223ef65e1cdf$var$K & 6) && $83d1223ef65e1cdf$var$jg();
        }), c = null;
        else {
            switch($83d1223ef65e1cdf$var$Dc(d)){
                case 1:
                    c = $83d1223ef65e1cdf$var$fc;
                    break;
                case 4:
                    c = $83d1223ef65e1cdf$var$gc;
                    break;
                case 16:
                    c = $83d1223ef65e1cdf$var$hc;
                    break;
                case 536870912:
                    c = $83d1223ef65e1cdf$var$jc;
                    break;
                default:
                    c = $83d1223ef65e1cdf$var$hc;
            }
            c = $83d1223ef65e1cdf$var$Gk(c, $83d1223ef65e1cdf$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $83d1223ef65e1cdf$var$Hk(a, b) {
    $83d1223ef65e1cdf$var$Bk = -1;
    $83d1223ef65e1cdf$var$Ck = 0;
    if (0 !== ($83d1223ef65e1cdf$var$K & 6)) throw Error($83d1223ef65e1cdf$var$p(327));
    var c = a.callbackNode;
    if ($83d1223ef65e1cdf$var$Ik() && a.callbackNode !== c) return null;
    var d = $83d1223ef65e1cdf$var$uc(a, a === $83d1223ef65e1cdf$var$R ? $83d1223ef65e1cdf$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $83d1223ef65e1cdf$var$Jk(a, d);
    else {
        b = d;
        var e = $83d1223ef65e1cdf$var$K;
        $83d1223ef65e1cdf$var$K |= 2;
        var f = $83d1223ef65e1cdf$var$Kk();
        if ($83d1223ef65e1cdf$var$R !== a || $83d1223ef65e1cdf$var$Z !== b) $83d1223ef65e1cdf$var$vk = null, $83d1223ef65e1cdf$var$Hj = $83d1223ef65e1cdf$var$B() + 500, $83d1223ef65e1cdf$var$Lk(a, b);
        for(;;)try {
            $83d1223ef65e1cdf$var$Mk();
            break;
        } catch (h) {
            $83d1223ef65e1cdf$var$Nk(a, h);
        }
        $83d1223ef65e1cdf$var$Qg();
        $83d1223ef65e1cdf$var$nk.current = f;
        $83d1223ef65e1cdf$var$K = e;
        null !== $83d1223ef65e1cdf$var$Y ? b = 0 : ($83d1223ef65e1cdf$var$R = null, $83d1223ef65e1cdf$var$Z = 0, b = $83d1223ef65e1cdf$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $83d1223ef65e1cdf$var$xc(a), 0 !== e && (d = e, b = $83d1223ef65e1cdf$var$Ok(a, e)));
        if (1 === b) throw c = $83d1223ef65e1cdf$var$qk, $83d1223ef65e1cdf$var$Lk(a, 0), $83d1223ef65e1cdf$var$Dk(a, d), $83d1223ef65e1cdf$var$Ek(a, $83d1223ef65e1cdf$var$B()), c;
        if (6 === b) $83d1223ef65e1cdf$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$83d1223ef65e1cdf$var$Pk(e) && (b = $83d1223ef65e1cdf$var$Jk(a, d), 2 === b && (f = $83d1223ef65e1cdf$var$xc(a), 0 !== f && (d = f, b = $83d1223ef65e1cdf$var$Ok(a, f))), 1 === b)) throw c = $83d1223ef65e1cdf$var$qk, $83d1223ef65e1cdf$var$Lk(a, 0), $83d1223ef65e1cdf$var$Dk(a, d), $83d1223ef65e1cdf$var$Ek(a, $83d1223ef65e1cdf$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($83d1223ef65e1cdf$var$p(345));
                case 2:
                    $83d1223ef65e1cdf$var$Qk(a, $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$vk);
                    break;
                case 3:
                    $83d1223ef65e1cdf$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $83d1223ef65e1cdf$var$gk + 500 - $83d1223ef65e1cdf$var$B(), 10 < b)) {
                        if (0 !== $83d1223ef65e1cdf$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $83d1223ef65e1cdf$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $83d1223ef65e1cdf$var$Ff($83d1223ef65e1cdf$var$Qk.bind(null, a, $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$vk), b);
                        break;
                    }
                    $83d1223ef65e1cdf$var$Qk(a, $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$vk);
                    break;
                case 4:
                    $83d1223ef65e1cdf$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $83d1223ef65e1cdf$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $83d1223ef65e1cdf$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $83d1223ef65e1cdf$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $83d1223ef65e1cdf$var$Ff($83d1223ef65e1cdf$var$Qk.bind(null, a, $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$vk), d);
                        break;
                    }
                    $83d1223ef65e1cdf$var$Qk(a, $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$vk);
                    break;
                case 5:
                    $83d1223ef65e1cdf$var$Qk(a, $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$vk);
                    break;
                default:
                    throw Error($83d1223ef65e1cdf$var$p(329));
            }
        }
    }
    $83d1223ef65e1cdf$var$Ek(a, $83d1223ef65e1cdf$var$B());
    return a.callbackNode === c ? $83d1223ef65e1cdf$var$Hk.bind(null, a) : null;
}
function $83d1223ef65e1cdf$var$Ok(a, b) {
    var c = $83d1223ef65e1cdf$var$tk;
    a.current.memoizedState.isDehydrated && ($83d1223ef65e1cdf$var$Lk(a, b).flags |= 256);
    a = $83d1223ef65e1cdf$var$Jk(a, b);
    2 !== a && (b = $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$uk = c, null !== b && $83d1223ef65e1cdf$var$Gj(b));
    return a;
}
function $83d1223ef65e1cdf$var$Gj(a) {
    null === $83d1223ef65e1cdf$var$uk ? $83d1223ef65e1cdf$var$uk = a : $83d1223ef65e1cdf$var$uk.push.apply($83d1223ef65e1cdf$var$uk, a);
}
function $83d1223ef65e1cdf$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$83d1223ef65e1cdf$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $83d1223ef65e1cdf$var$Dk(a, b) {
    b &= ~$83d1223ef65e1cdf$var$sk;
    b &= ~$83d1223ef65e1cdf$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $83d1223ef65e1cdf$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $83d1223ef65e1cdf$var$Fk(a) {
    if (0 !== ($83d1223ef65e1cdf$var$K & 6)) throw Error($83d1223ef65e1cdf$var$p(327));
    $83d1223ef65e1cdf$var$Ik();
    var b = $83d1223ef65e1cdf$var$uc(a, 0);
    if (0 === (b & 1)) return $83d1223ef65e1cdf$var$Ek(a, $83d1223ef65e1cdf$var$B()), null;
    var c = $83d1223ef65e1cdf$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $83d1223ef65e1cdf$var$xc(a);
        0 !== d && (b = d, c = $83d1223ef65e1cdf$var$Ok(a, d));
    }
    if (1 === c) throw c = $83d1223ef65e1cdf$var$qk, $83d1223ef65e1cdf$var$Lk(a, 0), $83d1223ef65e1cdf$var$Dk(a, b), $83d1223ef65e1cdf$var$Ek(a, $83d1223ef65e1cdf$var$B()), c;
    if (6 === c) throw Error($83d1223ef65e1cdf$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $83d1223ef65e1cdf$var$Qk(a, $83d1223ef65e1cdf$var$uk, $83d1223ef65e1cdf$var$vk);
    $83d1223ef65e1cdf$var$Ek(a, $83d1223ef65e1cdf$var$B());
    return null;
}
function $83d1223ef65e1cdf$var$Rk(a, b) {
    var c = $83d1223ef65e1cdf$var$K;
    $83d1223ef65e1cdf$var$K |= 1;
    try {
        return a(b);
    } finally{
        $83d1223ef65e1cdf$var$K = c, 0 === $83d1223ef65e1cdf$var$K && ($83d1223ef65e1cdf$var$Hj = $83d1223ef65e1cdf$var$B() + 500, $83d1223ef65e1cdf$var$fg && $83d1223ef65e1cdf$var$jg());
    }
}
function $83d1223ef65e1cdf$var$Sk(a) {
    null !== $83d1223ef65e1cdf$var$xk && 0 === $83d1223ef65e1cdf$var$xk.tag && 0 === ($83d1223ef65e1cdf$var$K & 6) && $83d1223ef65e1cdf$var$Ik();
    var b = $83d1223ef65e1cdf$var$K;
    $83d1223ef65e1cdf$var$K |= 1;
    var c = $83d1223ef65e1cdf$var$pk.transition, d = $83d1223ef65e1cdf$var$C;
    try {
        if ($83d1223ef65e1cdf$var$pk.transition = null, $83d1223ef65e1cdf$var$C = 1, a) return a();
    } finally{
        $83d1223ef65e1cdf$var$C = d, $83d1223ef65e1cdf$var$pk.transition = c, $83d1223ef65e1cdf$var$K = b, 0 === ($83d1223ef65e1cdf$var$K & 6) && $83d1223ef65e1cdf$var$jg();
    }
}
function $83d1223ef65e1cdf$var$Ij() {
    $83d1223ef65e1cdf$var$gj = $83d1223ef65e1cdf$var$fj.current;
    $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$fj);
}
function $83d1223ef65e1cdf$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $83d1223ef65e1cdf$var$Gf(c));
    if (null !== $83d1223ef65e1cdf$var$Y) for(c = $83d1223ef65e1cdf$var$Y.return; null !== c;){
        var d = c;
        $83d1223ef65e1cdf$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $83d1223ef65e1cdf$var$$f();
                break;
            case 3:
                $83d1223ef65e1cdf$var$Jh();
                $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$Wf);
                $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$H);
                $83d1223ef65e1cdf$var$Oh();
                break;
            case 5:
                $83d1223ef65e1cdf$var$Lh(d);
                break;
            case 4:
                $83d1223ef65e1cdf$var$Jh();
                break;
            case 13:
                $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$M);
                break;
            case 19:
                $83d1223ef65e1cdf$var$E($83d1223ef65e1cdf$var$M);
                break;
            case 10:
                $83d1223ef65e1cdf$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $83d1223ef65e1cdf$var$Ij();
        }
        c = c.return;
    }
    $83d1223ef65e1cdf$var$R = a;
    $83d1223ef65e1cdf$var$Y = a = $83d1223ef65e1cdf$var$wh(a.current, null);
    $83d1223ef65e1cdf$var$Z = $83d1223ef65e1cdf$var$gj = b;
    $83d1223ef65e1cdf$var$T = 0;
    $83d1223ef65e1cdf$var$qk = null;
    $83d1223ef65e1cdf$var$sk = $83d1223ef65e1cdf$var$rk = $83d1223ef65e1cdf$var$hh = 0;
    $83d1223ef65e1cdf$var$uk = $83d1223ef65e1cdf$var$tk = null;
    if (null !== $83d1223ef65e1cdf$var$Wg) {
        for(b = 0; b < $83d1223ef65e1cdf$var$Wg.length; b++)if (c = $83d1223ef65e1cdf$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $83d1223ef65e1cdf$var$Wg = null;
    }
    return a;
}
function $83d1223ef65e1cdf$var$Nk(a, b) {
    do {
        var c = $83d1223ef65e1cdf$var$Y;
        try {
            $83d1223ef65e1cdf$var$Qg();
            $83d1223ef65e1cdf$var$Ph.current = $83d1223ef65e1cdf$var$ai;
            if ($83d1223ef65e1cdf$var$Sh) {
                for(var d = $83d1223ef65e1cdf$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $83d1223ef65e1cdf$var$Sh = !1;
            }
            $83d1223ef65e1cdf$var$Rh = 0;
            $83d1223ef65e1cdf$var$P = $83d1223ef65e1cdf$var$O = $83d1223ef65e1cdf$var$N = null;
            $83d1223ef65e1cdf$var$Th = !1;
            $83d1223ef65e1cdf$var$Uh = 0;
            $83d1223ef65e1cdf$var$ok.current = null;
            if (null === c || null === c.return) {
                $83d1223ef65e1cdf$var$T = 1;
                $83d1223ef65e1cdf$var$qk = b;
                $83d1223ef65e1cdf$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $83d1223ef65e1cdf$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $83d1223ef65e1cdf$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $83d1223ef65e1cdf$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $83d1223ef65e1cdf$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $83d1223ef65e1cdf$var$Ti(f, l, b);
                            $83d1223ef65e1cdf$var$uj();
                            break a;
                        }
                        k = Error($83d1223ef65e1cdf$var$p(426));
                    }
                } else if ($83d1223ef65e1cdf$var$I && h.mode & 1) {
                    var J = $83d1223ef65e1cdf$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $83d1223ef65e1cdf$var$Wi(J, g, h, f, b);
                        $83d1223ef65e1cdf$var$Jg($83d1223ef65e1cdf$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $83d1223ef65e1cdf$var$Ki(k, h);
                4 !== $83d1223ef65e1cdf$var$T && ($83d1223ef65e1cdf$var$T = 2);
                null === $83d1223ef65e1cdf$var$tk ? $83d1223ef65e1cdf$var$tk = [
                    f
                ] : $83d1223ef65e1cdf$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $83d1223ef65e1cdf$var$Oi(f, k, b);
                            $83d1223ef65e1cdf$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $83d1223ef65e1cdf$var$Si || !$83d1223ef65e1cdf$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $83d1223ef65e1cdf$var$Ri(f, h, b);
                                $83d1223ef65e1cdf$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $83d1223ef65e1cdf$var$Tk(c);
        } catch (na) {
            b = na;
            $83d1223ef65e1cdf$var$Y === c && null !== c && ($83d1223ef65e1cdf$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $83d1223ef65e1cdf$var$Kk() {
    var a = $83d1223ef65e1cdf$var$nk.current;
    $83d1223ef65e1cdf$var$nk.current = $83d1223ef65e1cdf$var$ai;
    return null === a ? $83d1223ef65e1cdf$var$ai : a;
}
function $83d1223ef65e1cdf$var$uj() {
    if (0 === $83d1223ef65e1cdf$var$T || 3 === $83d1223ef65e1cdf$var$T || 2 === $83d1223ef65e1cdf$var$T) $83d1223ef65e1cdf$var$T = 4;
    null === $83d1223ef65e1cdf$var$R || 0 === ($83d1223ef65e1cdf$var$hh & 268435455) && 0 === ($83d1223ef65e1cdf$var$rk & 268435455) || $83d1223ef65e1cdf$var$Dk($83d1223ef65e1cdf$var$R, $83d1223ef65e1cdf$var$Z);
}
function $83d1223ef65e1cdf$var$Jk(a, b) {
    var c = $83d1223ef65e1cdf$var$K;
    $83d1223ef65e1cdf$var$K |= 2;
    var d = $83d1223ef65e1cdf$var$Kk();
    if ($83d1223ef65e1cdf$var$R !== a || $83d1223ef65e1cdf$var$Z !== b) $83d1223ef65e1cdf$var$vk = null, $83d1223ef65e1cdf$var$Lk(a, b);
    for(;;)try {
        $83d1223ef65e1cdf$var$Uk();
        break;
    } catch (e) {
        $83d1223ef65e1cdf$var$Nk(a, e);
    }
    $83d1223ef65e1cdf$var$Qg();
    $83d1223ef65e1cdf$var$K = c;
    $83d1223ef65e1cdf$var$nk.current = d;
    if (null !== $83d1223ef65e1cdf$var$Y) throw Error($83d1223ef65e1cdf$var$p(261));
    $83d1223ef65e1cdf$var$R = null;
    $83d1223ef65e1cdf$var$Z = 0;
    return $83d1223ef65e1cdf$var$T;
}
function $83d1223ef65e1cdf$var$Uk() {
    for(; null !== $83d1223ef65e1cdf$var$Y;)$83d1223ef65e1cdf$var$Vk($83d1223ef65e1cdf$var$Y);
}
function $83d1223ef65e1cdf$var$Mk() {
    for(; null !== $83d1223ef65e1cdf$var$Y && !$83d1223ef65e1cdf$var$cc();)$83d1223ef65e1cdf$var$Vk($83d1223ef65e1cdf$var$Y);
}
function $83d1223ef65e1cdf$var$Vk(a) {
    var b = $83d1223ef65e1cdf$var$Wk(a.alternate, a, $83d1223ef65e1cdf$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $83d1223ef65e1cdf$var$Tk(a) : $83d1223ef65e1cdf$var$Y = b;
    $83d1223ef65e1cdf$var$ok.current = null;
}
function $83d1223ef65e1cdf$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $83d1223ef65e1cdf$var$Fj(c, b, $83d1223ef65e1cdf$var$gj), null !== c) {
                $83d1223ef65e1cdf$var$Y = c;
                return;
            }
        } else {
            c = $83d1223ef65e1cdf$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $83d1223ef65e1cdf$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $83d1223ef65e1cdf$var$T = 6;
                $83d1223ef65e1cdf$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $83d1223ef65e1cdf$var$Y = b;
            return;
        }
        $83d1223ef65e1cdf$var$Y = b = a;
    }while (null !== b);
    0 === $83d1223ef65e1cdf$var$T && ($83d1223ef65e1cdf$var$T = 5);
}
function $83d1223ef65e1cdf$var$Qk(a, b, c) {
    var d = $83d1223ef65e1cdf$var$C, e = $83d1223ef65e1cdf$var$pk.transition;
    try {
        $83d1223ef65e1cdf$var$pk.transition = null, $83d1223ef65e1cdf$var$C = 1, $83d1223ef65e1cdf$var$Xk(a, b, c, d);
    } finally{
        $83d1223ef65e1cdf$var$pk.transition = e, $83d1223ef65e1cdf$var$C = d;
    }
    return null;
}
function $83d1223ef65e1cdf$var$Xk(a, b, c, d) {
    do $83d1223ef65e1cdf$var$Ik();
    while (null !== $83d1223ef65e1cdf$var$xk);
    if (0 !== ($83d1223ef65e1cdf$var$K & 6)) throw Error($83d1223ef65e1cdf$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($83d1223ef65e1cdf$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $83d1223ef65e1cdf$var$Bc(a, f);
    a === $83d1223ef65e1cdf$var$R && ($83d1223ef65e1cdf$var$Y = $83d1223ef65e1cdf$var$R = null, $83d1223ef65e1cdf$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $83d1223ef65e1cdf$var$wk || ($83d1223ef65e1cdf$var$wk = !0, $83d1223ef65e1cdf$var$Gk($83d1223ef65e1cdf$var$hc, function() {
        $83d1223ef65e1cdf$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $83d1223ef65e1cdf$var$pk.transition;
        $83d1223ef65e1cdf$var$pk.transition = null;
        var g = $83d1223ef65e1cdf$var$C;
        $83d1223ef65e1cdf$var$C = 1;
        var h = $83d1223ef65e1cdf$var$K;
        $83d1223ef65e1cdf$var$K |= 4;
        $83d1223ef65e1cdf$var$ok.current = null;
        $83d1223ef65e1cdf$var$Pj(a, c);
        $83d1223ef65e1cdf$var$ek(c, a);
        $83d1223ef65e1cdf$var$Oe($83d1223ef65e1cdf$var$Df);
        $83d1223ef65e1cdf$var$dd = !!$83d1223ef65e1cdf$var$Cf;
        $83d1223ef65e1cdf$var$Df = $83d1223ef65e1cdf$var$Cf = null;
        a.current = c;
        $83d1223ef65e1cdf$var$ik(c, a, e);
        $83d1223ef65e1cdf$var$dc();
        $83d1223ef65e1cdf$var$K = h;
        $83d1223ef65e1cdf$var$C = g;
        $83d1223ef65e1cdf$var$pk.transition = f;
    } else a.current = c;
    $83d1223ef65e1cdf$var$wk && ($83d1223ef65e1cdf$var$wk = !1, $83d1223ef65e1cdf$var$xk = a, $83d1223ef65e1cdf$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($83d1223ef65e1cdf$var$Si = null);
    $83d1223ef65e1cdf$var$mc(c.stateNode, d);
    $83d1223ef65e1cdf$var$Ek(a, $83d1223ef65e1cdf$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($83d1223ef65e1cdf$var$Pi) throw $83d1223ef65e1cdf$var$Pi = !1, a = $83d1223ef65e1cdf$var$Qi, $83d1223ef65e1cdf$var$Qi = null, a;
    0 !== ($83d1223ef65e1cdf$var$yk & 1) && 0 !== a.tag && $83d1223ef65e1cdf$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $83d1223ef65e1cdf$var$Ak ? $83d1223ef65e1cdf$var$zk++ : ($83d1223ef65e1cdf$var$zk = 0, $83d1223ef65e1cdf$var$Ak = a) : $83d1223ef65e1cdf$var$zk = 0;
    $83d1223ef65e1cdf$var$jg();
    return null;
}
function $83d1223ef65e1cdf$var$Ik() {
    if (null !== $83d1223ef65e1cdf$var$xk) {
        var a = $83d1223ef65e1cdf$var$Dc($83d1223ef65e1cdf$var$yk), b = $83d1223ef65e1cdf$var$pk.transition, c = $83d1223ef65e1cdf$var$C;
        try {
            $83d1223ef65e1cdf$var$pk.transition = null;
            $83d1223ef65e1cdf$var$C = 16 > a ? 16 : a;
            if (null === $83d1223ef65e1cdf$var$xk) var d = !1;
            else {
                a = $83d1223ef65e1cdf$var$xk;
                $83d1223ef65e1cdf$var$xk = null;
                $83d1223ef65e1cdf$var$yk = 0;
                if (0 !== ($83d1223ef65e1cdf$var$K & 6)) throw Error($83d1223ef65e1cdf$var$p(331));
                var e = $83d1223ef65e1cdf$var$K;
                $83d1223ef65e1cdf$var$K |= 4;
                for($83d1223ef65e1cdf$var$V = a.current; null !== $83d1223ef65e1cdf$var$V;){
                    var f = $83d1223ef65e1cdf$var$V, g = f.child;
                    if (0 !== ($83d1223ef65e1cdf$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($83d1223ef65e1cdf$var$V = l; null !== $83d1223ef65e1cdf$var$V;){
                                    var m = $83d1223ef65e1cdf$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $83d1223ef65e1cdf$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $83d1223ef65e1cdf$var$V = q;
                                    else for(; null !== $83d1223ef65e1cdf$var$V;){
                                        m = $83d1223ef65e1cdf$var$V;
                                        var r = m.sibling, y = m.return;
                                        $83d1223ef65e1cdf$var$Tj(m);
                                        if (m === l) {
                                            $83d1223ef65e1cdf$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $83d1223ef65e1cdf$var$V = r;
                                            break;
                                        }
                                        $83d1223ef65e1cdf$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $83d1223ef65e1cdf$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $83d1223ef65e1cdf$var$V = g;
                    else b: for(; null !== $83d1223ef65e1cdf$var$V;){
                        f = $83d1223ef65e1cdf$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $83d1223ef65e1cdf$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $83d1223ef65e1cdf$var$V = x;
                            break b;
                        }
                        $83d1223ef65e1cdf$var$V = f.return;
                    }
                }
                var w = a.current;
                for($83d1223ef65e1cdf$var$V = w; null !== $83d1223ef65e1cdf$var$V;){
                    g = $83d1223ef65e1cdf$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $83d1223ef65e1cdf$var$V = u;
                    else b: for(g = w; null !== $83d1223ef65e1cdf$var$V;){
                        h = $83d1223ef65e1cdf$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $83d1223ef65e1cdf$var$Rj(9, h);
                            }
                        } catch (na) {
                            $83d1223ef65e1cdf$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $83d1223ef65e1cdf$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $83d1223ef65e1cdf$var$V = F;
                            break b;
                        }
                        $83d1223ef65e1cdf$var$V = h.return;
                    }
                }
                $83d1223ef65e1cdf$var$K = e;
                $83d1223ef65e1cdf$var$jg();
                if ($83d1223ef65e1cdf$var$lc && "function" === typeof $83d1223ef65e1cdf$var$lc.onPostCommitFiberRoot) try {
                    $83d1223ef65e1cdf$var$lc.onPostCommitFiberRoot($83d1223ef65e1cdf$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $83d1223ef65e1cdf$var$C = c, $83d1223ef65e1cdf$var$pk.transition = b;
        }
    }
    return !1;
}
function $83d1223ef65e1cdf$var$Yk(a, b, c) {
    b = $83d1223ef65e1cdf$var$Ki(c, b);
    b = $83d1223ef65e1cdf$var$Oi(a, b, 1);
    a = $83d1223ef65e1cdf$var$dh(a, b, 1);
    b = $83d1223ef65e1cdf$var$L();
    null !== a && ($83d1223ef65e1cdf$var$Ac(a, 1, b), $83d1223ef65e1cdf$var$Ek(a, b));
}
function $83d1223ef65e1cdf$var$W(a, b, c) {
    if (3 === a.tag) $83d1223ef65e1cdf$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $83d1223ef65e1cdf$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $83d1223ef65e1cdf$var$Si || !$83d1223ef65e1cdf$var$Si.has(d))) {
                a = $83d1223ef65e1cdf$var$Ki(c, a);
                a = $83d1223ef65e1cdf$var$Ri(b, a, 1);
                b = $83d1223ef65e1cdf$var$dh(b, a, 1);
                a = $83d1223ef65e1cdf$var$L();
                null !== b && ($83d1223ef65e1cdf$var$Ac(b, 1, a), $83d1223ef65e1cdf$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $83d1223ef65e1cdf$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $83d1223ef65e1cdf$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $83d1223ef65e1cdf$var$R === a && ($83d1223ef65e1cdf$var$Z & c) === c && (4 === $83d1223ef65e1cdf$var$T || 3 === $83d1223ef65e1cdf$var$T && ($83d1223ef65e1cdf$var$Z & 130023424) === $83d1223ef65e1cdf$var$Z && 500 > $83d1223ef65e1cdf$var$B() - $83d1223ef65e1cdf$var$gk ? $83d1223ef65e1cdf$var$Lk(a, 0) : $83d1223ef65e1cdf$var$sk |= c);
    $83d1223ef65e1cdf$var$Ek(a, b);
}
function $83d1223ef65e1cdf$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $83d1223ef65e1cdf$var$sc, $83d1223ef65e1cdf$var$sc <<= 1, 0 === ($83d1223ef65e1cdf$var$sc & 130023424) && ($83d1223ef65e1cdf$var$sc = 4194304)));
    var c = $83d1223ef65e1cdf$var$L();
    a = $83d1223ef65e1cdf$var$Zg(a, b);
    null !== a && ($83d1223ef65e1cdf$var$Ac(a, b, c), $83d1223ef65e1cdf$var$Ek(a, c));
}
function $83d1223ef65e1cdf$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $83d1223ef65e1cdf$var$Zk(a, c);
}
function $83d1223ef65e1cdf$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($83d1223ef65e1cdf$var$p(314));
    }
    null !== d && d.delete(b);
    $83d1223ef65e1cdf$var$Zk(a, c);
}
var $83d1223ef65e1cdf$var$Wk;
$83d1223ef65e1cdf$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $83d1223ef65e1cdf$var$Wf.current) $83d1223ef65e1cdf$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $83d1223ef65e1cdf$var$Ug = !1, $83d1223ef65e1cdf$var$zj(a, b, c);
            $83d1223ef65e1cdf$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $83d1223ef65e1cdf$var$Ug = !1, $83d1223ef65e1cdf$var$I && 0 !== (b.flags & 1048576) && $83d1223ef65e1cdf$var$ug(b, $83d1223ef65e1cdf$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $83d1223ef65e1cdf$var$jj(a, b);
            a = b.pendingProps;
            var e = $83d1223ef65e1cdf$var$Yf(b, $83d1223ef65e1cdf$var$H.current);
            $83d1223ef65e1cdf$var$Tg(b, c);
            e = $83d1223ef65e1cdf$var$Xh(null, b, d, a, e, c);
            var f = $83d1223ef65e1cdf$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $83d1223ef65e1cdf$var$Zf(d) ? (f = !0, $83d1223ef65e1cdf$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $83d1223ef65e1cdf$var$ah(b), e.updater = $83d1223ef65e1cdf$var$nh, b.stateNode = e, e._reactInternals = b, $83d1223ef65e1cdf$var$rh(b, d, a, c), b = $83d1223ef65e1cdf$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $83d1223ef65e1cdf$var$I && f && $83d1223ef65e1cdf$var$vg(b), $83d1223ef65e1cdf$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $83d1223ef65e1cdf$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $83d1223ef65e1cdf$var$$k(d);
                a = $83d1223ef65e1cdf$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $83d1223ef65e1cdf$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $83d1223ef65e1cdf$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $83d1223ef65e1cdf$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $83d1223ef65e1cdf$var$aj(null, b, d, $83d1223ef65e1cdf$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($83d1223ef65e1cdf$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83d1223ef65e1cdf$var$Lg(d, e), $83d1223ef65e1cdf$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83d1223ef65e1cdf$var$Lg(d, e), $83d1223ef65e1cdf$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $83d1223ef65e1cdf$var$lj(b);
                if (null === a) throw Error($83d1223ef65e1cdf$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $83d1223ef65e1cdf$var$bh(a, b);
                $83d1223ef65e1cdf$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $83d1223ef65e1cdf$var$Ki(Error($83d1223ef65e1cdf$var$p(423)), b);
                        b = $83d1223ef65e1cdf$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $83d1223ef65e1cdf$var$Ki(Error($83d1223ef65e1cdf$var$p(424)), b);
                        b = $83d1223ef65e1cdf$var$mj(a, b, d, c, e);
                        break a;
                    } else for($83d1223ef65e1cdf$var$yg = $83d1223ef65e1cdf$var$Lf(b.stateNode.containerInfo.firstChild), $83d1223ef65e1cdf$var$xg = b, $83d1223ef65e1cdf$var$I = !0, $83d1223ef65e1cdf$var$zg = null, c = $83d1223ef65e1cdf$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $83d1223ef65e1cdf$var$Ig();
                    if (d === e) {
                        b = $83d1223ef65e1cdf$var$$i(a, b, c);
                        break a;
                    }
                    $83d1223ef65e1cdf$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $83d1223ef65e1cdf$var$Kh(b), null === a && $83d1223ef65e1cdf$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $83d1223ef65e1cdf$var$Ef(d, e) ? g = null : null !== f && $83d1223ef65e1cdf$var$Ef(d, f) && (b.flags |= 32), $83d1223ef65e1cdf$var$hj(a, b), $83d1223ef65e1cdf$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $83d1223ef65e1cdf$var$Eg(b), null;
        case 13:
            return $83d1223ef65e1cdf$var$pj(a, b, c);
        case 4:
            return $83d1223ef65e1cdf$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $83d1223ef65e1cdf$var$Bh(b, null, d, c) : $83d1223ef65e1cdf$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83d1223ef65e1cdf$var$Lg(d, e), $83d1223ef65e1cdf$var$Zi(a, b, d, e, c);
        case 7:
            return $83d1223ef65e1cdf$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $83d1223ef65e1cdf$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $83d1223ef65e1cdf$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $83d1223ef65e1cdf$var$G($83d1223ef65e1cdf$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($83d1223ef65e1cdf$var$He(f.value, g)) {
                        if (f.children === e.children && !$83d1223ef65e1cdf$var$Wf.current) {
                            b = $83d1223ef65e1cdf$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $83d1223ef65e1cdf$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $83d1223ef65e1cdf$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($83d1223ef65e1cdf$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $83d1223ef65e1cdf$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $83d1223ef65e1cdf$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $83d1223ef65e1cdf$var$Tg(b, c), e = $83d1223ef65e1cdf$var$Vg(e), d = d(e), b.flags |= 1, $83d1223ef65e1cdf$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $83d1223ef65e1cdf$var$Lg(d, b.pendingProps), e = $83d1223ef65e1cdf$var$Lg(d.type, e), $83d1223ef65e1cdf$var$aj(a, b, d, e, c);
        case 15:
            return $83d1223ef65e1cdf$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83d1223ef65e1cdf$var$Lg(d, e), $83d1223ef65e1cdf$var$jj(a, b), b.tag = 1, $83d1223ef65e1cdf$var$Zf(d) ? (a = !0, $83d1223ef65e1cdf$var$cg(b)) : a = !1, $83d1223ef65e1cdf$var$Tg(b, c), $83d1223ef65e1cdf$var$ph(b, d, e), $83d1223ef65e1cdf$var$rh(b, d, e, c), $83d1223ef65e1cdf$var$kj(null, b, d, !0, a, c);
        case 19:
            return $83d1223ef65e1cdf$var$yj(a, b, c);
        case 22:
            return $83d1223ef65e1cdf$var$ej(a, b, c);
    }
    throw Error($83d1223ef65e1cdf$var$p(156, b.tag));
};
function $83d1223ef65e1cdf$var$Gk(a, b) {
    return $83d1223ef65e1cdf$var$ac(a, b);
}
function $83d1223ef65e1cdf$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $83d1223ef65e1cdf$var$Bg(a, b, c, d) {
    return new $83d1223ef65e1cdf$var$al(a, b, c, d);
}
function $83d1223ef65e1cdf$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $83d1223ef65e1cdf$var$$k(a) {
    if ("function" === typeof a) return $83d1223ef65e1cdf$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $83d1223ef65e1cdf$var$Da) return 11;
        if (a === $83d1223ef65e1cdf$var$Ga) return 14;
    }
    return 2;
}
function $83d1223ef65e1cdf$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $83d1223ef65e1cdf$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $83d1223ef65e1cdf$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $83d1223ef65e1cdf$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $83d1223ef65e1cdf$var$ya:
            return $83d1223ef65e1cdf$var$Ah(c.children, e, f, b);
        case $83d1223ef65e1cdf$var$za:
            g = 8;
            e |= 8;
            break;
        case $83d1223ef65e1cdf$var$Aa:
            return a = $83d1223ef65e1cdf$var$Bg(12, c, b, e | 2), a.elementType = $83d1223ef65e1cdf$var$Aa, a.lanes = f, a;
        case $83d1223ef65e1cdf$var$Ea:
            return a = $83d1223ef65e1cdf$var$Bg(13, c, b, e), a.elementType = $83d1223ef65e1cdf$var$Ea, a.lanes = f, a;
        case $83d1223ef65e1cdf$var$Fa:
            return a = $83d1223ef65e1cdf$var$Bg(19, c, b, e), a.elementType = $83d1223ef65e1cdf$var$Fa, a.lanes = f, a;
        case $83d1223ef65e1cdf$var$Ia:
            return $83d1223ef65e1cdf$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $83d1223ef65e1cdf$var$Ba:
                    g = 10;
                    break a;
                case $83d1223ef65e1cdf$var$Ca:
                    g = 9;
                    break a;
                case $83d1223ef65e1cdf$var$Da:
                    g = 11;
                    break a;
                case $83d1223ef65e1cdf$var$Ga:
                    g = 14;
                    break a;
                case $83d1223ef65e1cdf$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($83d1223ef65e1cdf$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $83d1223ef65e1cdf$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $83d1223ef65e1cdf$var$Ah(a, b, c, d) {
    a = $83d1223ef65e1cdf$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $83d1223ef65e1cdf$var$qj(a, b, c, d) {
    a = $83d1223ef65e1cdf$var$Bg(22, a, d, b);
    a.elementType = $83d1223ef65e1cdf$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $83d1223ef65e1cdf$var$xh(a, b, c) {
    a = $83d1223ef65e1cdf$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $83d1223ef65e1cdf$var$zh(a, b, c) {
    b = $83d1223ef65e1cdf$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $83d1223ef65e1cdf$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $83d1223ef65e1cdf$var$zc(0);
    this.expirationTimes = $83d1223ef65e1cdf$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $83d1223ef65e1cdf$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $83d1223ef65e1cdf$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $83d1223ef65e1cdf$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $83d1223ef65e1cdf$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $83d1223ef65e1cdf$var$ah(f);
    return a;
}
function $83d1223ef65e1cdf$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $83d1223ef65e1cdf$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $83d1223ef65e1cdf$var$el(a) {
    if (!a) return $83d1223ef65e1cdf$var$Vf;
    a = a._reactInternals;
    a: {
        if ($83d1223ef65e1cdf$var$Vb(a) !== a || 1 !== a.tag) throw Error($83d1223ef65e1cdf$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($83d1223ef65e1cdf$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($83d1223ef65e1cdf$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($83d1223ef65e1cdf$var$Zf(c)) return $83d1223ef65e1cdf$var$bg(a, c, b);
    }
    return b;
}
function $83d1223ef65e1cdf$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $83d1223ef65e1cdf$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $83d1223ef65e1cdf$var$el(null);
    c = a.current;
    d = $83d1223ef65e1cdf$var$L();
    e = $83d1223ef65e1cdf$var$lh(c);
    f = $83d1223ef65e1cdf$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $83d1223ef65e1cdf$var$dh(c, f, e);
    a.current.lanes = e;
    $83d1223ef65e1cdf$var$Ac(a, e, d);
    $83d1223ef65e1cdf$var$Ek(a, d);
    return a;
}
function $83d1223ef65e1cdf$var$gl(a, b, c, d) {
    var e = b.current, f = $83d1223ef65e1cdf$var$L(), g = $83d1223ef65e1cdf$var$lh(e);
    c = $83d1223ef65e1cdf$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $83d1223ef65e1cdf$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $83d1223ef65e1cdf$var$dh(e, b, g);
    null !== a && ($83d1223ef65e1cdf$var$mh(a, e, g, f), $83d1223ef65e1cdf$var$eh(a, e, g));
    return g;
}
function $83d1223ef65e1cdf$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $83d1223ef65e1cdf$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $83d1223ef65e1cdf$var$jl(a, b) {
    $83d1223ef65e1cdf$var$il(a, b);
    (a = a.alternate) && $83d1223ef65e1cdf$var$il(a, b);
}
function $83d1223ef65e1cdf$var$kl() {
    return null;
}
var $83d1223ef65e1cdf$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $83d1223ef65e1cdf$var$ml(a) {
    this._internalRoot = a;
}
$83d1223ef65e1cdf$var$nl.prototype.render = $83d1223ef65e1cdf$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($83d1223ef65e1cdf$var$p(409));
    $83d1223ef65e1cdf$var$gl(a, b, null, null);
};
$83d1223ef65e1cdf$var$nl.prototype.unmount = $83d1223ef65e1cdf$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $83d1223ef65e1cdf$var$Sk(function() {
            $83d1223ef65e1cdf$var$gl(null, a, null, null);
        });
        b[$83d1223ef65e1cdf$var$uf] = null;
    }
};
function $83d1223ef65e1cdf$var$nl(a) {
    this._internalRoot = a;
}
$83d1223ef65e1cdf$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $83d1223ef65e1cdf$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $83d1223ef65e1cdf$var$Qc.length && 0 !== b && b < $83d1223ef65e1cdf$var$Qc[c].priority; c++);
        $83d1223ef65e1cdf$var$Qc.splice(c, 0, a);
        0 === c && $83d1223ef65e1cdf$var$Vc(a);
    }
};
function $83d1223ef65e1cdf$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $83d1223ef65e1cdf$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $83d1223ef65e1cdf$var$ql() {}
function $83d1223ef65e1cdf$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $83d1223ef65e1cdf$var$hl(g);
                f.call(a);
            };
        }
        var g = $83d1223ef65e1cdf$var$fl(b, d, a, 0, null, !1, !1, "", $83d1223ef65e1cdf$var$ql);
        a._reactRootContainer = g;
        a[$83d1223ef65e1cdf$var$uf] = g.current;
        $83d1223ef65e1cdf$var$sf(8 === a.nodeType ? a.parentNode : a);
        $83d1223ef65e1cdf$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $83d1223ef65e1cdf$var$hl(k);
            h.call(a);
        };
    }
    var k = $83d1223ef65e1cdf$var$cl(a, 0, !1, null, null, !1, !1, "", $83d1223ef65e1cdf$var$ql);
    a._reactRootContainer = k;
    a[$83d1223ef65e1cdf$var$uf] = k.current;
    $83d1223ef65e1cdf$var$sf(8 === a.nodeType ? a.parentNode : a);
    $83d1223ef65e1cdf$var$Sk(function() {
        $83d1223ef65e1cdf$var$gl(b, k, c, d);
    });
    return k;
}
function $83d1223ef65e1cdf$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $83d1223ef65e1cdf$var$hl(g);
                h.call(a);
            };
        }
        $83d1223ef65e1cdf$var$gl(b, g, a, e);
    } else g = $83d1223ef65e1cdf$var$rl(c, b, a, e, d);
    return $83d1223ef65e1cdf$var$hl(g);
}
$83d1223ef65e1cdf$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $83d1223ef65e1cdf$var$tc(b.pendingLanes);
                0 !== c && ($83d1223ef65e1cdf$var$Cc(b, c | 1), $83d1223ef65e1cdf$var$Ek(b, $83d1223ef65e1cdf$var$B()), 0 === ($83d1223ef65e1cdf$var$K & 6) && ($83d1223ef65e1cdf$var$Hj = $83d1223ef65e1cdf$var$B() + 500, $83d1223ef65e1cdf$var$jg()));
            }
            break;
        case 13:
            $83d1223ef65e1cdf$var$Sk(function() {
                var b = $83d1223ef65e1cdf$var$Zg(a, 1);
                if (null !== b) {
                    var c = $83d1223ef65e1cdf$var$L();
                    $83d1223ef65e1cdf$var$mh(b, a, 1, c);
                }
            }), $83d1223ef65e1cdf$var$jl(a, 1);
    }
};
$83d1223ef65e1cdf$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $83d1223ef65e1cdf$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $83d1223ef65e1cdf$var$L();
            $83d1223ef65e1cdf$var$mh(b, a, 134217728, c);
        }
        $83d1223ef65e1cdf$var$jl(a, 134217728);
    }
};
$83d1223ef65e1cdf$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $83d1223ef65e1cdf$var$lh(a), c = $83d1223ef65e1cdf$var$Zg(a, b);
        if (null !== c) {
            var d = $83d1223ef65e1cdf$var$L();
            $83d1223ef65e1cdf$var$mh(c, a, b, d);
        }
        $83d1223ef65e1cdf$var$jl(a, b);
    }
};
$83d1223ef65e1cdf$var$Hc = function() {
    return $83d1223ef65e1cdf$var$C;
};
$83d1223ef65e1cdf$var$Ic = function(a, b) {
    var c = $83d1223ef65e1cdf$var$C;
    try {
        return $83d1223ef65e1cdf$var$C = a, b();
    } finally{
        $83d1223ef65e1cdf$var$C = c;
    }
};
$83d1223ef65e1cdf$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $83d1223ef65e1cdf$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $83d1223ef65e1cdf$var$Db(d);
                        if (!e) throw Error($83d1223ef65e1cdf$var$p(90));
                        $83d1223ef65e1cdf$var$Wa(d);
                        $83d1223ef65e1cdf$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $83d1223ef65e1cdf$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $83d1223ef65e1cdf$var$fb(a, !!c.multiple, b, !1);
    }
};
$83d1223ef65e1cdf$var$Gb = $83d1223ef65e1cdf$var$Rk;
$83d1223ef65e1cdf$var$Hb = $83d1223ef65e1cdf$var$Sk;
var $83d1223ef65e1cdf$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $83d1223ef65e1cdf$var$Cb,
        $83d1223ef65e1cdf$var$ue,
        $83d1223ef65e1cdf$var$Db,
        $83d1223ef65e1cdf$var$Eb,
        $83d1223ef65e1cdf$var$Fb,
        $83d1223ef65e1cdf$var$Rk
    ]
}, $83d1223ef65e1cdf$var$ul = {
    findFiberByHostInstance: $83d1223ef65e1cdf$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $83d1223ef65e1cdf$var$vl = {
    bundleType: $83d1223ef65e1cdf$var$ul.bundleType,
    version: $83d1223ef65e1cdf$var$ul.version,
    rendererPackageName: $83d1223ef65e1cdf$var$ul.rendererPackageName,
    rendererConfig: $83d1223ef65e1cdf$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $83d1223ef65e1cdf$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $83d1223ef65e1cdf$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $83d1223ef65e1cdf$var$ul.findFiberByHostInstance || $83d1223ef65e1cdf$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $83d1223ef65e1cdf$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$83d1223ef65e1cdf$var$wl.isDisabled && $83d1223ef65e1cdf$var$wl.supportsFiber) try {
        $83d1223ef65e1cdf$var$kc = $83d1223ef65e1cdf$var$wl.inject($83d1223ef65e1cdf$var$vl), $83d1223ef65e1cdf$var$lc = $83d1223ef65e1cdf$var$wl;
    } catch (a) {}
}
$83d1223ef65e1cdf$export$ae55be85d98224ed = $83d1223ef65e1cdf$var$tl;
$83d1223ef65e1cdf$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$83d1223ef65e1cdf$var$ol(b)) throw Error($83d1223ef65e1cdf$var$p(200));
    return $83d1223ef65e1cdf$var$dl(a, b, null, c);
};
$83d1223ef65e1cdf$export$882461b6382ed46c = function(a, b) {
    if (!$83d1223ef65e1cdf$var$ol(a)) throw Error($83d1223ef65e1cdf$var$p(299));
    var c = !1, d = "", e = $83d1223ef65e1cdf$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $83d1223ef65e1cdf$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$83d1223ef65e1cdf$var$uf] = b.current;
    $83d1223ef65e1cdf$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $83d1223ef65e1cdf$var$ml(b);
};
$83d1223ef65e1cdf$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($83d1223ef65e1cdf$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($83d1223ef65e1cdf$var$p(268, a));
    }
    a = $83d1223ef65e1cdf$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$83d1223ef65e1cdf$export$cd75ccfd720a3cd4 = function(a) {
    return $83d1223ef65e1cdf$var$Sk(a);
};
$83d1223ef65e1cdf$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$83d1223ef65e1cdf$var$pl(b)) throw Error($83d1223ef65e1cdf$var$p(200));
    return $83d1223ef65e1cdf$var$sl(null, a, b, !0, c);
};
$83d1223ef65e1cdf$export$757ceba2d55c277e = function(a, b, c) {
    if (!$83d1223ef65e1cdf$var$ol(a)) throw Error($83d1223ef65e1cdf$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $83d1223ef65e1cdf$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $83d1223ef65e1cdf$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$83d1223ef65e1cdf$var$uf] = b.current;
    $83d1223ef65e1cdf$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $83d1223ef65e1cdf$var$nl(b);
};
$83d1223ef65e1cdf$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$83d1223ef65e1cdf$var$pl(b)) throw Error($83d1223ef65e1cdf$var$p(200));
    return $83d1223ef65e1cdf$var$sl(null, a, b, !1, c);
};
$83d1223ef65e1cdf$export$502457920280e6be = function(a) {
    if (!$83d1223ef65e1cdf$var$pl(a)) throw Error($83d1223ef65e1cdf$var$p(40));
    return a._reactRootContainer ? ($83d1223ef65e1cdf$var$Sk(function() {
        $83d1223ef65e1cdf$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$83d1223ef65e1cdf$var$uf] = null;
        });
    }), !0) : !1;
};
$83d1223ef65e1cdf$export$c78a37762a8d58e1 = $83d1223ef65e1cdf$var$Rk;
$83d1223ef65e1cdf$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$83d1223ef65e1cdf$var$pl(c)) throw Error($83d1223ef65e1cdf$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($83d1223ef65e1cdf$var$p(38));
    return $83d1223ef65e1cdf$var$sl(a, b, c, !1, d);
};
$83d1223ef65e1cdf$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("hMJeX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hB7sJ"));

});
parcelRegister("hB7sJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ccfbae40d3c4ba6c$export$c4744153514ff05d; }, function (v) { return $ccfbae40d3c4ba6c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ccfbae40d3c4ba6c$export$3e506c1ccc9cc1a7; }, function (v) { return $ccfbae40d3c4ba6c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ccfbae40d3c4ba6c$export$e26fe2ed2fa76875; }, function (v) { return $ccfbae40d3c4ba6c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ccfbae40d3c4ba6c$export$502329bbf4b505b1; }, function (v) { return $ccfbae40d3c4ba6c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ccfbae40d3c4ba6c$export$6e3807111c4874c4; }, function (v) { return $ccfbae40d3c4ba6c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ccfbae40d3c4ba6c$export$c27134553091fb3a; }, function (v) { return $ccfbae40d3c4ba6c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ccfbae40d3c4ba6c$export$33ee1acdc04fd2a2; }, function (v) { return $ccfbae40d3c4ba6c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ccfbae40d3c4ba6c$export$b00a404bbd5edef2; }, function (v) { return $ccfbae40d3c4ba6c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ccfbae40d3c4ba6c$export$8352ce38b91d0c62; }, function (v) { return $ccfbae40d3c4ba6c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ccfbae40d3c4ba6c$export$d66a1c1c77bd778b; }, function (v) { return $ccfbae40d3c4ba6c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ccfbae40d3c4ba6c$export$d3dfb8e4810cb555; }, function (v) { return $ccfbae40d3c4ba6c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ccfbae40d3c4ba6c$export$839f9183b0465a69; }, function (v) { return $ccfbae40d3c4ba6c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ccfbae40d3c4ba6c$export$72fdf0e06517287b; }, function (v) { return $ccfbae40d3c4ba6c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ccfbae40d3c4ba6c$export$4b844e58a3e414b4; }, function (v) { return $ccfbae40d3c4ba6c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ccfbae40d3c4ba6c$export$816d2913ae6b83b1; }, function (v) { return $ccfbae40d3c4ba6c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ccfbae40d3c4ba6c$export$61bcfe829111a1d0; }, function (v) { return $ccfbae40d3c4ba6c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ccfbae40d3c4ba6c$export$7ee8c9beb337bc3f; }, function (v) { return $ccfbae40d3c4ba6c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ccfbae40d3c4ba6c$export$b5836b71941fa3ed; }, function (v) { return $ccfbae40d3c4ba6c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ccfbae40d3c4ba6c$export$cf845f2c119da08a; }, function (v) { return $ccfbae40d3c4ba6c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ccfbae40d3c4ba6c$export$c4744153514ff05d;
var $ccfbae40d3c4ba6c$export$3e506c1ccc9cc1a7;
var $ccfbae40d3c4ba6c$export$e26fe2ed2fa76875;
var $ccfbae40d3c4ba6c$export$502329bbf4b505b1;
var $ccfbae40d3c4ba6c$export$6e3807111c4874c4;
var $ccfbae40d3c4ba6c$export$c27134553091fb3a;
var $ccfbae40d3c4ba6c$export$33ee1acdc04fd2a2;
var $ccfbae40d3c4ba6c$export$b00a404bbd5edef2;
var $ccfbae40d3c4ba6c$export$8352ce38b91d0c62;
var $ccfbae40d3c4ba6c$export$d66a1c1c77bd778b;
var $ccfbae40d3c4ba6c$export$d3dfb8e4810cb555;
var $ccfbae40d3c4ba6c$export$839f9183b0465a69;
var $ccfbae40d3c4ba6c$export$72fdf0e06517287b;
var $ccfbae40d3c4ba6c$export$4b844e58a3e414b4;
var $ccfbae40d3c4ba6c$export$816d2913ae6b83b1;
var $ccfbae40d3c4ba6c$export$61bcfe829111a1d0;
var $ccfbae40d3c4ba6c$export$7ee8c9beb337bc3f;
var $ccfbae40d3c4ba6c$export$b5836b71941fa3ed;
var $ccfbae40d3c4ba6c$export$cf845f2c119da08a;
"use strict";
function $ccfbae40d3c4ba6c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ccfbae40d3c4ba6c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ccfbae40d3c4ba6c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ccfbae40d3c4ba6c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ccfbae40d3c4ba6c$var$g(C, c)) n < e && 0 > $ccfbae40d3c4ba6c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ccfbae40d3c4ba6c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ccfbae40d3c4ba6c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ccfbae40d3c4ba6c$var$l = performance;
    $ccfbae40d3c4ba6c$export$c4744153514ff05d = function() {
        return $ccfbae40d3c4ba6c$var$l.now();
    };
} else {
    var $ccfbae40d3c4ba6c$var$p = Date, $ccfbae40d3c4ba6c$var$q = $ccfbae40d3c4ba6c$var$p.now();
    $ccfbae40d3c4ba6c$export$c4744153514ff05d = function() {
        return $ccfbae40d3c4ba6c$var$p.now() - $ccfbae40d3c4ba6c$var$q;
    };
}
var $ccfbae40d3c4ba6c$var$r = [], $ccfbae40d3c4ba6c$var$t = [], $ccfbae40d3c4ba6c$var$u = 1, $ccfbae40d3c4ba6c$var$v = null, $ccfbae40d3c4ba6c$var$y = 3, $ccfbae40d3c4ba6c$var$z = !1, $ccfbae40d3c4ba6c$var$A = !1, $ccfbae40d3c4ba6c$var$B = !1, $ccfbae40d3c4ba6c$var$D = "function" === typeof setTimeout ? setTimeout : null, $ccfbae40d3c4ba6c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ccfbae40d3c4ba6c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ccfbae40d3c4ba6c$var$G(a) {
    for(var b = $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$t); null !== b;){
        if (null === b.callback) $ccfbae40d3c4ba6c$var$k($ccfbae40d3c4ba6c$var$t);
        else if (b.startTime <= a) $ccfbae40d3c4ba6c$var$k($ccfbae40d3c4ba6c$var$t), b.sortIndex = b.expirationTime, $ccfbae40d3c4ba6c$var$f($ccfbae40d3c4ba6c$var$r, b);
        else break;
        b = $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$t);
    }
}
function $ccfbae40d3c4ba6c$var$H(a) {
    $ccfbae40d3c4ba6c$var$B = !1;
    $ccfbae40d3c4ba6c$var$G(a);
    if (!$ccfbae40d3c4ba6c$var$A) {
        if (null !== $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$r)) $ccfbae40d3c4ba6c$var$A = !0, $ccfbae40d3c4ba6c$var$I($ccfbae40d3c4ba6c$var$J);
        else {
            var b = $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$t);
            null !== b && $ccfbae40d3c4ba6c$var$K($ccfbae40d3c4ba6c$var$H, b.startTime - a);
        }
    }
}
function $ccfbae40d3c4ba6c$var$J(a, b) {
    $ccfbae40d3c4ba6c$var$A = !1;
    $ccfbae40d3c4ba6c$var$B && ($ccfbae40d3c4ba6c$var$B = !1, $ccfbae40d3c4ba6c$var$E($ccfbae40d3c4ba6c$var$L), $ccfbae40d3c4ba6c$var$L = -1);
    $ccfbae40d3c4ba6c$var$z = !0;
    var c = $ccfbae40d3c4ba6c$var$y;
    try {
        $ccfbae40d3c4ba6c$var$G(b);
        for($ccfbae40d3c4ba6c$var$v = $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$r); null !== $ccfbae40d3c4ba6c$var$v && (!($ccfbae40d3c4ba6c$var$v.expirationTime > b) || a && !$ccfbae40d3c4ba6c$var$M());){
            var d = $ccfbae40d3c4ba6c$var$v.callback;
            if ("function" === typeof d) {
                $ccfbae40d3c4ba6c$var$v.callback = null;
                $ccfbae40d3c4ba6c$var$y = $ccfbae40d3c4ba6c$var$v.priorityLevel;
                var e = d($ccfbae40d3c4ba6c$var$v.expirationTime <= b);
                b = $ccfbae40d3c4ba6c$export$c4744153514ff05d();
                "function" === typeof e ? $ccfbae40d3c4ba6c$var$v.callback = e : $ccfbae40d3c4ba6c$var$v === $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$r) && $ccfbae40d3c4ba6c$var$k($ccfbae40d3c4ba6c$var$r);
                $ccfbae40d3c4ba6c$var$G(b);
            } else $ccfbae40d3c4ba6c$var$k($ccfbae40d3c4ba6c$var$r);
            $ccfbae40d3c4ba6c$var$v = $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$r);
        }
        if (null !== $ccfbae40d3c4ba6c$var$v) var w = !0;
        else {
            var m = $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$t);
            null !== m && $ccfbae40d3c4ba6c$var$K($ccfbae40d3c4ba6c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ccfbae40d3c4ba6c$var$v = null, $ccfbae40d3c4ba6c$var$y = c, $ccfbae40d3c4ba6c$var$z = !1;
    }
}
var $ccfbae40d3c4ba6c$var$N = !1, $ccfbae40d3c4ba6c$var$O = null, $ccfbae40d3c4ba6c$var$L = -1, $ccfbae40d3c4ba6c$var$P = 5, $ccfbae40d3c4ba6c$var$Q = -1;
function $ccfbae40d3c4ba6c$var$M() {
    return $ccfbae40d3c4ba6c$export$c4744153514ff05d() - $ccfbae40d3c4ba6c$var$Q < $ccfbae40d3c4ba6c$var$P ? !1 : !0;
}
function $ccfbae40d3c4ba6c$var$R() {
    if (null !== $ccfbae40d3c4ba6c$var$O) {
        var a = $ccfbae40d3c4ba6c$export$c4744153514ff05d();
        $ccfbae40d3c4ba6c$var$Q = a;
        var b = !0;
        try {
            b = $ccfbae40d3c4ba6c$var$O(!0, a);
        } finally{
            b ? $ccfbae40d3c4ba6c$var$S() : ($ccfbae40d3c4ba6c$var$N = !1, $ccfbae40d3c4ba6c$var$O = null);
        }
    } else $ccfbae40d3c4ba6c$var$N = !1;
}
var $ccfbae40d3c4ba6c$var$S;
if ("function" === typeof $ccfbae40d3c4ba6c$var$F) $ccfbae40d3c4ba6c$var$S = function() {
    $ccfbae40d3c4ba6c$var$F($ccfbae40d3c4ba6c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ccfbae40d3c4ba6c$var$T = new MessageChannel, $ccfbae40d3c4ba6c$var$U = $ccfbae40d3c4ba6c$var$T.port2;
    $ccfbae40d3c4ba6c$var$T.port1.onmessage = $ccfbae40d3c4ba6c$var$R;
    $ccfbae40d3c4ba6c$var$S = function() {
        $ccfbae40d3c4ba6c$var$U.postMessage(null);
    };
} else $ccfbae40d3c4ba6c$var$S = function() {
    $ccfbae40d3c4ba6c$var$D($ccfbae40d3c4ba6c$var$R, 0);
};
function $ccfbae40d3c4ba6c$var$I(a) {
    $ccfbae40d3c4ba6c$var$O = a;
    $ccfbae40d3c4ba6c$var$N || ($ccfbae40d3c4ba6c$var$N = !0, $ccfbae40d3c4ba6c$var$S());
}
function $ccfbae40d3c4ba6c$var$K(a, b) {
    $ccfbae40d3c4ba6c$var$L = $ccfbae40d3c4ba6c$var$D(function() {
        a($ccfbae40d3c4ba6c$export$c4744153514ff05d());
    }, b);
}
$ccfbae40d3c4ba6c$export$3e506c1ccc9cc1a7 = 5;
$ccfbae40d3c4ba6c$export$e26fe2ed2fa76875 = 1;
$ccfbae40d3c4ba6c$export$502329bbf4b505b1 = 4;
$ccfbae40d3c4ba6c$export$6e3807111c4874c4 = 3;
$ccfbae40d3c4ba6c$export$c27134553091fb3a = null;
$ccfbae40d3c4ba6c$export$33ee1acdc04fd2a2 = 2;
$ccfbae40d3c4ba6c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ccfbae40d3c4ba6c$export$8352ce38b91d0c62 = function() {
    $ccfbae40d3c4ba6c$var$A || $ccfbae40d3c4ba6c$var$z || ($ccfbae40d3c4ba6c$var$A = !0, $ccfbae40d3c4ba6c$var$I($ccfbae40d3c4ba6c$var$J));
};
$ccfbae40d3c4ba6c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ccfbae40d3c4ba6c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ccfbae40d3c4ba6c$export$d3dfb8e4810cb555 = function() {
    return $ccfbae40d3c4ba6c$var$y;
};
$ccfbae40d3c4ba6c$export$839f9183b0465a69 = function() {
    return $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$r);
};
$ccfbae40d3c4ba6c$export$72fdf0e06517287b = function(a) {
    switch($ccfbae40d3c4ba6c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ccfbae40d3c4ba6c$var$y;
    }
    var c = $ccfbae40d3c4ba6c$var$y;
    $ccfbae40d3c4ba6c$var$y = b;
    try {
        return a();
    } finally{
        $ccfbae40d3c4ba6c$var$y = c;
    }
};
$ccfbae40d3c4ba6c$export$4b844e58a3e414b4 = function() {};
$ccfbae40d3c4ba6c$export$816d2913ae6b83b1 = function() {};
$ccfbae40d3c4ba6c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ccfbae40d3c4ba6c$var$y;
    $ccfbae40d3c4ba6c$var$y = a;
    try {
        return b();
    } finally{
        $ccfbae40d3c4ba6c$var$y = c;
    }
};
$ccfbae40d3c4ba6c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ccfbae40d3c4ba6c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ccfbae40d3c4ba6c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ccfbae40d3c4ba6c$var$f($ccfbae40d3c4ba6c$var$t, a), null === $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$r) && a === $ccfbae40d3c4ba6c$var$h($ccfbae40d3c4ba6c$var$t) && ($ccfbae40d3c4ba6c$var$B ? ($ccfbae40d3c4ba6c$var$E($ccfbae40d3c4ba6c$var$L), $ccfbae40d3c4ba6c$var$L = -1) : $ccfbae40d3c4ba6c$var$B = !0, $ccfbae40d3c4ba6c$var$K($ccfbae40d3c4ba6c$var$H, c - d))) : (a.sortIndex = e, $ccfbae40d3c4ba6c$var$f($ccfbae40d3c4ba6c$var$r, a), $ccfbae40d3c4ba6c$var$A || $ccfbae40d3c4ba6c$var$z || ($ccfbae40d3c4ba6c$var$A = !0, $ccfbae40d3c4ba6c$var$I($ccfbae40d3c4ba6c$var$J)));
    return a;
};
$ccfbae40d3c4ba6c$export$b5836b71941fa3ed = $ccfbae40d3c4ba6c$var$M;
$ccfbae40d3c4ba6c$export$cf845f2c119da08a = function(a) {
    var b = $ccfbae40d3c4ba6c$var$y;
    return function() {
        var c = $ccfbae40d3c4ba6c$var$y;
        $ccfbae40d3c4ba6c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ccfbae40d3c4ba6c$var$y = c;
        }
    };
};

});



parcelRegister("c8wto", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $8d5f6bd93439685b$export$bf730a2d8bf68b42; }, function (v) { return $8d5f6bd93439685b$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8d5f6bd93439685b$export$bf730a2d8bf68b42;
"use strict";

var $6YKZt = parcelRequire("6YKZt");
function $8d5f6bd93439685b$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8d5f6bd93439685b$var$p = "function" === typeof Object.is ? Object.is : $8d5f6bd93439685b$var$n, $8d5f6bd93439685b$var$q = $6YKZt.useSyncExternalStore, $8d5f6bd93439685b$var$r = $6YKZt.useRef, $8d5f6bd93439685b$var$t = $6YKZt.useEffect, $8d5f6bd93439685b$var$u = $6YKZt.useMemo, $8d5f6bd93439685b$var$v = $6YKZt.useDebugValue;
$8d5f6bd93439685b$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $8d5f6bd93439685b$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $8d5f6bd93439685b$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($8d5f6bd93439685b$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $8d5f6bd93439685b$var$q(a, c[0], c[1]);
    $8d5f6bd93439685b$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $8d5f6bd93439685b$var$v(d);
    return d;
};

});

parcelRegister("6I9Dd", function(module, exports) {

var $cf8Qw = parcelRequire("cf8Qw");
module.exports = $cf8Qw("eQO7j").then(()=>parcelRequire("5bma8"));

});
parcelRegister("cf8Qw", function(module, exports) {
"use strict";

function $8e9dbf6b227d9ca3$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("lXnmw")).resolve(id));
}
module.exports = $8e9dbf6b227d9ca3$var$load;

});



var $2RmP6 = parcelRequire("2RmP6");

var $6YKZt = parcelRequire("6YKZt");
var $86f431360e84be50$exports = {};

$parcel$export($86f431360e84be50$exports, "createRoot", function () { return $86f431360e84be50$export$882461b6382ed46c; }, function (v) { return $86f431360e84be50$export$882461b6382ed46c = v; });
$parcel$export($86f431360e84be50$exports, "hydrateRoot", function () { return $86f431360e84be50$export$757ceba2d55c277e; }, function (v) { return $86f431360e84be50$export$757ceba2d55c277e = v; });
var $86f431360e84be50$export$882461b6382ed46c;
var $86f431360e84be50$export$757ceba2d55c277e;
"use strict";
var $c1a87c920c636bce$exports = {};
"use strict";
function $c1a87c920c636bce$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c1a87c920c636bce$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c1a87c920c636bce$var$checkDCE();

$c1a87c920c636bce$exports = (parcelRequire("bjEOX"));


var $86f431360e84be50$var$i;
$86f431360e84be50$export$882461b6382ed46c = $c1a87c920c636bce$exports.createRoot;
$86f431360e84be50$export$757ceba2d55c277e = $c1a87c920c636bce$exports.hydrateRoot;



var $2RmP6 = parcelRequire("2RmP6");
const $1f80689291b57452$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_264,h_288,c_fill/";
const $1f80689291b57452$export$cd85698b2b1026a5 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";
const $1f80689291b57452$export$8878ead86ed0da0b = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdaMYtVi9_tfNcpsbGGseU6ehYgV9UeU3h7A&usqp=CAU ";
const $1f80689291b57452$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=" //  multifile used named exports
;



var $6YKZt = parcelRequire("6YKZt");
/**
 * React Router DOM v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6YKZt = parcelRequire("6YKZt");
/**
 * @remix-run/router v1.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e0c55ef9edbf5c6a$var$_extends() {
    $e0c55ef9edbf5c6a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0c55ef9edbf5c6a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e0c55ef9edbf5c6a$export$e19cd5f9376f8cee || ($e0c55ef9edbf5c6a$export$e19cd5f9376f8cee = {}));
const $e0c55ef9edbf5c6a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e0c55ef9edbf5c6a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e0c55ef9edbf5c6a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e0c55ef9edbf5c6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e0c55ef9edbf5c6a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e0c55ef9edbf5c6a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e0c55ef9edbf5c6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e0c55ef9edbf5c6a$export$fe53371bee54353d(to);
    }
    return $e0c55ef9edbf5c6a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e0c55ef9edbf5c6a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e0c55ef9edbf5c6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e0c55ef9edbf5c6a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e0c55ef9edbf5c6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e0c55ef9edbf5c6a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e0c55ef9edbf5c6a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e0c55ef9edbf5c6a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e0c55ef9edbf5c6a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e0c55ef9edbf5c6a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e0c55ef9edbf5c6a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e0c55ef9edbf5c6a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e0c55ef9edbf5c6a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e0c55ef9edbf5c6a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e0c55ef9edbf5c6a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e0c55ef9edbf5c6a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Push;
        let location = $e0c55ef9edbf5c6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e0c55ef9edbf5c6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Replace;
        let location = $e0c55ef9edbf5c6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e0c55ef9edbf5c6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e0c55ef9edbf5c6a$export$fe53371bee54353d(to);
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e0c55ef9edbf5c6a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e0c55ef9edbf5c6a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e0c55ef9edbf5c6a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e0c55ef9edbf5c6a$var$ResultType || ($e0c55ef9edbf5c6a$var$ResultType = {}));
const $e0c55ef9edbf5c6a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e0c55ef9edbf5c6a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e0c55ef9edbf5c6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($e0c55ef9edbf5c6a$var$isIndexRoute(route)) {
            let indexRoute = $e0c55ef9edbf5c6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e0c55ef9edbf5c6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e0c55ef9edbf5c6a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $e0c55ef9edbf5c6a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e0c55ef9edbf5c6a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e0c55ef9edbf5c6a$var$flattenRoutes(routes);
    $e0c55ef9edbf5c6a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $e0c55ef9edbf5c6a$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $e0c55ef9edbf5c6a$var$safelyDecodeURI(pathname));
    return matches;
}
function $e0c55ef9edbf5c6a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e0c55ef9edbf5c6a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e0c55ef9edbf5c6a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $e0c55ef9edbf5c6a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e0c55ef9edbf5c6a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e0c55ef9edbf5c6a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e0c55ef9edbf5c6a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e0c55ef9edbf5c6a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e0c55ef9edbf5c6a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e0c55ef9edbf5c6a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e0c55ef9edbf5c6a$var$paramRe = /^:\w+$/;
const $e0c55ef9edbf5c6a$var$dynamicSegmentValue = 3;
const $e0c55ef9edbf5c6a$var$indexRouteValue = 2;
const $e0c55ef9edbf5c6a$var$emptySegmentValue = 1;
const $e0c55ef9edbf5c6a$var$staticSegmentValue = 10;
const $e0c55ef9edbf5c6a$var$splatPenalty = -2;
const $e0c55ef9edbf5c6a$var$isSplat = (s)=>s === "*";
function $e0c55ef9edbf5c6a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e0c55ef9edbf5c6a$var$isSplat)) initialScore += $e0c55ef9edbf5c6a$var$splatPenalty;
    if (index) initialScore += $e0c55ef9edbf5c6a$var$indexRouteValue;
    return segments.filter((s)=>!$e0c55ef9edbf5c6a$var$isSplat(s)).reduce((score, segment)=>score + ($e0c55ef9edbf5c6a$var$paramRe.test(segment) ? $e0c55ef9edbf5c6a$var$dynamicSegmentValue : segment === "" ? $e0c55ef9edbf5c6a$var$emptySegmentValue : $e0c55ef9edbf5c6a$var$staticSegmentValue), initialScore);
}
function $e0c55ef9edbf5c6a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e0c55ef9edbf5c6a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e0c55ef9edbf5c6a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e0c55ef9edbf5c6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e0c55ef9edbf5c6a$export$a5c6d149b50c1d86($e0c55ef9edbf5c6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e0c55ef9edbf5c6a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $e0c55ef9edbf5c6a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e0c55ef9edbf5c6a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $e0c55ef9edbf5c6a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $e0c55ef9edbf5c6a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $e0c55ef9edbf5c6a$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e0c55ef9edbf5c6a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e0c55ef9edbf5c6a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $e0c55ef9edbf5c6a$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $e0c55ef9edbf5c6a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $e0c55ef9edbf5c6a$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $e0c55ef9edbf5c6a$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e0c55ef9edbf5c6a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $e0c55ef9edbf5c6a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $e0c55ef9edbf5c6a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $e0c55ef9edbf5c6a$var$normalizeSearch(search),
        hash: $e0c55ef9edbf5c6a$var$normalizeHash(hash)
    };
}
function $e0c55ef9edbf5c6a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e0c55ef9edbf5c6a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e0c55ef9edbf5c6a$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $e0c55ef9edbf5c6a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e0c55ef9edbf5c6a$var$_extends({}, toArg);
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e0c55ef9edbf5c6a$var$getInvalidPathError("?", "pathname", "search", to));
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e0c55ef9edbf5c6a$var$getInvalidPathError("#", "pathname", "hash", to));
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e0c55ef9edbf5c6a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e0c55ef9edbf5c6a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e0c55ef9edbf5c6a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $e0c55ef9edbf5c6a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e0c55ef9edbf5c6a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e0c55ef9edbf5c6a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e0c55ef9edbf5c6a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $e0c55ef9edbf5c6a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e0c55ef9edbf5c6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e0c55ef9edbf5c6a$export$42a99a7a4bc0e76a extends Error {
}
class $e0c55ef9edbf5c6a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e0c55ef9edbf5c6a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e0c55ef9edbf5c6a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $e0c55ef9edbf5c6a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e0c55ef9edbf5c6a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e0c55ef9edbf5c6a$var$unwrapTrackedPromise(value) {
    if (!$e0c55ef9edbf5c6a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $e0c55ef9edbf5c6a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e0c55ef9edbf5c6a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e0c55ef9edbf5c6a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e0c55ef9edbf5c6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e0c55ef9edbf5c6a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e0c55ef9edbf5c6a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e0c55ef9edbf5c6a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e0c55ef9edbf5c6a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e0c55ef9edbf5c6a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e0c55ef9edbf5c6a$var$validMutationMethods = new Set($e0c55ef9edbf5c6a$var$validMutationMethodsArr);
const $e0c55ef9edbf5c6a$var$validRequestMethodsArr = [
    "get",
    ...$e0c55ef9edbf5c6a$var$validMutationMethodsArr
];
const $e0c55ef9edbf5c6a$var$validRequestMethods = new Set($e0c55ef9edbf5c6a$var$validRequestMethodsArr);
const $e0c55ef9edbf5c6a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e0c55ef9edbf5c6a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e0c55ef9edbf5c6a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e0c55ef9edbf5c6a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e0c55ef9edbf5c6a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e0c55ef9edbf5c6a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e0c55ef9edbf5c6a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e0c55ef9edbf5c6a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e0c55ef9edbf5c6a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e0c55ef9edbf5c6a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e0c55ef9edbf5c6a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e0c55ef9edbf5c6a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $e0c55ef9edbf5c6a$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e0c55ef9edbf5c6a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e0c55ef9edbf5c6a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e0c55ef9edbf5c6a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $e0c55ef9edbf5c6a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e0c55ef9edbf5c6a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e0c55ef9edbf5c6a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e0c55ef9edbf5c6a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $e0c55ef9edbf5c6a$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state, {
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e0c55ef9edbf5c6a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e0c55ef9edbf5c6a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e0c55ef9edbf5c6a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e0c55ef9edbf5c6a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e0c55ef9edbf5c6a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e0c55ef9edbf5c6a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e0c55ef9edbf5c6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e0c55ef9edbf5c6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e0c55ef9edbf5c6a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e0c55ef9edbf5c6a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e0c55ef9edbf5c6a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e0c55ef9edbf5c6a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $e0c55ef9edbf5c6a$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e0c55ef9edbf5c6a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $e0c55ef9edbf5c6a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e0c55ef9edbf5c6a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e0c55ef9edbf5c6a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$e0c55ef9edbf5c6a$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $e0c55ef9edbf5c6a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $e0c55ef9edbf5c6a$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e0c55ef9edbf5c6a$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e0c55ef9edbf5c6a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $e0c55ef9edbf5c6a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e0c55ef9edbf5c6a$var$ResultType.error,
            error: $e0c55ef9edbf5c6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $e0c55ef9edbf5c6a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e0c55ef9edbf5c6a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e0c55ef9edbf5c6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e0c55ef9edbf5c6a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($e0c55ef9edbf5c6a$var$isDeferredResult(result)) throw $e0c55ef9edbf5c6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e0c55ef9edbf5c6a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e0c55ef9edbf5c6a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e0c55ef9edbf5c6a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e0c55ef9edbf5c6a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $e0c55ef9edbf5c6a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($e0c55ef9edbf5c6a$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e0c55ef9edbf5c6a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e0c55ef9edbf5c6a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e0c55ef9edbf5c6a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $e0c55ef9edbf5c6a$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e0c55ef9edbf5c6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e0c55ef9edbf5c6a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $e0c55ef9edbf5c6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $e0c55ef9edbf5c6a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e0c55ef9edbf5c6a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $e0c55ef9edbf5c6a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $e0c55ef9edbf5c6a$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $e0c55ef9edbf5c6a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $e0c55ef9edbf5c6a$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($e0c55ef9edbf5c6a$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $e0c55ef9edbf5c6a$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $e0c55ef9edbf5c6a$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($e0c55ef9edbf5c6a$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($e0c55ef9edbf5c6a$var$isDeferredResult(actionResult)) throw $e0c55ef9edbf5c6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e0c55ef9edbf5c6a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e0c55ef9edbf5c6a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e0c55ef9edbf5c6a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e0c55ef9edbf5c6a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e0c55ef9edbf5c6a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e0c55ef9edbf5c6a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e0c55ef9edbf5c6a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e0c55ef9edbf5c6a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($e0c55ef9edbf5c6a$var$_extends({
                errors: errors,
                loaderData: $e0c55ef9edbf5c6a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $e0c55ef9edbf5c6a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $e0c55ef9edbf5c6a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $e0c55ef9edbf5c6a$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e0c55ef9edbf5c6a$var$isDeferredResult(result)) result = await $e0c55ef9edbf5c6a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e0c55ef9edbf5c6a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $e0c55ef9edbf5c6a$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e0c55ef9edbf5c6a$var$isErrorResult(result)) {
            let boundaryMatch = $e0c55ef9edbf5c6a$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(!$e0c55ef9edbf5c6a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $e0c55ef9edbf5c6a$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $e0c55ef9edbf5c6a$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e0c55ef9edbf5c6a$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e0c55ef9edbf5c6a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Replace : $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e0c55ef9edbf5c6a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e0c55ef9edbf5c6a$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $e0c55ef9edbf5c6a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e0c55ef9edbf5c6a$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e0c55ef9edbf5c6a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$e0c55ef9edbf5c6a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $e0c55ef9edbf5c6a$var$callLoaderOrAction("loader", $e0c55ef9edbf5c6a$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $e0c55ef9edbf5c6a$var$ResultType.error,
                        error: $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $e0c55ef9edbf5c6a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $e0c55ef9edbf5c6a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $e0c55ef9edbf5c6a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e0c55ef9edbf5c6a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e0c55ef9edbf5c6a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e0c55ef9edbf5c6a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e0c55ef9edbf5c6a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e0c55ef9edbf5c6a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e0c55ef9edbf5c6a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e0c55ef9edbf5c6a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e0c55ef9edbf5c6a$export$4d0306f8f6a4585b = Symbol("deferred");
function $e0c55ef9edbf5c6a$export$3336b097a6fbc59a(routes, opts) {
    $e0c55ef9edbf5c6a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e0c55ef9edbf5c6a$var$defaultMapRouteProperties;
    let dataRoutes = $e0c55ef9edbf5c6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e0c55ef9edbf5c6a$var$createLocation("", $e0c55ef9edbf5c6a$export$fe53371bee54353d(url), null, "default");
        let matches = $e0c55ef9edbf5c6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e0c55ef9edbf5c6a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e0c55ef9edbf5c6a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e0c55ef9edbf5c6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e0c55ef9edbf5c6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($e0c55ef9edbf5c6a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e0c55ef9edbf5c6a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e0c55ef9edbf5c6a$var$createLocation("", $e0c55ef9edbf5c6a$export$fe53371bee54353d(url), null, "default");
        let matches = $e0c55ef9edbf5c6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e0c55ef9edbf5c6a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e0c55ef9edbf5c6a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e0c55ef9edbf5c6a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e0c55ef9edbf5c6a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($e0c55ef9edbf5c6a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e0c55ef9edbf5c6a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e0c55ef9edbf5c6a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e0c55ef9edbf5c6a$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $e0c55ef9edbf5c6a$var$isResponse(result) ? result : $e0c55ef9edbf5c6a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($e0c55ef9edbf5c6a$var$isQueryRouteResponse(e)) {
                if (e.type === $e0c55ef9edbf5c6a$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e0c55ef9edbf5c6a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e0c55ef9edbf5c6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e0c55ef9edbf5c6a$var$ResultType.error,
                error: error
            };
        } else {
            result = await $e0c55ef9edbf5c6a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($e0c55ef9edbf5c6a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($e0c55ef9edbf5c6a$var$isDeferredResult(result)) {
            let error = $e0c55ef9edbf5c6a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e0c55ef9edbf5c6a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e0c55ef9edbf5c6a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($e0c55ef9edbf5c6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e0c55ef9edbf5c6a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $e0c55ef9edbf5c6a$var$_extends({}, context, {
                statusCode: $e0c55ef9edbf5c6a$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $e0c55ef9edbf5c6a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $e0c55ef9edbf5c6a$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $e0c55ef9edbf5c6a$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e0c55ef9edbf5c6a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $e0c55ef9edbf5c6a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$e0c55ef9edbf5c6a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e0c55ef9edbf5c6a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e0c55ef9edbf5c6a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e0c55ef9edbf5c6a$export$fec11da027c70692(routes, context, error) {
    let newContext = $e0c55ef9edbf5c6a$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e0c55ef9edbf5c6a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e0c55ef9edbf5c6a$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e0c55ef9edbf5c6a$export$cae722b0cc860f13(to ? to : ".", $e0c55ef9edbf5c6a$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $e0c55ef9edbf5c6a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$e0c55ef9edbf5c6a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e0c55ef9edbf5c6a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e0c55ef9edbf5c6a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e0c55ef9edbf5c6a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e0c55ef9edbf5c6a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e0c55ef9edbf5c6a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e0c55ef9edbf5c6a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e0c55ef9edbf5c6a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e0c55ef9edbf5c6a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e0c55ef9edbf5c6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e0c55ef9edbf5c6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e0c55ef9edbf5c6a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e0c55ef9edbf5c6a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e0c55ef9edbf5c6a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e0c55ef9edbf5c6a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e0c55ef9edbf5c6a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e0c55ef9edbf5c6a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e0c55ef9edbf5c6a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e0c55ef9edbf5c6a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $e0c55ef9edbf5c6a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $e0c55ef9edbf5c6a$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $e0c55ef9edbf5c6a$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($e0c55ef9edbf5c6a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e0c55ef9edbf5c6a$var$shouldRevalidateLoader(match, $e0c55ef9edbf5c6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e0c55ef9edbf5c6a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $e0c55ef9edbf5c6a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e0c55ef9edbf5c6a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e0c55ef9edbf5c6a$var$shouldRevalidateLoader(fetcherMatch, $e0c55ef9edbf5c6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e0c55ef9edbf5c6a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e0c55ef9edbf5c6a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e0c55ef9edbf5c6a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e0c55ef9edbf5c6a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e0c55ef9edbf5c6a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e0c55ef9edbf5c6a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$e0c55ef9edbf5c6a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e0c55ef9edbf5c6a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $e0c55ef9edbf5c6a$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $e0c55ef9edbf5c6a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $e0c55ef9edbf5c6a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e0c55ef9edbf5c6a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e0c55ef9edbf5c6a$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e0c55ef9edbf5c6a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $e0c55ef9edbf5c6a$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($e0c55ef9edbf5c6a$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($e0c55ef9edbf5c6a$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$e0c55ef9edbf5c6a$var$ABSOLUTE_URL_REGEX.test(location)) location = $e0c55ef9edbf5c6a$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $e0c55ef9edbf5c6a$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $e0c55ef9edbf5c6a$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $e0c55ef9edbf5c6a$var$ResultType.error ? $e0c55ef9edbf5c6a$var$ResultType.error : $e0c55ef9edbf5c6a$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $e0c55ef9edbf5c6a$var$ResultType.error) return {
            type: resultType,
            error: new $e0c55ef9edbf5c6a$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $e0c55ef9edbf5c6a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $e0c55ef9edbf5c6a$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($e0c55ef9edbf5c6a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $e0c55ef9edbf5c6a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $e0c55ef9edbf5c6a$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e0c55ef9edbf5c6a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e0c55ef9edbf5c6a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e0c55ef9edbf5c6a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e0c55ef9edbf5c6a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e0c55ef9edbf5c6a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e0c55ef9edbf5c6a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e0c55ef9edbf5c6a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(!$e0c55ef9edbf5c6a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e0c55ef9edbf5c6a$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $e0c55ef9edbf5c6a$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e0c55ef9edbf5c6a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($e0c55ef9edbf5c6a$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e0c55ef9edbf5c6a$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e0c55ef9edbf5c6a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($e0c55ef9edbf5c6a$var$isErrorResult(result)) {
            let boundaryMatch = $e0c55ef9edbf5c6a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e0c55ef9edbf5c6a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e0c55ef9edbf5c6a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e0c55ef9edbf5c6a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e0c55ef9edbf5c6a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e0c55ef9edbf5c6a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e0c55ef9edbf5c6a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e0c55ef9edbf5c6a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e0c55ef9edbf5c6a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e0c55ef9edbf5c6a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e0c55ef9edbf5c6a$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $e0c55ef9edbf5c6a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e0c55ef9edbf5c6a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($e0c55ef9edbf5c6a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $e0c55ef9edbf5c6a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(path) : path;
    return $e0c55ef9edbf5c6a$export$fe53371bee54353d($e0c55ef9edbf5c6a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e0c55ef9edbf5c6a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e0c55ef9edbf5c6a$var$isDeferredResult(result) {
    return result.type === $e0c55ef9edbf5c6a$var$ResultType.deferred;
}
function $e0c55ef9edbf5c6a$var$isErrorResult(result) {
    return result.type === $e0c55ef9edbf5c6a$var$ResultType.error;
}
function $e0c55ef9edbf5c6a$var$isRedirectResult(result) {
    return (result && result.type) === $e0c55ef9edbf5c6a$var$ResultType.redirect;
}
function $e0c55ef9edbf5c6a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e0c55ef9edbf5c6a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e0c55ef9edbf5c6a$var$isRedirectResponse(result) {
    if (!$e0c55ef9edbf5c6a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e0c55ef9edbf5c6a$var$isQueryRouteResponse(obj) {
    return obj && $e0c55ef9edbf5c6a$var$isResponse(obj.response) && (obj.type === $e0c55ef9edbf5c6a$var$ResultType.data || obj.type === $e0c55ef9edbf5c6a$var$ResultType.error);
}
function $e0c55ef9edbf5c6a$var$isValidMethod(method) {
    return $e0c55ef9edbf5c6a$var$validRequestMethods.has(method.toLowerCase());
}
function $e0c55ef9edbf5c6a$var$isMutationMethod(method) {
    return $e0c55ef9edbf5c6a$var$validMutationMethods.has(method.toLowerCase());
}
async function $e0c55ef9edbf5c6a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e0c55ef9edbf5c6a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e0c55ef9edbf5c6a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $e0c55ef9edbf5c6a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $e0c55ef9edbf5c6a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $e0c55ef9edbf5c6a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e0c55ef9edbf5c6a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e0c55ef9edbf5c6a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e0c55ef9edbf5c6a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e0c55ef9edbf5c6a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e0c55ef9edbf5c6a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e0c55ef9edbf5c6a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e0c55ef9edbf5c6a$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e0c55ef9edbf5c6a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e0c55ef9edbf5c6a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e0c55ef9edbf5c6a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e0c55ef9edbf5c6a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e0c55ef9edbf5c6a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e0c55ef9edbf5c6a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e0c55ef9edbf5c6a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e0c55ef9edbf5c6a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e0c55ef9edbf5c6a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e0c55ef9edbf5c6a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e0c55ef9edbf5c6a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6YKZt = parcelRequire("6YKZt");

function $57f032b757fa5634$var$_extends() {
    $57f032b757fa5634$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $57f032b757fa5634$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $57f032b757fa5634$export$3add0d5dce533e2e = /*#__PURE__*/ $6YKZt.createContext(null);
const $57f032b757fa5634$export$145dfa71566a64dc = /*#__PURE__*/ $6YKZt.createContext(null);
const $57f032b757fa5634$var$AwaitContext = /*#__PURE__*/ $6YKZt.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $57f032b757fa5634$export$26749e8557646306 = /*#__PURE__*/ $6YKZt.createContext(null);
const $57f032b757fa5634$export$c7914228fb69b0f5 = /*#__PURE__*/ $6YKZt.createContext(null);
const $57f032b757fa5634$export$9072aa6dd1f93057 = /*#__PURE__*/ $6YKZt.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $57f032b757fa5634$var$RouteErrorContext = /*#__PURE__*/ $6YKZt.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $57f032b757fa5634$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$57f032b757fa5634$export$9c954a9d03d32f4a() && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6YKZt.useContext($57f032b757fa5634$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $57f032b757fa5634$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $e0c55ef9edbf5c6a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $57f032b757fa5634$export$9c954a9d03d32f4a() {
    return $6YKZt.useContext($57f032b757fa5634$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $57f032b757fa5634$export$45d76561a5302f2b() {
    !$57f032b757fa5634$export$9c954a9d03d32f4a() && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return $6YKZt.useContext($57f032b757fa5634$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $57f032b757fa5634$export$1b3f31771c5d07c() {
    return $6YKZt.useContext($57f032b757fa5634$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $57f032b757fa5634$export$6c330e8992e8a295(pattern) {
    !$57f032b757fa5634$export$9c954a9d03d32f4a() && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $57f032b757fa5634$export$45d76561a5302f2b();
    return $6YKZt.useMemo(()=>(0, $e0c55ef9edbf5c6a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $57f032b757fa5634$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $57f032b757fa5634$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6YKZt.useContext($57f032b757fa5634$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6YKZt.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $57f032b757fa5634$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $57f032b757fa5634$var$useNavigateStable() : $57f032b757fa5634$var$useNavigateUnstable();
}
function $57f032b757fa5634$var$useNavigateUnstable() {
    !$57f032b757fa5634$export$9c954a9d03d32f4a() && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6YKZt.useContext($57f032b757fa5634$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $6YKZt.useContext($57f032b757fa5634$export$26749e8557646306);
    let { matches: matches } = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $57f032b757fa5634$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e0c55ef9edbf5c6a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $6YKZt.useRef(false);
    $57f032b757fa5634$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6YKZt.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $e0c55ef9edbf5c6a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e0c55ef9edbf5c6a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $57f032b757fa5634$var$OutletContext = /*#__PURE__*/ $6YKZt.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $57f032b757fa5634$export$4138103a3ae699cc() {
    return $6YKZt.useContext($57f032b757fa5634$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $57f032b757fa5634$export$a3be3530d8e40d0b(context) {
    let outlet = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $57f032b757fa5634$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $57f032b757fa5634$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $57f032b757fa5634$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e0c55ef9edbf5c6a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $6YKZt.useMemo(()=>(0, $e0c55ef9edbf5c6a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $57f032b757fa5634$export$5d3fca4a98652595(routes, locationArg) {
    return $57f032b757fa5634$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $57f032b757fa5634$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$57f032b757fa5634$export$9c954a9d03d32f4a() && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $6YKZt.useContext($57f032b757fa5634$export$26749e8557646306);
    let { matches: parentMatches } = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $57f032b757fa5634$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $e0c55ef9edbf5c6a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $57f032b757fa5634$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $e0c55ef9edbf5c6a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $e0c55ef9edbf5c6a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $57f032b757fa5634$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $57f032b757fa5634$var$DefaultErrorComponent() {
    let error = $57f032b757fa5634$export$ed527bf60f6e05f2();
    let message = (0, $e0c55ef9edbf5c6a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6YKZt.createElement($6YKZt.Fragment, null, /*#__PURE__*/ $6YKZt.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6YKZt.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6YKZt.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $57f032b757fa5634$var$defaultErrorElement = /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$DefaultErrorComponent, null);
class $57f032b757fa5634$var$RenderErrorBoundary extends $6YKZt.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $57f032b757fa5634$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6YKZt.useContext($57f032b757fa5634$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $57f032b757fa5634$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $57f032b757fa5634$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6YKZt.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $57f032b757fa5634$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($57f032b757fa5634$var$DataRouterHook || {});
var $57f032b757fa5634$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($57f032b757fa5634$var$DataRouterStateHook || {});
function $57f032b757fa5634$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $57f032b757fa5634$var$useDataRouterContext(hookName) {
    let ctx = $6YKZt.useContext($57f032b757fa5634$export$3add0d5dce533e2e);
    !ctx && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $57f032b757fa5634$var$useDataRouterState(hookName) {
    let state = $6YKZt.useContext($57f032b757fa5634$export$145dfa71566a64dc);
    !state && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return state;
}
function $57f032b757fa5634$var$useRouteContext(hookName) {
    let route = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    !route && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $57f032b757fa5634$var$useCurrentRouteId(hookName) {
    let route = $57f032b757fa5634$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $57f032b757fa5634$export$5fc8298006ad9e58() {
    return $57f032b757fa5634$var$useCurrentRouteId($57f032b757fa5634$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $57f032b757fa5634$export$d0fd4b7106de2769() {
    let state = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $57f032b757fa5634$export$600dc272ed516c15() {
    let dataRouterContext = $57f032b757fa5634$var$useDataRouterContext($57f032b757fa5634$var$DataRouterHook.UseRevalidator);
    let state = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseRevalidator);
    return $6YKZt.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $57f032b757fa5634$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseMatches);
    return $6YKZt.useMemo(()=>matches.map((m)=>(0, $e0c55ef9edbf5c6a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $57f032b757fa5634$export$1448a5050d252c4d() {
    let state = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseLoaderData);
    let routeId = $57f032b757fa5634$var$useCurrentRouteId($57f032b757fa5634$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $57f032b757fa5634$export$fd5d37484eab868d(routeId) {
    let state = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $57f032b757fa5634$export$fdc00f3f26066d5e() {
    let state = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseActionData);
    let route = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    !route && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $57f032b757fa5634$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6YKZt.useContext($57f032b757fa5634$var$RouteErrorContext);
    let state = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseRouteError);
    let routeId = $57f032b757fa5634$var$useCurrentRouteId($57f032b757fa5634$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $57f032b757fa5634$export$78a72ddb39bdd145() {
    let value = $6YKZt.useContext($57f032b757fa5634$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $57f032b757fa5634$export$17f53340677d5831() {
    let value = $6YKZt.useContext($57f032b757fa5634$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $57f032b757fa5634$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $57f032b757fa5634$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $57f032b757fa5634$var$useDataRouterContext($57f032b757fa5634$var$DataRouterHook.UseBlocker);
    let state = $57f032b757fa5634$var$useDataRouterState($57f032b757fa5634$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6YKZt.useState("");
    let blockerFunction = $6YKZt.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $57f032b757fa5634$var$_extends({}, currentLocation, {
                pathname: (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $57f032b757fa5634$var$_extends({}, nextLocation, {
                pathname: (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6YKZt.useEffect(()=>{
        let key = String(++$57f032b757fa5634$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6YKZt.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e0c55ef9edbf5c6a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $57f032b757fa5634$var$useNavigateStable() {
    let { router: router } = $57f032b757fa5634$var$useDataRouterContext($57f032b757fa5634$var$DataRouterHook.UseNavigateStable);
    let id = $57f032b757fa5634$var$useCurrentRouteId($57f032b757fa5634$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6YKZt.useRef(false);
    $57f032b757fa5634$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6YKZt.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $57f032b757fa5634$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $57f032b757fa5634$var$alreadyWarned = {};
function $57f032b757fa5634$var$warningOnce(key, cond, message) {
    if (!cond && !$57f032b757fa5634$var$alreadyWarned[key]) $57f032b757fa5634$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $57f032b757fa5634$var$START_TRANSITION = "startTransition";
const $57f032b757fa5634$var$startTransitionImpl = $6YKZt[$57f032b757fa5634$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $57f032b757fa5634$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6YKZt.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6YKZt.useCallback((newState)=>{
        if (v7_startTransition && $57f032b757fa5634$var$startTransitionImpl) $57f032b757fa5634$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6YKZt.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $6YKZt.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6YKZt.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6YKZt.createElement($6YKZt.Fragment, null, /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $57f032b757fa5634$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $57f032b757fa5634$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $57f032b757fa5634$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6YKZt.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e0c55ef9edbf5c6a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6YKZt.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6YKZt.useCallback((newState)=>{
        v7_startTransition && $57f032b757fa5634$var$startTransitionImpl ? $57f032b757fa5634$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6YKZt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $57f032b757fa5634$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$57f032b757fa5634$export$9c954a9d03d32f4a() && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let { matches: matches } = $6YKZt.useContext($57f032b757fa5634$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $57f032b757fa5634$export$45d76561a5302f2b();
    let navigate = $57f032b757fa5634$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $e0c55ef9edbf5c6a$export$cae722b0cc860f13)(to, (0, $e0c55ef9edbf5c6a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6YKZt.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $57f032b757fa5634$export$910ae8079b2c2852(props) {
    return $57f032b757fa5634$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $57f032b757fa5634$export$e7b0ac011bb776c6(_props) {
    (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $57f032b757fa5634$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $e0c55ef9edbf5c6a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$57f032b757fa5634$export$9c954a9d03d32f4a() && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6YKZt.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $e0c55ef9edbf5c6a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6YKZt.useMemo(()=>{
        let trailingPathname = (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $57f032b757fa5634$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $57f032b757fa5634$export$5d3fca4a98652595($57f032b757fa5634$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $57f032b757fa5634$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$ResolveAwait, null, children));
}
var $57f032b757fa5634$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($57f032b757fa5634$var$AwaitRenderStatus || {});
const $57f032b757fa5634$var$neverSettledPromise = new Promise(()=>{});
class $57f032b757fa5634$var$AwaitErrorBoundary extends $6YKZt.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $57f032b757fa5634$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $57f032b757fa5634$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $57f032b757fa5634$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $57f032b757fa5634$var$AwaitRenderStatus.error : promise._data !== undefined ? $57f032b757fa5634$var$AwaitRenderStatus.success : $57f032b757fa5634$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $57f032b757fa5634$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $57f032b757fa5634$var$AwaitRenderStatus.error && promise._error instanceof (0, $e0c55ef9edbf5c6a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $57f032b757fa5634$var$neverSettledPromise;
        if (status === $57f032b757fa5634$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $57f032b757fa5634$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $57f032b757fa5634$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6YKZt.createElement($57f032b757fa5634$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $57f032b757fa5634$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $57f032b757fa5634$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6YKZt.createElement($6YKZt.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $57f032b757fa5634$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6YKZt.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6YKZt.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6YKZt.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $57f032b757fa5634$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $57f032b757fa5634$export$e7b0ac011bb776c6) && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $57f032b757fa5634$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $57f032b757fa5634$export$daf73786167a7f72(matches) {
    return $57f032b757fa5634$var$_renderMatches(matches);
}
function $57f032b757fa5634$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6YKZt.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6YKZt.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $57f032b757fa5634$export$f30f7e456d254e83(routes, opts) {
    return (0, $e0c55ef9edbf5c6a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $57f032b757fa5634$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e0c55ef9edbf5c6a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $57f032b757fa5634$export$52b333d321859367
    }).initialize();
}



function $041a517ada8d798a$var$_extends() {
    $041a517ada8d798a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $041a517ada8d798a$var$_extends.apply(this, arguments);
}
function $041a517ada8d798a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $041a517ada8d798a$var$defaultMethod = "get";
const $041a517ada8d798a$var$defaultEncType = "application/x-www-form-urlencoded";
function $041a517ada8d798a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $041a517ada8d798a$var$isButtonElement(object) {
    return $041a517ada8d798a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $041a517ada8d798a$var$isFormElement(object) {
    return $041a517ada8d798a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $041a517ada8d798a$var$isInputElement(object) {
    return $041a517ada8d798a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $041a517ada8d798a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $041a517ada8d798a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$041a517ada8d798a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $041a517ada8d798a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $041a517ada8d798a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $041a517ada8d798a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $041a517ada8d798a$var$_formDataSupportsSubmitter = null;
function $041a517ada8d798a$var$isFormDataSubmitterSupported() {
    if ($041a517ada8d798a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $041a517ada8d798a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $041a517ada8d798a$var$_formDataSupportsSubmitter = true;
    }
    return $041a517ada8d798a$var$_formDataSupportsSubmitter;
}
const $041a517ada8d798a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $041a517ada8d798a$var$getFormEncType(encType) {
    if (encType != null && !$041a517ada8d798a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $041a517ada8d798a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($041a517ada8d798a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $041a517ada8d798a$var$defaultMethod;
        encType = $041a517ada8d798a$var$getFormEncType(target.getAttribute("enctype")) || $041a517ada8d798a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($041a517ada8d798a$var$isButtonElement(target) || $041a517ada8d798a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $041a517ada8d798a$var$defaultMethod;
        encType = $041a517ada8d798a$var$getFormEncType(target.getAttribute("formenctype")) || $041a517ada8d798a$var$getFormEncType(form.getAttribute("enctype")) || $041a517ada8d798a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$041a517ada8d798a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($041a517ada8d798a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $041a517ada8d798a$var$defaultMethod;
        action = null;
        encType = $041a517ada8d798a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $041a517ada8d798a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $041a517ada8d798a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $041a517ada8d798a$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $041a517ada8d798a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e0c55ef9edbf5c6a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $041a517ada8d798a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e0c55ef9edbf5c6a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $041a517ada8d798a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $57f032b757fa5634$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $041a517ada8d798a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e0c55ef9edbf5c6a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $041a517ada8d798a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e0c55ef9edbf5c6a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $041a517ada8d798a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $57f032b757fa5634$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $041a517ada8d798a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $041a517ada8d798a$var$_extends({}, state, {
        errors: $041a517ada8d798a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $041a517ada8d798a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $e0c55ef9edbf5c6a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $041a517ada8d798a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6YKZt.createContext({
    isTransitioning: false
});
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $041a517ada8d798a$var$START_TRANSITION = "startTransition";
const $041a517ada8d798a$var$startTransitionImpl = $6YKZt[$041a517ada8d798a$var$START_TRANSITION];
function $041a517ada8d798a$var$startTransitionSafe(cb) {
    if ($041a517ada8d798a$var$startTransitionImpl) $041a517ada8d798a$var$startTransitionImpl(cb);
    else cb();
}
class $041a517ada8d798a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $041a517ada8d798a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6YKZt.useState(router.state);
    let [pendingState, setPendingState] = $6YKZt.useState();
    let [vtContext, setVtContext] = $6YKZt.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6YKZt.useState();
    let [transition, setTransition] = $6YKZt.useState();
    let [interruption, setInterruption] = $6YKZt.useState();
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6YKZt.useCallback((cb)=>{
        if (v7_startTransition) $041a517ada8d798a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6YKZt.useCallback((newState, _ref2)=>{
        let { unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        optInStartTransition,
        transition,
        renderDfd,
        router.window
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6YKZt.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6YKZt.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $041a517ada8d798a$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6YKZt.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6YKZt.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6YKZt.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $6YKZt.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6YKZt.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6YKZt.createElement($6YKZt.Fragment, null, /*#__PURE__*/ $6YKZt.createElement((0, $57f032b757fa5634$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6YKZt.createElement((0, $57f032b757fa5634$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6YKZt.createElement($041a517ada8d798a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6YKZt.createElement((0, $57f032b757fa5634$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $6YKZt.createElement($041a517ada8d798a$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement)))), null);
}
function $041a517ada8d798a$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $57f032b757fa5634$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $041a517ada8d798a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6YKZt.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e0c55ef9edbf5c6a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6YKZt.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6YKZt.useCallback((newState)=>{
        v7_startTransition && $041a517ada8d798a$var$startTransitionImpl ? $041a517ada8d798a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6YKZt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6YKZt.createElement((0, $57f032b757fa5634$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $041a517ada8d798a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6YKZt.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e0c55ef9edbf5c6a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6YKZt.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6YKZt.useCallback((newState)=>{
        v7_startTransition && $041a517ada8d798a$var$startTransitionImpl ? $041a517ada8d798a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6YKZt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6YKZt.createElement((0, $57f032b757fa5634$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $041a517ada8d798a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6YKZt.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6YKZt.useCallback((newState)=>{
        v7_startTransition && $041a517ada8d798a$var$startTransitionImpl ? $041a517ada8d798a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6YKZt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6YKZt.createElement((0, $57f032b757fa5634$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $041a517ada8d798a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $041a517ada8d798a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $041a517ada8d798a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6YKZt.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $041a517ada8d798a$var$_objectWithoutPropertiesLoose(_ref7, $041a517ada8d798a$var$_excluded);
    let { basename: basename } = $6YKZt.useContext((0, $57f032b757fa5634$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $041a517ada8d798a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($041a517ada8d798a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $57f032b757fa5634$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $041a517ada8d798a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6YKZt.createElement("a", $041a517ada8d798a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $041a517ada8d798a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6YKZt.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $041a517ada8d798a$var$_objectWithoutPropertiesLoose(_ref8, $041a517ada8d798a$var$_excluded2);
    let path = (0, $57f032b757fa5634$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $57f032b757fa5634$export$45d76561a5302f2b)();
    let routerState = $6YKZt.useContext((0, $57f032b757fa5634$export$145dfa71566a64dc));
    let { navigator: navigator } = $6YKZt.useContext((0, $57f032b757fa5634$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $041a517ada8d798a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6YKZt.createElement($041a517ada8d798a$export$a6c7ac8248d6e38a, $041a517ada8d798a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $041a517ada8d798a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6YKZt.forwardRef((props, ref)=>{
    let submit = $041a517ada8d798a$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $6YKZt.createElement($041a517ada8d798a$var$FormImpl, $041a517ada8d798a$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $041a517ada8d798a$var$FormImpl = /*#__PURE__*/ $6YKZt.forwardRef((_ref9, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $041a517ada8d798a$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $041a517ada8d798a$var$_objectWithoutPropertiesLoose(_ref9, $041a517ada8d798a$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $041a517ada8d798a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $6YKZt.createElement("form", $041a517ada8d798a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $041a517ada8d798a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $041a517ada8d798a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $041a517ada8d798a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($041a517ada8d798a$var$DataRouterHook || ($041a517ada8d798a$var$DataRouterHook = {}));
var $041a517ada8d798a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($041a517ada8d798a$var$DataRouterStateHook || ($041a517ada8d798a$var$DataRouterStateHook = {}));
function $041a517ada8d798a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $041a517ada8d798a$var$useDataRouterContext(hookName) {
    let ctx = $6YKZt.useContext((0, $57f032b757fa5634$export$3add0d5dce533e2e));
    !ctx && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $041a517ada8d798a$var$useDataRouterState(hookName) {
    let state = $6YKZt.useContext((0, $57f032b757fa5634$export$145dfa71566a64dc));
    !state && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $041a517ada8d798a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $57f032b757fa5634$export$9770f232ac06a008)();
    let location = (0, $57f032b757fa5634$export$45d76561a5302f2b)();
    let path = (0, $57f032b757fa5634$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6YKZt.useCallback((event)=>{
        if ($041a517ada8d798a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $e0c55ef9edbf5c6a$export$fe53371bee54353d)(location) === (0, $e0c55ef9edbf5c6a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $041a517ada8d798a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6YKZt.useRef($041a517ada8d798a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6YKZt.useRef(false);
    let location = (0, $57f032b757fa5634$export$45d76561a5302f2b)();
    let searchParams = $6YKZt.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $041a517ada8d798a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $57f032b757fa5634$export$9770f232ac06a008)();
    let setSearchParams = $6YKZt.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $041a517ada8d798a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $041a517ada8d798a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $041a517ada8d798a$export$47c85c6e3a081d3() {
    let { router: router } = $041a517ada8d798a$var$useDataRouterContext($041a517ada8d798a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6YKZt.useContext((0, $57f032b757fa5634$export$26749e8557646306));
    let currentRouteId = (0, $57f032b757fa5634$export$5fc8298006ad9e58)();
    return $6YKZt.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $041a517ada8d798a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $041a517ada8d798a$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $041a517ada8d798a$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $041a517ada8d798a$var$useDataRouterContext($041a517ada8d798a$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $6YKZt.useContext((0, $57f032b757fa5634$export$26749e8557646306));
    return $6YKZt.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $041a517ada8d798a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $041a517ada8d798a$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $041a517ada8d798a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6YKZt.useContext((0, $57f032b757fa5634$export$26749e8557646306));
    let routeContext = $6YKZt.useContext((0, $57f032b757fa5634$export$9072aa6dd1f93057));
    !routeContext && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $041a517ada8d798a$var$_extends({}, (0, $57f032b757fa5634$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $57f032b757fa5634$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e0c55ef9edbf5c6a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $e0c55ef9edbf5c6a$export$fe53371bee54353d)(path);
}
function $041a517ada8d798a$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $6YKZt.forwardRef((props, ref)=>{
        let submit = $041a517ada8d798a$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $6YKZt.createElement($041a517ada8d798a$var$FormImpl, $041a517ada8d798a$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $041a517ada8d798a$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $041a517ada8d798a$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $041a517ada8d798a$var$useDataRouterContext($041a517ada8d798a$var$DataRouterHook.UseFetcher);
    let route = $6YKZt.useContext((0, $57f032b757fa5634$export$9072aa6dd1f93057));
    !route && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $6YKZt.useState(()=>String(++$041a517ada8d798a$var$fetcherId));
    let [Form] = $6YKZt.useState(()=>{
        !routeId && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
        return $041a517ada8d798a$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $6YKZt.useState(()=>(href)=>{
            !router && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
            !routeId && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $041a517ada8d798a$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $6YKZt.useMemo(()=>$041a517ada8d798a$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $6YKZt.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $041a517ada8d798a$export$fa996778a3a31087() {
    let state = $041a517ada8d798a$var$useDataRouterState($041a517ada8d798a$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $041a517ada8d798a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $041a517ada8d798a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $041a517ada8d798a$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $041a517ada8d798a$var$useDataRouterContext($041a517ada8d798a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $041a517ada8d798a$var$useDataRouterState($041a517ada8d798a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6YKZt.useContext((0, $57f032b757fa5634$export$26749e8557646306));
    let location = (0, $57f032b757fa5634$export$45d76561a5302f2b)();
    let matches = (0, $57f032b757fa5634$export$2378eb7f5ff86053)();
    let navigation = (0, $57f032b757fa5634$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6YKZt.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $041a517ada8d798a$var$usePageHide($6YKZt.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $041a517ada8d798a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $041a517ada8d798a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($041a517ada8d798a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6YKZt.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $041a517ada8d798a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $041a517ada8d798a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6YKZt.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($041a517ada8d798a$var$_extends({}, location, {
                    pathname: (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($041a517ada8d798a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6YKZt.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $041a517ada8d798a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6YKZt.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $041a517ada8d798a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6YKZt.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $041a517ada8d798a$export$39f4eb3dbd812741(_ref11) {
    let { when: when, message: message } = _ref11;
    let blocker = (0, $57f032b757fa5634$export$2af03a1de5c0910)(when);
    $6YKZt.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6YKZt.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $041a517ada8d798a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6YKZt.useContext($041a517ada8d798a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $e0c55ef9edbf5c6a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $041a517ada8d798a$var$useDataRouterContext($041a517ada8d798a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $57f032b757fa5634$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $e0c55ef9edbf5c6a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $e0c55ef9edbf5c6a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $e0c55ef9edbf5c6a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $6YKZt = parcelRequire("6YKZt");
const $5d85d35113a74ff5$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $6YKZt.useState)(true);
    // check online status
    (0, $6YKZt.useEffect)(()=>{
        window.addEventListener("offline", ()=>{
            setOnlineStatus(false);
        });
        window.addEventListener("online", ()=>{
            setOnlineStatus(true);
        });
    }, []);
    return onlineStatus;
};
var $5d85d35113a74ff5$export$2e2bcd8739ae039 = $5d85d35113a74ff5$var$useOnlineStatus;



var $6YKZt = parcelRequire("6YKZt");
const $68b2826e7e0b4a0a$var$UserContext = /*#__PURE__*/ (0, $6YKZt.createContext)({
    loggedInUser: "Default User"
});
var $68b2826e7e0b4a0a$export$2e2bcd8739ae039 = $68b2826e7e0b4a0a$var$UserContext;



var $6YKZt = parcelRequire("6YKZt");
var $b9d77ba2877dde5c$exports = {};
"use strict";

$b9d77ba2877dde5c$exports = (parcelRequire("c8wto"));



var $f3ef210356a0cd51$var$__defProp = Object.defineProperty;
var $f3ef210356a0cd51$var$__defProps = Object.defineProperties;
var $f3ef210356a0cd51$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f3ef210356a0cd51$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f3ef210356a0cd51$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f3ef210356a0cd51$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f3ef210356a0cd51$var$__defNormalProp = (obj, key, value)=>key in obj ? $f3ef210356a0cd51$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f3ef210356a0cd51$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f3ef210356a0cd51$var$__hasOwnProp.call(b, prop)) $f3ef210356a0cd51$var$__defNormalProp(a, prop, b[prop]);
    if ($f3ef210356a0cd51$var$__getOwnPropSymbols) {
        for (var prop of $f3ef210356a0cd51$var$__getOwnPropSymbols(b))if ($f3ef210356a0cd51$var$__propIsEnum.call(b, prop)) $f3ef210356a0cd51$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f3ef210356a0cd51$var$__spreadProps = (a, b)=>$f3ef210356a0cd51$var$__defProps(a, $f3ef210356a0cd51$var$__getOwnPropDescs(b));
var $f3ef210356a0cd51$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f3ef210356a0cd51$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f3ef210356a0cd51$var$__getOwnPropSymbols) {
        for (var prop of $f3ef210356a0cd51$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f3ef210356a0cd51$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/batch.ts
function $f3ef210356a0cd51$var$defaultNoopBatch(callback) {
    callback();
}
var $f3ef210356a0cd51$var$batch = $f3ef210356a0cd51$var$defaultNoopBatch;
var $f3ef210356a0cd51$var$setBatch = (newBatch)=>$f3ef210356a0cd51$var$batch = newBatch;
var $f3ef210356a0cd51$var$getBatch = ()=>$f3ef210356a0cd51$var$batch;
var $f3ef210356a0cd51$var$React = // prettier-ignore
// @ts-ignore
"default" in $6YKZt ? $6YKZt["default"] : $6YKZt;
// src/components/Context.ts
var $f3ef210356a0cd51$var$ContextKey = Symbol.for(`react-redux-context`);
var $f3ef210356a0cd51$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f3ef210356a0cd51$var$getContext() {
    var _a;
    if (!$f3ef210356a0cd51$var$React.createContext) return {};
    const contextMap = (_a = $f3ef210356a0cd51$var$gT[$f3ef210356a0cd51$var$ContextKey]) != null ? _a : $f3ef210356a0cd51$var$gT[$f3ef210356a0cd51$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($f3ef210356a0cd51$var$React.createContext);
    if (!realContext) {
        realContext = $f3ef210356a0cd51$var$React.createContext(null);
        contextMap.set($f3ef210356a0cd51$var$React.createContext, realContext);
    }
    return realContext;
}
var $f3ef210356a0cd51$export$cc80c08dc91f1c00 = /* @__PURE__ */ $f3ef210356a0cd51$var$getContext();
// src/utils/useSyncExternalStore.ts
var $f3ef210356a0cd51$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $f3ef210356a0cd51$var$createReduxContextHook(context = $f3ef210356a0cd51$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $f3ef210356a0cd51$var$React.useContext(context);
        return contextValue;
    };
}
var $f3ef210356a0cd51$var$useReduxContext = /* @__PURE__ */ $f3ef210356a0cd51$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $f3ef210356a0cd51$var$useSyncExternalStoreWithSelector = $f3ef210356a0cd51$var$notInitialized;
var $f3ef210356a0cd51$var$initializeUseSelector = (fn)=>{
    $f3ef210356a0cd51$var$useSyncExternalStoreWithSelector = fn;
};
var $f3ef210356a0cd51$var$refEquality = (a, b)=>a === b;
function $f3ef210356a0cd51$export$2b53f90d2bd1cbfb(context = $f3ef210356a0cd51$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f3ef210356a0cd51$export$cc80c08dc91f1c00 ? $f3ef210356a0cd51$var$useReduxContext : $f3ef210356a0cd51$var$createReduxContextHook(context);
    return function useSelector2(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $f3ef210356a0cd51$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $f3ef210356a0cd51$var$React.useRef(true);
        const wrappedSelector = $f3ef210356a0cd51$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $f3ef210356a0cd51$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $f3ef210356a0cd51$var$React.useDebugValue(selectedState);
        return selectedState;
    };
}
var $f3ef210356a0cd51$export$2105062e25df4afe = /* @__PURE__ */ $f3ef210356a0cd51$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $f3ef210356a0cd51$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $f3ef210356a0cd51$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $f3ef210356a0cd51$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $f3ef210356a0cd51$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $f3ef210356a0cd51$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $f3ef210356a0cd51$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $f3ef210356a0cd51$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $f3ef210356a0cd51$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $f3ef210356a0cd51$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $f3ef210356a0cd51$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $f3ef210356a0cd51$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $f3ef210356a0cd51$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $f3ef210356a0cd51$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $f3ef210356a0cd51$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $f3ef210356a0cd51$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $f3ef210356a0cd51$var$ForwardRef = $f3ef210356a0cd51$var$REACT_FORWARD_REF_TYPE;
var $f3ef210356a0cd51$var$Memo = $f3ef210356a0cd51$var$REACT_MEMO_TYPE;
function $f3ef210356a0cd51$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $f3ef210356a0cd51$var$REACT_FRAGMENT_TYPE || type === $f3ef210356a0cd51$var$REACT_PROFILER_TYPE || type === $f3ef210356a0cd51$var$REACT_STRICT_MODE_TYPE || type === $f3ef210356a0cd51$var$REACT_SUSPENSE_TYPE || type === $f3ef210356a0cd51$var$REACT_SUSPENSE_LIST_TYPE || type === $f3ef210356a0cd51$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $f3ef210356a0cd51$var$REACT_LAZY_TYPE || type.$$typeof === $f3ef210356a0cd51$var$REACT_MEMO_TYPE || type.$$typeof === $f3ef210356a0cd51$var$REACT_PROVIDER_TYPE || type.$$typeof === $f3ef210356a0cd51$var$REACT_CONTEXT_TYPE || type.$$typeof === $f3ef210356a0cd51$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $f3ef210356a0cd51$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $f3ef210356a0cd51$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $f3ef210356a0cd51$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $f3ef210356a0cd51$var$REACT_FRAGMENT_TYPE:
                        case $f3ef210356a0cd51$var$REACT_PROFILER_TYPE:
                        case $f3ef210356a0cd51$var$REACT_STRICT_MODE_TYPE:
                        case $f3ef210356a0cd51$var$REACT_SUSPENSE_TYPE:
                        case $f3ef210356a0cd51$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $f3ef210356a0cd51$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $f3ef210356a0cd51$var$REACT_CONTEXT_TYPE:
                                    case $f3ef210356a0cd51$var$REACT_FORWARD_REF_TYPE:
                                    case $f3ef210356a0cd51$var$REACT_LAZY_TYPE:
                                    case $f3ef210356a0cd51$var$REACT_MEMO_TYPE:
                                    case $f3ef210356a0cd51$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $f3ef210356a0cd51$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $f3ef210356a0cd51$var$isContextConsumer(object) {
    return $f3ef210356a0cd51$var$typeOf(object) === $f3ef210356a0cd51$var$REACT_CONTEXT_TYPE;
}
function $f3ef210356a0cd51$var$isMemo(object) {
    return $f3ef210356a0cd51$var$typeOf(object) === $f3ef210356a0cd51$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $f3ef210356a0cd51$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $f3ef210356a0cd51$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $f3ef210356a0cd51$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f3ef210356a0cd51$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f3ef210356a0cd51$var$verify(mapStateToProps, "mapStateToProps");
    $f3ef210356a0cd51$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f3ef210356a0cd51$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $f3ef210356a0cd51$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f3ef210356a0cd51$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $f3ef210356a0cd51$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f3ef210356a0cd51$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $f3ef210356a0cd51$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $f3ef210356a0cd51$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $f3ef210356a0cd51$var$verifyPlainObject(value, displayName, methodName) {
    if (!$f3ef210356a0cd51$var$isPlainObject(value)) $f3ef210356a0cd51$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $f3ef210356a0cd51$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $f3ef210356a0cd51$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $f3ef210356a0cd51$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f3ef210356a0cd51$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f3ef210356a0cd51$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $f3ef210356a0cd51$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $f3ef210356a0cd51$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $f3ef210356a0cd51$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $f3ef210356a0cd51$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $f3ef210356a0cd51$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $f3ef210356a0cd51$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $f3ef210356a0cd51$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $f3ef210356a0cd51$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $f3ef210356a0cd51$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $f3ef210356a0cd51$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $f3ef210356a0cd51$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $f3ef210356a0cd51$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $f3ef210356a0cd51$var$__spreadValues($f3ef210356a0cd51$var$__spreadValues($f3ef210356a0cd51$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $f3ef210356a0cd51$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f3ef210356a0cd51$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$f3ef210356a0cd51$var$defaultMergeProps : typeof mergeProps === "function" ? $f3ef210356a0cd51$var$wrapMergePropsFunc(mergeProps) : $f3ef210356a0cd51$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/Subscription.ts
function $f3ef210356a0cd51$var$createListenerCollection() {
    const batch3 = $f3ef210356a0cd51$var$getBatch();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch3(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f3ef210356a0cd51$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f3ef210356a0cd51$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $f3ef210356a0cd51$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f3ef210356a0cd51$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $f3ef210356a0cd51$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $f3ef210356a0cd51$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $f3ef210356a0cd51$var$useIsomorphicLayoutEffect = $f3ef210356a0cd51$var$canUseDOM ? $f3ef210356a0cd51$var$React.useLayoutEffect : $f3ef210356a0cd51$var$React.useEffect;
// src/utils/shallowEqual.ts
function $f3ef210356a0cd51$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f3ef210356a0cd51$export$d36bdfa510afb180(objA, objB) {
    if ($f3ef210356a0cd51$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f3ef210356a0cd51$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $f3ef210356a0cd51$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f3ef210356a0cd51$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f3ef210356a0cd51$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f3ef210356a0cd51$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f3ef210356a0cd51$var$TYPE_STATICS = {
    [$f3ef210356a0cd51$var$ForwardRef]: $f3ef210356a0cd51$var$FORWARD_REF_STATICS,
    [$f3ef210356a0cd51$var$Memo]: $f3ef210356a0cd51$var$MEMO_STATICS
};
function $f3ef210356a0cd51$var$getStatics(component) {
    if ($f3ef210356a0cd51$var$isMemo(component)) return $f3ef210356a0cd51$var$MEMO_STATICS;
    return $f3ef210356a0cd51$var$TYPE_STATICS[component["$$typeof"]] || $f3ef210356a0cd51$var$REACT_STATICS;
}
var $f3ef210356a0cd51$var$defineProperty = Object.defineProperty;
var $f3ef210356a0cd51$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f3ef210356a0cd51$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f3ef210356a0cd51$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f3ef210356a0cd51$var$getPrototypeOf = Object.getPrototypeOf;
var $f3ef210356a0cd51$var$objectPrototype = Object.prototype;
function $f3ef210356a0cd51$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($f3ef210356a0cd51$var$objectPrototype) {
            const inheritedComponent = $f3ef210356a0cd51$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f3ef210356a0cd51$var$objectPrototype) $f3ef210356a0cd51$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $f3ef210356a0cd51$var$getOwnPropertyNames(sourceComponent);
        if ($f3ef210356a0cd51$var$getOwnPropertySymbols) keys = keys.concat($f3ef210356a0cd51$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $f3ef210356a0cd51$var$getStatics(targetComponent);
        const sourceStatics = $f3ef210356a0cd51$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$f3ef210356a0cd51$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $f3ef210356a0cd51$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f3ef210356a0cd51$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $f3ef210356a0cd51$var$useSyncExternalStore = $f3ef210356a0cd51$var$notInitialized;
var $f3ef210356a0cd51$var$initializeConnect = (fn)=>{
    $f3ef210356a0cd51$var$useSyncExternalStore = fn;
};
var $f3ef210356a0cd51$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $f3ef210356a0cd51$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $f3ef210356a0cd51$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $f3ef210356a0cd51$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $f3ef210356a0cd51$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $f3ef210356a0cd51$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $f3ef210356a0cd51$var$strictEqual(a, b) {
    return a === b;
}
var $f3ef210356a0cd51$var$hasWarnedAboutDeprecatedPureOption = false;
function $f3ef210356a0cd51$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $f3ef210356a0cd51$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $f3ef210356a0cd51$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $f3ef210356a0cd51$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $f3ef210356a0cd51$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $f3ef210356a0cd51$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $f3ef210356a0cd51$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $f3ef210356a0cd51$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $f3ef210356a0cd51$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $f3ef210356a0cd51$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $f3ef210356a0cd51$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $f3ef210356a0cd51$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $f3ef210356a0cd51$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $f3ef210356a0cd51$var$React.useMemo(()=>{
                return $f3ef210356a0cd51$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $f3ef210356a0cd51$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $f3ef210356a0cd51$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $f3ef210356a0cd51$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $f3ef210356a0cd51$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $f3ef210356a0cd51$var$__spreadProps($f3ef210356a0cd51$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $f3ef210356a0cd51$var$React.useRef();
            const lastWrapperProps = $f3ef210356a0cd51$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $f3ef210356a0cd51$var$React.useRef();
            const renderIsScheduled = $f3ef210356a0cd51$var$React.useRef(false);
            const isProcessingDispatch = $f3ef210356a0cd51$var$React.useRef(false);
            const isMounted = $f3ef210356a0cd51$var$React.useRef(false);
            const latestSubscriptionCallbackError = $f3ef210356a0cd51$var$React.useRef();
            $f3ef210356a0cd51$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $f3ef210356a0cd51$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $f3ef210356a0cd51$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $f3ef210356a0cd51$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $f3ef210356a0cd51$var$useIsomorphicLayoutEffectWithArgs($f3ef210356a0cd51$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $f3ef210356a0cd51$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $f3ef210356a0cd51$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $f3ef210356a0cd51$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $f3ef210356a0cd51$var$React.createElement(WrappedComponent, $f3ef210356a0cd51$var$__spreadProps($f3ef210356a0cd51$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $f3ef210356a0cd51$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $f3ef210356a0cd51$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $f3ef210356a0cd51$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $f3ef210356a0cd51$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $f3ef210356a0cd51$var$React.createElement(Connect, $f3ef210356a0cd51$var$__spreadProps($f3ef210356a0cd51$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $f3ef210356a0cd51$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $f3ef210356a0cd51$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $f3ef210356a0cd51$export$64605811ab45167f = $f3ef210356a0cd51$var$connect;
// src/components/Provider.tsx
function $f3ef210356a0cd51$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $f3ef210356a0cd51$var$React.useMemo(()=>{
        const subscription = $f3ef210356a0cd51$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $f3ef210356a0cd51$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $f3ef210356a0cd51$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $f3ef210356a0cd51$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $f3ef210356a0cd51$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f3ef210356a0cd51$export$2881499e37b75b9a = $f3ef210356a0cd51$var$Provider;
// src/hooks/useStore.ts
function $f3ef210356a0cd51$export$671dba69185d0304(context = $f3ef210356a0cd51$export$cc80c08dc91f1c00) {
    const useReduxContext2 = // @ts-ignore
    context === $f3ef210356a0cd51$export$cc80c08dc91f1c00 ? $f3ef210356a0cd51$var$useReduxContext : // @ts-ignore
    $f3ef210356a0cd51$var$createReduxContextHook(context);
    return function useStore2() {
        const { store: store } = useReduxContext2();
        return store;
    };
}
var $f3ef210356a0cd51$export$6ccbb43953eebf8 = /* @__PURE__ */ $f3ef210356a0cd51$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $f3ef210356a0cd51$export$bc9b55530897c558(context = $f3ef210356a0cd51$export$cc80c08dc91f1c00) {
    const useStore2 = // @ts-ignore
    context === $f3ef210356a0cd51$export$cc80c08dc91f1c00 ? $f3ef210356a0cd51$export$6ccbb43953eebf8 : $f3ef210356a0cd51$export$671dba69185d0304(context);
    return function useDispatch2() {
        const store = useStore2();
        return store.dispatch;
    };
}
var $f3ef210356a0cd51$export$8ad76b76a4c905f8 = /* @__PURE__ */ $f3ef210356a0cd51$export$bc9b55530897c558();
// src/index.ts
$f3ef210356a0cd51$var$initializeUseSelector((0, $b9d77ba2877dde5c$exports.useSyncExternalStoreWithSelector));
$f3ef210356a0cd51$var$initializeConnect($6YKZt.useSyncExternalStore);
$f3ef210356a0cd51$var$setBatch((0, $c1a87c920c636bce$exports.unstable_batchedUpdates));
var $f3ef210356a0cd51$export$712ea50be43a7858 = (0, $c1a87c920c636bce$exports.unstable_batchedUpdates);


const $8ca9c2a02d1b7815$var$Header = ()=>{
    const onlineStatus = (0, $5d85d35113a74ff5$export$2e2bcd8739ae039)();
    const { loggedInUser: loggedInUser } = (0, $6YKZt.useContext)((0, $68b2826e7e0b4a0a$export$2e2bcd8739ae039));
    //  subcribing to the
    const cartItems = (0, $f3ef210356a0cd51$export$2105062e25df4afe)((store)=>store.cart.items);
    console.log(cartItems);
    // let btnName = "Login";
    const [btnNameReact, setBtnNameReact] = (0, $6YKZt.useState)("Login");
    (0, $6YKZt.useEffect)(()=>{
    // console.log("useEffect")
    });
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "flex justify-between bg-pink-100 shadow-lg mb-2 sm:bg-yellow-100 lg:bg-green-100 md:to-blue-100",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $2RmP6.jsx)("img", {
                    className: "w-28",
                    src: (0, $1f80689291b57452$export$8878ead86ed0da0b)
                })
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $2RmP6.jsxs)("ul", {
                    className: "flex  m-0 p-2",
                    children: [
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("li", {
                            className: "px-2",
                            children: [
                                "Status:",
                                onlineStatus ? "\u2705" : "\u274C"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $2RmP6.jsx)((0, $041a517ada8d798a$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: " Home "
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("li", {
                            className: "px-2",
                            children: [
                                /*#__PURE__*/ (0, $2RmP6.jsx)((0, $041a517ada8d798a$export$a6c7ac8248d6e38a), {
                                    to: "/about",
                                    children: "About us "
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("li", {
                            className: "px-2",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $2RmP6.jsx)((0, $041a517ada8d798a$export$a6c7ac8248d6e38a), {
                                    to: "/contact",
                                    children: "Contact Us"
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("li", {
                            className: "px-2",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $2RmP6.jsx)((0, $041a517ada8d798a$export$a6c7ac8248d6e38a), {
                                    to: "/grocery",
                                    children: "Grocery"
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("li", {
                            className: "px-2 font-bold",
                            children: [
                                /*#__PURE__*/ (0, $2RmP6.jsx)((0, $041a517ada8d798a$export$a6c7ac8248d6e38a), {
                                    to: "/cart",
                                    children: "Cart"
                                }),
                                "(",
                                cartItems.length,
                                " Item) "
                            ]
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsx)("button", {
                            className: "login ",
                            onClick: ()=>{
                                btnNameReact === "login" ? setBtnNameReact("logout") : setBtnNameReact("login");
                                console.log(btnNameReact);
                            },
                            children: btnNameReact
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("li", {
                            className: "px-2 font-bold",
                            children: [
                                " ",
                                loggedInUser,
                                " "
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $8ca9c2a02d1b7815$export$2e2bcd8739ae039 = $8ca9c2a02d1b7815$var$Header;



var $2RmP6 = parcelRequire("2RmP6");

var $2RmP6 = parcelRequire("2RmP6");

var $6YKZt = parcelRequire("6YKZt");


// const styleCard ={
//     backgroundColor: "#f0f0f0",
// };
const $e8bb02379cd7106d$var$RestaurantCard = (props)=>{
    const { resData: resData } = props;
    const { loggedInUser: loggedInUser } = (0, $6YKZt.useContext)((0, $68b2826e7e0b4a0a$export$2e2bcd8739ae039));
    const { cloudinaryImageId: cloudinaryImageId, name: name, cuisines: cuisines, costForTwo: costForTwo, avgRating: avgRating, deliveryTime: deliveryTime } = resData?.info;
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "res-card m-4 p-4 w-[300px] rounded-lg bg-gray-200 hover:bg-green-200  ",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsx)("img", {
                className: "res-logo rounded-lg ",
                src: (0, $1f80689291b57452$export$31adfacaf07ffe63) + cloudinaryImageId,
                alt: "Biryani"
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h3", {
                className: " font-bold py-4 text-lg",
                children: name
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h4", {
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("h4", {
                children: [
                    avgRating,
                    " stars"
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h4", {
                children: costForTwo
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("h4", {
                children: [
                    deliveryTime,
                    "minutes "
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("h4", {
                children: [
                    "User:",
                    loggedInUser,
                    " "
                ]
            })
        ]
    });
};
const $e8bb02379cd7106d$export$bdc3d774adf316c = (RestaurantCard)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2RmP6.jsx)("label", {
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $2RmP6.jsx)(RestaurantCard, {
                    ...props
                })
            ]
        });
    };
};
var $e8bb02379cd7106d$export$2e2bcd8739ae039 // style={{ backgroundColor: "#f0f0f0", }}
 = $e8bb02379cd7106d$var$RestaurantCard;



var $6YKZt = parcelRequire("6YKZt");

var $2RmP6 = parcelRequire("2RmP6");
const $b694b696f2bd79bb$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "flex flex-wrap m-4 p-4 mx-[60px] my-[60px] justify-between ",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "shimmer-container  rounded-lg border w-60 h-60    animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: " text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200",
                        children: " "
                    })
                ]
            })
        ]
    });
};
var $b694b696f2bd79bb$export$2e2bcd8739ae039 //  <div className="shimmer-container  rounded-lg border w-60 h-60 mx-16 m-8 p-4 animate-pulse">
 //  <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
 // <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
 // <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
 // <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
 // </div>
 = $b694b696f2bd79bb$var$Shimmer;





//  import UserContext from "../utils/UserContext";
//  import UserContext from "../utils/UserContext";
//  State Variables - super powerful variables
const $9189a9279a2293e1$var$Body = ()=>{
    const [listOfRestaurants, setListOfRestaurant] = (0, $6YKZt.useState)([]);
    const [filteredRestaurant, setFilteredRestaurant] = (0, $6YKZt.useState)([]);
    const [searchText, setSearchText] = (0, $6YKZt.useState)("");
    const RestaurantCardPromoted = (0, $e8bb02379cd7106d$export$bdc3d774adf316c)((0, $e8bb02379cd7106d$export$2e2bcd8739ae039));
    //    whenever state variable , react triggers a reconciliation cycle (re -render the component)
    console.log("rakesh");
    (0, $6YKZt.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        const data = await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9715987&lng=77.5945627&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
        const json = await data.json();
        // console.log(data.cards[2]);
        console.log(json);
        console.log(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        //  Optional Chaining                                                                
        setListOfRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        setFilteredRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
    };
    const onlineStatus = (0, $5d85d35113a74ff5$export$2e2bcd8739ae039)();
    if (onlineStatus === false) return /*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
        children: "Look like you are offline"
    });
    //  if(listOfRestaurants.length===0){
    //    return <Shimmer/>;
    const { loggedInUser: loggedInUser, setUserName: setUserName } = (0, $6YKZt.useContext)((0, $68b2826e7e0b4a0a$export$2e2bcd8739ae039));
    return listOfRestaurants.length === 0 ? /*#__PURE__*/ (0, $2RmP6.jsx)((0, $b694b696f2bd79bb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "filter flex",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                        className: "search p-4 m-4",
                        children: [
                            /*#__PURE__*/ (0, $2RmP6.jsx)("input", {
                                type: "text",
                                className: "border border-solid border-black",
                                value: searchText,
                                onChange: (e)=>{
                                    setSearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $2RmP6.jsx)("button", {
                                className: "px-4 py-1 bg-green-100 m-4 rounded-lg",
                                onClick: ()=>{
                                    //  filter
                                    const filteredRestaurant = listOfRestaurants.filter((res)=>res.info.name.toLowerCase().includes(searchText));
                                    setFilteredRestaurant(filteredRestaurant);
                                },
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                        className: "p-4 m-4 flex items-center",
                        children: /*#__PURE__*/ (0, $2RmP6.jsx)("button", {
                            className: "filter-btn px-4 py-2 bg-gray-200 rounded-lg",
                            onClick: ()=>{
                                //     filter logic here
                                const filteredList = listOfRestaurants.filter((res)=>res.info.avgRating > 4);
                                setListOfRestaurant(filteredList);
                            // console.log(listOfRestaurants);
                            },
                            children: "Top Rated Restaurants"
                        })
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                        className: "p-4 m-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $2RmP6.jsx)("label", {
                                children: "User Name:"
                            }),
                            /*#__PURE__*/ (0, $2RmP6.jsx)("input", {
                                className: "border border-black p-2",
                                value: loggedInUser,
                                onChange: (e)=>setUserName(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                className: "res-conatiner flex flex-wrap rounded-lg",
                children: filteredRestaurant.map((restaurants, index)=>/*#__PURE__*/ (0, $2RmP6.jsx)((0, $041a517ada8d798a$export$a6c7ac8248d6e38a), {
                        to: "/restaurants/" + restaurants.info.id,
                        children: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $e8bb02379cd7106d$export$2e2bcd8739ae039), {
                            resData: restaurants
                        })
                    }, restaurants.info.id))
            })
        ]
    });
};
var $9189a9279a2293e1$export$2e2bcd8739ae039 = $9189a9279a2293e1$var$Body;



var $2RmP6 = parcelRequire("2RmP6");

var $6YKZt = parcelRequire("6YKZt");

var $2RmP6 = parcelRequire("2RmP6");

var $6YKZt = parcelRequire("6YKZt");
const $69aedd0f10418240$var$User = ({ name: name })=>{
    const [count, setCount] = (0, $6YKZt.useState)(0);
    const [count2] = (0, $6YKZt.useState)(1);
    // function handleClick() {
    //     setCount(count + 1);
    //   }
    (0, $6YKZt.useEffect)(()=>{}, []);
    async function getUserInfo() {}
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "user-card",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsx)("h2", {
                children: " Name :Rakesh kushwaha "
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("h2", {
                children: [
                    "  ",
                    name
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h3", {
                children: " location : Akabar shahpur Meja Prayagraj"
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h4", {
                children: "Contact : rk7518329420@gmail.com"
            })
        ]
    });
};
var $69aedd0f10418240$export$2e2bcd8739ae039 = $69aedd0f10418240$var$User;



var $2RmP6 = parcelRequire("2RmP6");

var $6YKZt = parcelRequire("6YKZt");
class $6f853a5c45e9f9f6$var$UserClass extends (0, (/*@__PURE__*/$parcel$interopDefault($6YKZt))).Component {
    constructor(props){
        super(props);
        this.state = {
            userInfo: {
                name: "Rakesh kushwaha  ",
                location: "Prayagraj"
            }
        };
    //  console.log( this.props.name+"Constructing");
    }
    async componentDidMount() {
        // console.log(this.props.name+"Child Component")
        const data = await fetch("https://api.github.com/users/RAKESHKUSHWAHA7518");
        const json = await data.json();
        this.setState({
            userInfo: json
        });
        console.log(json);
    }
    componentDidUpdate() {
        console.log("componentDidUpdate");
    }
    componentWillUnmount() {
        console.log("componentWillUnmount");
    }
    render() {
        //  const {name} = this.props;
        //  console.log (this.props.name+" child render")
        const { name: name, location: location, id: id, avatar_url: avatar_url } = this.state.userInfo;
        return /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
            className: "  place-content-center  ",
            children: /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "user-card m-4 p-4 border  rounded-lg bg-blue-200  justify-center",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("img", {
                        className: "bg-gray-200 place-content-center  hover:bg-green-200",
                        src: avatar_url
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsxs)("h2", {
                        className: "font-bold",
                        children: [
                            " Name : ",
                            name
                        ]
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("h3", {
                        className: "font-light",
                        children: " location : Akabar shahpur Meja Prayagraj"
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsxs)("h3", {
                        className: "font-light",
                        children: [
                            " location : ",
                            location
                        ]
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsxs)("h3", {
                        className: "font-light",
                        children: [
                            " Id: ",
                            id
                        ]
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)("h4", {
                        children: "Contact : rk7518329420@gmail.com"
                    })
                ]
            })
        });
    }
}
var $6f853a5c45e9f9f6$export$2e2bcd8739ae039 = $6f853a5c45e9f9f6$var$UserClass;



class $43875d40b4ab981c$var$About extends (0, (/*@__PURE__*/$parcel$interopDefault($6YKZt))).Component {
    constructor(props){
        super(props);
    // console.log(" Parent Construct")
    }
    componentDidMount() {
    // console.log(" parent Component is mounted");
    }
    render() {
        // console.log(" Parent Rendering...");
        return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
                    className: "m-4 px-4  font-bold",
                    children: "About class "
                }),
                /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                    children: [
                        "loggedIn User",
                        /*#__PURE__*/ (0, $2RmP6.jsx)((0, $68b2826e7e0b4a0a$export$2e2bcd8739ae039).Consumer, {
                            children: ({ loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
                                    className: "font-bold p-6",
                                    children: loggedInUser
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2RmP6.jsx)("h2", {
                    className: "m-4 px-4 font-bold",
                    children: " Namaste React Student"
                }),
                /*#__PURE__*/ (0, $2RmP6.jsx)((0, $6f853a5c45e9f9f6$export$2e2bcd8739ae039), {
                    name: "Rakesh Kushwaha (class base component) "
                })
            ]
        });
    }
}
var // const About =() =>{
//     return(
//         <div>
//             <h1>About</h1>
//             <h2> Namaste React Student</h2>
//             <User name = {"Rakesh Kushwaha(fuctional)"}/>
//             <UserClass name = {"Rakesh Kushwaha (class base component) "} />
//         </div>
//     );
// }
$43875d40b4ab981c$export$2e2bcd8739ae039 = $43875d40b4ab981c$var$About;



var $2RmP6 = parcelRequire("2RmP6");


const $038171ea419d65e1$var$Error = ()=>{
    const err = (0, $57f032b757fa5634$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsx)((0, $8ca9c2a02d1b7815$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
                children: " Error 404 found"
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h2", {
                children: "This page is not present"
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("h3", {
                children: [
                    err.status,
                    ":",
                    err.statusText,
                    /*#__PURE__*/ (0, $2RmP6.jsx)("br", {})
                ]
            })
        ]
    });
};
var $038171ea419d65e1$export$2e2bcd8739ae039 = $038171ea419d65e1$var$Error;



var $2RmP6 = parcelRequire("2RmP6");
const $d5e2a43cca5176d2$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "border m-4 p-4 justify-center bg-gray-200 border-r-blue-200",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
                className: "font-bold",
                children: " Contact us Page"
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h2", {
                children: "I am Rakesh Kushwaha"
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h2", {
                children: "My Email is rk7518329420@gmail.com"
            })
        ]
    });
};
var $d5e2a43cca5176d2$export$2e2bcd8739ae039 = $d5e2a43cca5176d2$var$Contact;




var $2RmP6 = parcelRequire("2RmP6");

var $6YKZt = parcelRequire("6YKZt");



var $6YKZt = parcelRequire("6YKZt");

const $b31bde19fc8c4e51$var$useRestaurantMenu = (resId)=>{
    const [resInfo, setResInfo] = (0, $6YKZt.useState)(null);
    //  fetch data
    (0, $6YKZt.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        const data = await fetch("https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=" + resId + "&catalog_qa=undefined&submitAction=ENTER");
        const json = await data.json();
        setResInfo(json.data);
    //  console.log(json.data);
    };
    return resInfo;
};
var $b31bde19fc8c4e51$export$2e2bcd8739ae039 = $b31bde19fc8c4e51$var$useRestaurantMenu;




var $2RmP6 = parcelRequire("2RmP6");
parcelRequire("6YKZt");
// import { useDispatch } from "react-redux";

var $2RmP6 = parcelRequire("2RmP6");

// src/index.ts
// src/utils/formatProdErrorMessage.ts
function $9c0d8341932e5849$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $9c0d8341932e5849$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $9c0d8341932e5849$var$symbol_observable_default = $9c0d8341932e5849$var$$$observable;
// src/utils/actionTypes.ts
var $9c0d8341932e5849$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $9c0d8341932e5849$var$ActionTypes = {
    INIT: `@@redux/INIT${$9c0d8341932e5849$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$9c0d8341932e5849$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$9c0d8341932e5849$var$randomString()}`
};
var $9c0d8341932e5849$export$4219e499db7ca678 = $9c0d8341932e5849$var$ActionTypes;
// src/utils/isPlainObject.ts
function $9c0d8341932e5849$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// src/utils/kindOf.ts
function $9c0d8341932e5849$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($9c0d8341932e5849$var$isDate(val)) return "date";
    if ($9c0d8341932e5849$var$isError(val)) return "error";
    const constructorName = $9c0d8341932e5849$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $9c0d8341932e5849$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $9c0d8341932e5849$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $9c0d8341932e5849$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $9c0d8341932e5849$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $9c0d8341932e5849$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(1));
        return enhancer($9c0d8341932e5849$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$9c0d8341932e5849$export$53b83ca8eaab0383(action)) throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $9c0d8341932e5849$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$9c0d8341932e5849$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $9c0d8341932e5849$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$9c0d8341932e5849$var$symbol_observable_default]: observable
    };
    return store;
}
function $9c0d8341932e5849$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $9c0d8341932e5849$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $9c0d8341932e5849$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $9c0d8341932e5849$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $9c0d8341932e5849$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$9c0d8341932e5849$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$9c0d8341932e5849$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $9c0d8341932e5849$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $9c0d8341932e5849$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $9c0d8341932e5849$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $9c0d8341932e5849$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(13));
    });
}
function $9c0d8341932e5849$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $9c0d8341932e5849$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $9c0d8341932e5849$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $9c0d8341932e5849$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $9c0d8341932e5849$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $9c0d8341932e5849$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $9c0d8341932e5849$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $9c0d8341932e5849$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($9c0d8341932e5849$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $9c0d8341932e5849$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $9c0d8341932e5849$export$b956e38827fca970(action) {
    return $9c0d8341932e5849$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $e5e702a7285c7426$var$__defProp = Object.defineProperty;
var $e5e702a7285c7426$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e5e702a7285c7426$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e5e702a7285c7426$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e5e702a7285c7426$var$__defNormalProp = (obj, key, value)=>key in obj ? $e5e702a7285c7426$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e5e702a7285c7426$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e5e702a7285c7426$var$__hasOwnProp.call(b, prop)) $e5e702a7285c7426$var$__defNormalProp(a, prop, b[prop]);
    if ($e5e702a7285c7426$var$__getOwnPropSymbols) {
        for (var prop of $e5e702a7285c7426$var$__getOwnPropSymbols(b))if ($e5e702a7285c7426$var$__propIsEnum.call(b, prop)) $e5e702a7285c7426$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $e5e702a7285c7426$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $e5e702a7285c7426$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $e5e702a7285c7426$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $e5e702a7285c7426$var$errors = [];
function $e5e702a7285c7426$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $e5e702a7285c7426$var$getPrototypeOf = Object.getPrototypeOf;
function $e5e702a7285c7426$export$541ac630993a4c84(value) {
    return !!value && !!value[$e5e702a7285c7426$var$DRAFT_STATE];
}
function $e5e702a7285c7426$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $e5e702a7285c7426$var$isPlainObject(value) || Array.isArray(value) || !!value[$e5e702a7285c7426$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$e5e702a7285c7426$export$6ee2082928bcb0ee]) || $e5e702a7285c7426$var$isMap(value) || $e5e702a7285c7426$var$isSet(value);
}
var $e5e702a7285c7426$var$objectCtorString = Object.prototype.constructor.toString();
function $e5e702a7285c7426$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $e5e702a7285c7426$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $e5e702a7285c7426$var$objectCtorString;
}
function $e5e702a7285c7426$export$22e8af3f75a010e3(value) {
    if (!$e5e702a7285c7426$export$541ac630993a4c84(value)) $e5e702a7285c7426$var$die(15, value);
    return value[$e5e702a7285c7426$var$DRAFT_STATE].base_;
}
function $e5e702a7285c7426$var$each(obj, iter) {
    if ($e5e702a7285c7426$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $e5e702a7285c7426$var$getArchtype(thing) {
    const state = thing[$e5e702a7285c7426$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $e5e702a7285c7426$var$isMap(thing) ? 2 /* Map */  : $e5e702a7285c7426$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $e5e702a7285c7426$var$has(thing, prop) {
    return $e5e702a7285c7426$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $e5e702a7285c7426$var$get(thing, prop) {
    return $e5e702a7285c7426$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $e5e702a7285c7426$var$set(thing, propOrOldValue, value) {
    const t = $e5e702a7285c7426$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $e5e702a7285c7426$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e5e702a7285c7426$var$isMap(target) {
    return target instanceof Map;
}
function $e5e702a7285c7426$var$isSet(target) {
    return target instanceof Set;
}
function $e5e702a7285c7426$var$latest(state) {
    return state.copy_ || state.base_;
}
function $e5e702a7285c7426$var$shallowCopy(base, strict) {
    if ($e5e702a7285c7426$var$isMap(base)) return new Map(base);
    if ($e5e702a7285c7426$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $e5e702a7285c7426$var$isPlainObject(base)) {
        if (!$e5e702a7285c7426$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $e5e702a7285c7426$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$e5e702a7285c7426$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($e5e702a7285c7426$var$getPrototypeOf(base), descriptors);
}
function $e5e702a7285c7426$export$792f3d81ea979f55(obj, deep = false) {
    if ($e5e702a7285c7426$var$isFrozen(obj) || $e5e702a7285c7426$export$541ac630993a4c84(obj) || !$e5e702a7285c7426$export$16e3aed3edb85946(obj)) return obj;
    if ($e5e702a7285c7426$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $e5e702a7285c7426$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $e5e702a7285c7426$var$each(obj, (_key, value)=>$e5e702a7285c7426$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $e5e702a7285c7426$var$dontMutateFrozenCollections() {
    $e5e702a7285c7426$var$die(2);
}
function $e5e702a7285c7426$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $e5e702a7285c7426$var$plugins = {};
function $e5e702a7285c7426$var$getPlugin(pluginKey) {
    const plugin = $e5e702a7285c7426$var$plugins[pluginKey];
    if (!plugin) $e5e702a7285c7426$var$die(0, pluginKey);
    return plugin;
}
function $e5e702a7285c7426$var$loadPlugin(pluginKey, implementation) {
    if (!$e5e702a7285c7426$var$plugins[pluginKey]) $e5e702a7285c7426$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $e5e702a7285c7426$var$currentScope;
function $e5e702a7285c7426$var$getCurrentScope() {
    return $e5e702a7285c7426$var$currentScope;
}
function $e5e702a7285c7426$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $e5e702a7285c7426$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $e5e702a7285c7426$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $e5e702a7285c7426$var$revokeScope(scope) {
    $e5e702a7285c7426$var$leaveScope(scope);
    scope.drafts_.forEach($e5e702a7285c7426$var$revokeDraft);
    scope.drafts_ = null;
}
function $e5e702a7285c7426$var$leaveScope(scope) {
    if (scope === $e5e702a7285c7426$var$currentScope) $e5e702a7285c7426$var$currentScope = scope.parent_;
}
function $e5e702a7285c7426$var$enterScope(immer2) {
    return $e5e702a7285c7426$var$currentScope = $e5e702a7285c7426$var$createScope($e5e702a7285c7426$var$currentScope, immer2);
}
function $e5e702a7285c7426$var$revokeDraft(draft) {
    const state = draft[$e5e702a7285c7426$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $e5e702a7285c7426$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$e5e702a7285c7426$var$DRAFT_STATE].modified_) {
            $e5e702a7285c7426$var$revokeScope(scope);
            $e5e702a7285c7426$var$die(4);
        }
        if ($e5e702a7285c7426$export$16e3aed3edb85946(result)) {
            result = $e5e702a7285c7426$var$finalize(scope, result);
            if (!scope.parent_) $e5e702a7285c7426$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $e5e702a7285c7426$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$e5e702a7285c7426$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $e5e702a7285c7426$var$finalize(scope, baseDraft, []);
    $e5e702a7285c7426$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $e5e702a7285c7426$export$45b790e32b2810ee ? result : void 0;
}
function $e5e702a7285c7426$var$finalize(rootScope, value, path) {
    if ($e5e702a7285c7426$var$isFrozen(value)) return value;
    const state = value[$e5e702a7285c7426$var$DRAFT_STATE];
    if (!state) {
        $e5e702a7285c7426$var$each(value, (key, childValue)=>$e5e702a7285c7426$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $e5e702a7285c7426$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $e5e702a7285c7426$var$each(resultEach, (key, childValue)=>$e5e702a7285c7426$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $e5e702a7285c7426$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $e5e702a7285c7426$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $e5e702a7285c7426$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($e5e702a7285c7426$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$e5e702a7285c7426$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $e5e702a7285c7426$var$finalize(rootScope, childValue, path);
        $e5e702a7285c7426$var$set(targetObject, prop, res);
        if ($e5e702a7285c7426$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($e5e702a7285c7426$export$16e3aed3edb85946(childValue) && !$e5e702a7285c7426$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $e5e702a7285c7426$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $e5e702a7285c7426$var$maybeFreeze(rootScope, childValue);
    }
}
function $e5e702a7285c7426$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $e5e702a7285c7426$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $e5e702a7285c7426$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $e5e702a7285c7426$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $e5e702a7285c7426$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $e5e702a7285c7426$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $e5e702a7285c7426$var$objectTraps = {
    get (state, prop) {
        if (prop === $e5e702a7285c7426$var$DRAFT_STATE) return state;
        const source = $e5e702a7285c7426$var$latest(state);
        if (!$e5e702a7285c7426$var$has(source, prop)) return $e5e702a7285c7426$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$e5e702a7285c7426$export$16e3aed3edb85946(value)) return value;
        if (value === $e5e702a7285c7426$var$peek(state.base_, prop)) {
            $e5e702a7285c7426$var$prepareCopy(state);
            return state.copy_[prop] = $e5e702a7285c7426$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $e5e702a7285c7426$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($e5e702a7285c7426$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $e5e702a7285c7426$var$getDescriptorFromProto($e5e702a7285c7426$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $e5e702a7285c7426$var$peek($e5e702a7285c7426$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$e5e702a7285c7426$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($e5e702a7285c7426$var$is(value, current2) && (value !== void 0 || $e5e702a7285c7426$var$has(state.base_, prop))) return true;
            $e5e702a7285c7426$var$prepareCopy(state);
            $e5e702a7285c7426$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($e5e702a7285c7426$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $e5e702a7285c7426$var$prepareCopy(state);
            $e5e702a7285c7426$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $e5e702a7285c7426$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $e5e702a7285c7426$var$die(11);
    },
    getPrototypeOf (state) {
        return $e5e702a7285c7426$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $e5e702a7285c7426$var$die(12);
    }
};
var $e5e702a7285c7426$var$arrayTraps = {};
$e5e702a7285c7426$var$each($e5e702a7285c7426$var$objectTraps, (key, fn)=>{
    $e5e702a7285c7426$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$e5e702a7285c7426$var$arrayTraps.deleteProperty = function(state, prop) {
    return $e5e702a7285c7426$var$arrayTraps.set.call(this, state, prop, void 0);
};
$e5e702a7285c7426$var$arrayTraps.set = function(state, prop, value) {
    return $e5e702a7285c7426$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $e5e702a7285c7426$var$peek(draft, prop) {
    const state = draft[$e5e702a7285c7426$var$DRAFT_STATE];
    const source = state ? $e5e702a7285c7426$var$latest(state) : draft;
    return source[prop];
}
function $e5e702a7285c7426$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $e5e702a7285c7426$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $e5e702a7285c7426$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $e5e702a7285c7426$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $e5e702a7285c7426$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $e5e702a7285c7426$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $e5e702a7285c7426$var$markChanged(state.parent_);
    }
}
function $e5e702a7285c7426$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $e5e702a7285c7426$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $e5e702a7285c7426$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $e5e702a7285c7426$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $e5e702a7285c7426$var$die(7);
            let result;
            if ($e5e702a7285c7426$export$16e3aed3edb85946(base)) {
                const scope = $e5e702a7285c7426$var$enterScope(this);
                const proxy = $e5e702a7285c7426$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $e5e702a7285c7426$var$revokeScope(scope);
                    else $e5e702a7285c7426$var$leaveScope(scope);
                }
                $e5e702a7285c7426$var$usePatchesInScope(scope, patchListener);
                return $e5e702a7285c7426$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $e5e702a7285c7426$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $e5e702a7285c7426$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $e5e702a7285c7426$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $e5e702a7285c7426$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$e5e702a7285c7426$export$16e3aed3edb85946(base)) $e5e702a7285c7426$var$die(8);
        if ($e5e702a7285c7426$export$541ac630993a4c84(base)) base = $e5e702a7285c7426$export$97aac956da55dae9(base);
        const scope = $e5e702a7285c7426$var$enterScope(this);
        const proxy = $e5e702a7285c7426$var$createProxy(base, void 0);
        proxy[$e5e702a7285c7426$var$DRAFT_STATE].isManual_ = true;
        $e5e702a7285c7426$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$e5e702a7285c7426$var$DRAFT_STATE];
        if (!state || !state.isManual_) $e5e702a7285c7426$var$die(9);
        const { scope_: scope } = state;
        $e5e702a7285c7426$var$usePatchesInScope(scope, patchListener);
        return $e5e702a7285c7426$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $e5e702a7285c7426$var$getPlugin("Patches").applyPatches_;
        if ($e5e702a7285c7426$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $e5e702a7285c7426$var$createProxy(value, parent) {
    const draft = $e5e702a7285c7426$var$isMap(value) ? $e5e702a7285c7426$var$getPlugin("MapSet").proxyMap_(value, parent) : $e5e702a7285c7426$var$isSet(value) ? $e5e702a7285c7426$var$getPlugin("MapSet").proxySet_(value, parent) : $e5e702a7285c7426$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $e5e702a7285c7426$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $e5e702a7285c7426$export$97aac956da55dae9(value) {
    if (!$e5e702a7285c7426$export$541ac630993a4c84(value)) $e5e702a7285c7426$var$die(10, value);
    return $e5e702a7285c7426$var$currentImpl(value);
}
function $e5e702a7285c7426$var$currentImpl(value) {
    if (!$e5e702a7285c7426$export$16e3aed3edb85946(value) || $e5e702a7285c7426$var$isFrozen(value)) return value;
    const state = value[$e5e702a7285c7426$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $e5e702a7285c7426$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $e5e702a7285c7426$var$shallowCopy(value, true);
    $e5e702a7285c7426$var$each(copy, (key, childValue)=>{
        $e5e702a7285c7426$var$set(copy, key, $e5e702a7285c7426$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $e5e702a7285c7426$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $e5e702a7285c7426$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $e5e702a7285c7426$var$get(base_, key);
            const value = $e5e702a7285c7426$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $e5e702a7285c7426$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $e5e702a7285c7426$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $e5e702a7285c7426$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $e5e702a7285c7426$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $e5e702a7285c7426$var$die(errorOffset + 3);
                base = $e5e702a7285c7426$var$get(base, p);
                if (typeof base !== "object") $e5e702a7285c7426$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $e5e702a7285c7426$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $e5e702a7285c7426$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $e5e702a7285c7426$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$e5e702a7285c7426$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($e5e702a7285c7426$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($e5e702a7285c7426$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($e5e702a7285c7426$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($e5e702a7285c7426$var$has(obj, $e5e702a7285c7426$export$6ee2082928bcb0ee)) cloned[$e5e702a7285c7426$export$6ee2082928bcb0ee] = obj[$e5e702a7285c7426$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($e5e702a7285c7426$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $e5e702a7285c7426$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $e5e702a7285c7426$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$e5e702a7285c7426$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $e5e702a7285c7426$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $e5e702a7285c7426$var$latest(this[$e5e702a7285c7426$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $e5e702a7285c7426$var$latest(this[$e5e702a7285c7426$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$e5e702a7285c7426$var$latest(state).has(key) || $e5e702a7285c7426$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $e5e702a7285c7426$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $e5e702a7285c7426$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($e5e702a7285c7426$var$latest(state).size) {
                prepareMapCopy(state);
                $e5e702a7285c7426$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $e5e702a7285c7426$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            $e5e702a7285c7426$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $e5e702a7285c7426$var$latest(state).get(key);
            if (state.finalized_ || !$e5e702a7285c7426$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $e5e702a7285c7426$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $e5e702a7285c7426$var$latest(this[$e5e702a7285c7426$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($e5e702a7285c7426$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$e5e702a7285c7426$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $e5e702a7285c7426$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $e5e702a7285c7426$var$latest(this[$e5e702a7285c7426$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $e5e702a7285c7426$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $e5e702a7285c7426$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($e5e702a7285c7426$var$latest(state).size) {
                prepareSetCopy(state);
                $e5e702a7285c7426$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$e5e702a7285c7426$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($e5e702a7285c7426$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($e5e702a7285c7426$export$16e3aed3edb85946(value)) {
                    const draft = $e5e702a7285c7426$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $e5e702a7285c7426$var$die(3, JSON.stringify($e5e702a7285c7426$var$latest(state)));
    }
    $e5e702a7285c7426$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $e5e702a7285c7426$var$immer = new $e5e702a7285c7426$export$aaadc6ff0f822719();
var $e5e702a7285c7426$export$b46cabe22e78bc00 = $e5e702a7285c7426$var$immer.produce;
var $e5e702a7285c7426$export$4da66d41c9492c78 = $e5e702a7285c7426$var$immer.produceWithPatches.bind($e5e702a7285c7426$var$immer);
var $e5e702a7285c7426$export$573f26f60825c493 = $e5e702a7285c7426$var$immer.setAutoFreeze.bind($e5e702a7285c7426$var$immer);
var $e5e702a7285c7426$export$333ce65961cbe047 = $e5e702a7285c7426$var$immer.setUseStrictShallowCopy.bind($e5e702a7285c7426$var$immer);
var $e5e702a7285c7426$export$a8b8e03e6bbe5473 = $e5e702a7285c7426$var$immer.applyPatches.bind($e5e702a7285c7426$var$immer);
var $e5e702a7285c7426$export$3c3214997190395f = $e5e702a7285c7426$var$immer.createDraft.bind($e5e702a7285c7426$var$immer);
var $e5e702a7285c7426$export$c60f5e69c521b528 = $e5e702a7285c7426$var$immer.finishDraft.bind($e5e702a7285c7426$var$immer);
function $e5e702a7285c7426$export$c05b21e3257751e5(value) {
    return value;
}
function $e5e702a7285c7426$export$20f911b3f8cf0b74(value) {
    return value;
}


var $363a2fa013f2d91f$var$__defProp = Object.defineProperty;
var $363a2fa013f2d91f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $363a2fa013f2d91f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $363a2fa013f2d91f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $363a2fa013f2d91f$var$__defNormalProp = (obj, key, value)=>key in obj ? $363a2fa013f2d91f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $363a2fa013f2d91f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($363a2fa013f2d91f$var$__hasOwnProp.call(b, prop)) $363a2fa013f2d91f$var$__defNormalProp(a, prop, b[prop]);
    if ($363a2fa013f2d91f$var$__getOwnPropSymbols) {
        for (var prop of $363a2fa013f2d91f$var$__getOwnPropSymbols(b))if ($363a2fa013f2d91f$var$__propIsEnum.call(b, prop)) $363a2fa013f2d91f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $363a2fa013f2d91f$var$__publicField = (obj, key, value)=>{
    $363a2fa013f2d91f$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $363a2fa013f2d91f$var$runIdentityFunctionCheck = (resultFunc)=>{
    let isInputSameAsOutput = false;
    try {
        const emptyObject = {};
        if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
    } catch (e) {}
    if (isInputSameAsOutput) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
            stack: stack
        });
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $363a2fa013f2d91f$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $363a2fa013f2d91f$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $363a2fa013f2d91f$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($363a2fa013f2d91f$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $363a2fa013f2d91f$var$NOT_FOUND = "NOT_FOUND";
function $363a2fa013f2d91f$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $363a2fa013f2d91f$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $363a2fa013f2d91f$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $363a2fa013f2d91f$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $363a2fa013f2d91f$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $363a2fa013f2d91f$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $363a2fa013f2d91f$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $363a2fa013f2d91f$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $363a2fa013f2d91f$var$__spreadValues($363a2fa013f2d91f$var$__spreadValues({}, $363a2fa013f2d91f$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $363a2fa013f2d91f$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $363a2fa013f2d91f$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $363a2fa013f2d91f$var$$REVISION = 0;
var $363a2fa013f2d91f$var$CURRENT_TRACKER = null;
var $363a2fa013f2d91f$var$Cell = class {
    constructor(initialValue, isEqual = $363a2fa013f2d91f$var$tripleEq){
        $363a2fa013f2d91f$var$__publicField(this, "revision", $363a2fa013f2d91f$var$$REVISION);
        $363a2fa013f2d91f$var$__publicField(this, "_value");
        $363a2fa013f2d91f$var$__publicField(this, "_lastValue");
        $363a2fa013f2d91f$var$__publicField(this, "_isEqual", $363a2fa013f2d91f$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $363a2fa013f2d91f$var$CURRENT_TRACKER == null || $363a2fa013f2d91f$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$363a2fa013f2d91f$var$$REVISION;
    }
};
function $363a2fa013f2d91f$var$tripleEq(a, b) {
    return a === b;
}
var $363a2fa013f2d91f$var$TrackingCache = class {
    constructor(fn){
        $363a2fa013f2d91f$var$__publicField(this, "_cachedValue");
        $363a2fa013f2d91f$var$__publicField(this, "_cachedRevision", -1);
        $363a2fa013f2d91f$var$__publicField(this, "_deps", []);
        $363a2fa013f2d91f$var$__publicField(this, "hits", 0);
        $363a2fa013f2d91f$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $363a2fa013f2d91f$var$CURRENT_TRACKER;
            $363a2fa013f2d91f$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $363a2fa013f2d91f$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $363a2fa013f2d91f$var$CURRENT_TRACKER == null || $363a2fa013f2d91f$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $363a2fa013f2d91f$var$getValue(cell) {
    if (!(cell instanceof $363a2fa013f2d91f$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $363a2fa013f2d91f$var$setValue(storage, value) {
    if (!(storage instanceof $363a2fa013f2d91f$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $363a2fa013f2d91f$var$createCell(initialValue, isEqual = $363a2fa013f2d91f$var$tripleEq) {
    return new $363a2fa013f2d91f$var$Cell(initialValue, isEqual);
}
function $363a2fa013f2d91f$var$createCache(fn) {
    $363a2fa013f2d91f$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $363a2fa013f2d91f$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $363a2fa013f2d91f$var$neverEq = (a, b)=>false;
function $363a2fa013f2d91f$var$createTag() {
    return $363a2fa013f2d91f$var$createCell(null, $363a2fa013f2d91f$var$neverEq);
}
function $363a2fa013f2d91f$var$dirtyTag(tag, value) {
    $363a2fa013f2d91f$var$setValue(tag, value);
}
var $363a2fa013f2d91f$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $363a2fa013f2d91f$var$createTag();
    $363a2fa013f2d91f$var$getValue(tag);
};
var $363a2fa013f2d91f$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $363a2fa013f2d91f$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $363a2fa013f2d91f$var$REDUX_PROXY_LABEL = Symbol();
var $363a2fa013f2d91f$var$nextId = 0;
var $363a2fa013f2d91f$var$proto = Object.getPrototypeOf({});
var $363a2fa013f2d91f$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $363a2fa013f2d91f$var$__publicField(this, "proxy", new Proxy(this, $363a2fa013f2d91f$var$objectProxyHandler));
        $363a2fa013f2d91f$var$__publicField(this, "tag", $363a2fa013f2d91f$var$createTag());
        $363a2fa013f2d91f$var$__publicField(this, "tags", {});
        $363a2fa013f2d91f$var$__publicField(this, "children", {});
        $363a2fa013f2d91f$var$__publicField(this, "collectionTag", null);
        $363a2fa013f2d91f$var$__publicField(this, "id", $363a2fa013f2d91f$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $363a2fa013f2d91f$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $363a2fa013f2d91f$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $363a2fa013f2d91f$var$createNode(childValue);
                if (childNode.tag) $363a2fa013f2d91f$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $363a2fa013f2d91f$var$createTag();
                    tag.value = childValue;
                }
                $363a2fa013f2d91f$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $363a2fa013f2d91f$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $363a2fa013f2d91f$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $363a2fa013f2d91f$var$__publicField(this, "proxy", new Proxy([
            this
        ], $363a2fa013f2d91f$var$arrayProxyHandler));
        $363a2fa013f2d91f$var$__publicField(this, "tag", $363a2fa013f2d91f$var$createTag());
        $363a2fa013f2d91f$var$__publicField(this, "tags", {});
        $363a2fa013f2d91f$var$__publicField(this, "children", {});
        $363a2fa013f2d91f$var$__publicField(this, "collectionTag", null);
        $363a2fa013f2d91f$var$__publicField(this, "id", $363a2fa013f2d91f$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $363a2fa013f2d91f$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $363a2fa013f2d91f$var$consumeCollection(node);
        return $363a2fa013f2d91f$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $363a2fa013f2d91f$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $363a2fa013f2d91f$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $363a2fa013f2d91f$var$objectProxyHandler.has(node, prop);
    }
};
function $363a2fa013f2d91f$var$createNode(value) {
    if (Array.isArray(value)) return new $363a2fa013f2d91f$var$ArrayTreeNode(value);
    return new $363a2fa013f2d91f$var$ObjectTreeNode(value);
}
function $363a2fa013f2d91f$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $363a2fa013f2d91f$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $363a2fa013f2d91f$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $363a2fa013f2d91f$var$dirtyCollection(node);
            $363a2fa013f2d91f$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $363a2fa013f2d91f$var$updateNode(childNode, newChildValue);
        else {
            $363a2fa013f2d91f$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $363a2fa013f2d91f$var$deleteNode(node) {
    if (node.tag) $363a2fa013f2d91f$var$dirtyTag(node.tag, null);
    $363a2fa013f2d91f$var$dirtyCollection(node);
    for(const key in node.tags)$363a2fa013f2d91f$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$363a2fa013f2d91f$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $363a2fa013f2d91f$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $363a2fa013f2d91f$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $363a2fa013f2d91f$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $363a2fa013f2d91f$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $363a2fa013f2d91f$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $363a2fa013f2d91f$export$3f025202a230c6dd = (a, b)=>a === b;
function $363a2fa013f2d91f$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $363a2fa013f2d91f$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $363a2fa013f2d91f$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $363a2fa013f2d91f$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $363a2fa013f2d91f$var$createSingletonCache(comparator) : $363a2fa013f2d91f$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $363a2fa013f2d91f$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $363a2fa013f2d91f$export$c8f9cf88d9fdee55(func) {
    const node = $363a2fa013f2d91f$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $363a2fa013f2d91f$var$createCacheKeyComparator($363a2fa013f2d91f$export$3f025202a230c6dd);
    const cache = $363a2fa013f2d91f$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $363a2fa013f2d91f$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $363a2fa013f2d91f$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $363a2fa013f2d91f$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $363a2fa013f2d91f$var$StrongRef;
var $363a2fa013f2d91f$var$UNTERMINATED = 0;
var $363a2fa013f2d91f$var$TERMINATED = 1;
function $363a2fa013f2d91f$var$createCacheNode() {
    return {
        s: $363a2fa013f2d91f$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $363a2fa013f2d91f$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $363a2fa013f2d91f$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $363a2fa013f2d91f$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $363a2fa013f2d91f$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $363a2fa013f2d91f$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $363a2fa013f2d91f$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_a = lastResult == null ? void 0 : lastResult.deref()) != null ? _a : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $363a2fa013f2d91f$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $363a2fa013f2d91f$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $363a2fa013f2d91f$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $363a2fa013f2d91f$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $363a2fa013f2d91f$var$__spreadValues($363a2fa013f2d91f$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $363a2fa013f2d91f$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $363a2fa013f2d91f$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $363a2fa013f2d91f$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $363a2fa013f2d91f$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $363a2fa013f2d91f$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    return createSelector2;
}
var $363a2fa013f2d91f$export$595d22ed68ca2841 = /* @__PURE__ */ $363a2fa013f2d91f$export$5943f4447f6ef248($363a2fa013f2d91f$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $363a2fa013f2d91f$export$75979cfcd91bf38f = (inputSelectorsObject, selectorCreator = $363a2fa013f2d91f$export$595d22ed68ca2841)=>{
    $363a2fa013f2d91f$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
};


// src/index.ts
function $649ceaab3a730033$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $649ceaab3a730033$export$dd164f5517779f15 = $649ceaab3a730033$var$createThunkMiddleware();
var $649ceaab3a730033$export$16d06542a1949d9e = $649ceaab3a730033$var$createThunkMiddleware;


var $af1e72d42bed86d2$exports = {};
// shim for using process in browser
var $af1e72d42bed86d2$var$process = $af1e72d42bed86d2$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $af1e72d42bed86d2$var$cachedSetTimeout;
var $af1e72d42bed86d2$var$cachedClearTimeout;
function $af1e72d42bed86d2$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $af1e72d42bed86d2$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $af1e72d42bed86d2$var$cachedSetTimeout = setTimeout;
        else $af1e72d42bed86d2$var$cachedSetTimeout = $af1e72d42bed86d2$var$defaultSetTimout;
    } catch (e) {
        $af1e72d42bed86d2$var$cachedSetTimeout = $af1e72d42bed86d2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $af1e72d42bed86d2$var$cachedClearTimeout = clearTimeout;
        else $af1e72d42bed86d2$var$cachedClearTimeout = $af1e72d42bed86d2$var$defaultClearTimeout;
    } catch (e) {
        $af1e72d42bed86d2$var$cachedClearTimeout = $af1e72d42bed86d2$var$defaultClearTimeout;
    }
})();
function $af1e72d42bed86d2$var$runTimeout(fun) {
    if ($af1e72d42bed86d2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($af1e72d42bed86d2$var$cachedSetTimeout === $af1e72d42bed86d2$var$defaultSetTimout || !$af1e72d42bed86d2$var$cachedSetTimeout) && setTimeout) {
        $af1e72d42bed86d2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $af1e72d42bed86d2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $af1e72d42bed86d2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $af1e72d42bed86d2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $af1e72d42bed86d2$var$runClearTimeout(marker) {
    if ($af1e72d42bed86d2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($af1e72d42bed86d2$var$cachedClearTimeout === $af1e72d42bed86d2$var$defaultClearTimeout || !$af1e72d42bed86d2$var$cachedClearTimeout) && clearTimeout) {
        $af1e72d42bed86d2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $af1e72d42bed86d2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $af1e72d42bed86d2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $af1e72d42bed86d2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $af1e72d42bed86d2$var$queue = [];
var $af1e72d42bed86d2$var$draining = false;
var $af1e72d42bed86d2$var$currentQueue;
var $af1e72d42bed86d2$var$queueIndex = -1;
function $af1e72d42bed86d2$var$cleanUpNextTick() {
    if (!$af1e72d42bed86d2$var$draining || !$af1e72d42bed86d2$var$currentQueue) return;
    $af1e72d42bed86d2$var$draining = false;
    if ($af1e72d42bed86d2$var$currentQueue.length) $af1e72d42bed86d2$var$queue = $af1e72d42bed86d2$var$currentQueue.concat($af1e72d42bed86d2$var$queue);
    else $af1e72d42bed86d2$var$queueIndex = -1;
    if ($af1e72d42bed86d2$var$queue.length) $af1e72d42bed86d2$var$drainQueue();
}
function $af1e72d42bed86d2$var$drainQueue() {
    if ($af1e72d42bed86d2$var$draining) return;
    var timeout = $af1e72d42bed86d2$var$runTimeout($af1e72d42bed86d2$var$cleanUpNextTick);
    $af1e72d42bed86d2$var$draining = true;
    var len = $af1e72d42bed86d2$var$queue.length;
    while(len){
        $af1e72d42bed86d2$var$currentQueue = $af1e72d42bed86d2$var$queue;
        $af1e72d42bed86d2$var$queue = [];
        while(++$af1e72d42bed86d2$var$queueIndex < len)if ($af1e72d42bed86d2$var$currentQueue) $af1e72d42bed86d2$var$currentQueue[$af1e72d42bed86d2$var$queueIndex].run();
        $af1e72d42bed86d2$var$queueIndex = -1;
        len = $af1e72d42bed86d2$var$queue.length;
    }
    $af1e72d42bed86d2$var$currentQueue = null;
    $af1e72d42bed86d2$var$draining = false;
    $af1e72d42bed86d2$var$runClearTimeout(timeout);
}
$af1e72d42bed86d2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $af1e72d42bed86d2$var$queue.push(new $af1e72d42bed86d2$var$Item(fun, args));
    if ($af1e72d42bed86d2$var$queue.length === 1 && !$af1e72d42bed86d2$var$draining) $af1e72d42bed86d2$var$runTimeout($af1e72d42bed86d2$var$drainQueue);
};
// v8 likes predictible objects
function $af1e72d42bed86d2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$af1e72d42bed86d2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$af1e72d42bed86d2$var$process.title = "browser";
$af1e72d42bed86d2$var$process.browser = true;
$af1e72d42bed86d2$var$process.env = {};
$af1e72d42bed86d2$var$process.argv = [];
$af1e72d42bed86d2$var$process.version = ""; // empty string to avoid regexp issues
$af1e72d42bed86d2$var$process.versions = {};
function $af1e72d42bed86d2$var$noop() {}
$af1e72d42bed86d2$var$process.on = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.addListener = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.once = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.off = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.removeListener = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.removeAllListeners = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.emit = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.prependListener = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.prependOnceListener = $af1e72d42bed86d2$var$noop;
$af1e72d42bed86d2$var$process.listeners = function(name) {
    return [];
};
$af1e72d42bed86d2$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$af1e72d42bed86d2$var$process.cwd = function() {
    return "/";
};
$af1e72d42bed86d2$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$af1e72d42bed86d2$var$process.umask = function() {
    return 0;
};


var $484fbe089c3bc165$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $363a2fa013f2d91f$export$5943f4447f6ef248)(...args);
    return (...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $e5e702a7285c7426$export$541ac630993a4c84)(value) ? (0, $e5e702a7285c7426$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    };
};
var $484fbe089c3bc165$export$a5d3c27355e35910 = $484fbe089c3bc165$export$aab6de9e3dbb1473((0, $363a2fa013f2d91f$export$8402dc26d96f6902));
var $484fbe089c3bc165$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $9c0d8341932e5849$export$f672e0b6f7222cd7;
    return (0, $9c0d8341932e5849$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $484fbe089c3bc165$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $484fbe089c3bc165$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $484fbe089c3bc165$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $9c0d8341932e5849$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $484fbe089c3bc165$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $484fbe089c3bc165$var$hasMatchFunction(action);
}
function $484fbe089c3bc165$export$ebd532f9034651f3(action) {
    return (0, $9c0d8341932e5849$export$b956e38827fca970)(action) && Object.keys(action).every($484fbe089c3bc165$var$isValidKey);
}
function $484fbe089c3bc165$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $484fbe089c3bc165$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $484fbe089c3bc165$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $484fbe089c3bc165$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $484fbe089c3bc165$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $484fbe089c3bc165$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $484fbe089c3bc165$var$freezeDraftable(val) {
    return (0, $e5e702a7285c7426$export$16e3aed3edb85946)(val) ? (0, $e5e702a7285c7426$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $484fbe089c3bc165$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $484fbe089c3bc165$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $484fbe089c3bc165$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $484fbe089c3bc165$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $484fbe089c3bc165$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $484fbe089c3bc165$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $484fbe089c3bc165$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $484fbe089c3bc165$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $484fbe089c3bc165$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $484fbe089c3bc165$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $484fbe089c3bc165$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $9c0d8341932e5849$export$53b83ca8eaab0383)(val);
}
function $484fbe089c3bc165$export$ada5dca0b571bc7(value, path = "", isSerializable = $484fbe089c3bc165$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $484fbe089c3bc165$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $484fbe089c3bc165$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $484fbe089c3bc165$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$484fbe089c3bc165$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $484fbe089c3bc165$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $484fbe089c3bc165$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $484fbe089c3bc165$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $484fbe089c3bc165$export$1908877435b1d5e9();
        if (thunk) {
            if ($484fbe089c3bc165$var$isBoolean(thunk)) middlewareArray.push((0, $649ceaab3a730033$export$dd164f5517779f15));
            else middlewareArray.push((0, $649ceaab3a730033$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $484fbe089c3bc165$export$8fb31c0f05df007b = "RTK_autoBatch";
var $484fbe089c3bc165$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$484fbe089c3bc165$export$8fb31c0f05df007b]: true
            }
        });
var $484fbe089c3bc165$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $484fbe089c3bc165$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $484fbe089c3bc165$var$createQueueWithTimer(10);
var $484fbe089c3bc165$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $484fbe089c3bc165$var$rAF : options.type === "callback" ? options.queueNotification : $484fbe089c3bc165$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$484fbe089c3bc165$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $484fbe089c3bc165$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $484fbe089c3bc165$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($484fbe089c3bc165$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $484fbe089c3bc165$var$IS_PRODUCTION = true;
function $484fbe089c3bc165$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $484fbe089c3bc165$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $9c0d8341932e5849$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $9c0d8341932e5849$export$66e4520cdb265d18)(reducer);
    else throw new Error($484fbe089c3bc165$export$378fa86b259c0280(1));
    if (!$484fbe089c3bc165$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($484fbe089c3bc165$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$484fbe089c3bc165$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$484fbe089c3bc165$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(4));
    let finalCompose = (0, $9c0d8341932e5849$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $484fbe089c3bc165$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$484fbe089c3bc165$var$IS_PRODUCTION,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $9c0d8341932e5849$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $484fbe089c3bc165$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$484fbe089c3bc165$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($484fbe089c3bc165$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$484fbe089c3bc165$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(6));
    if (!$484fbe089c3bc165$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(7));
    if (!$484fbe089c3bc165$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $9c0d8341932e5849$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $484fbe089c3bc165$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $484fbe089c3bc165$var$isStateFunction(x) {
    return typeof x === "function";
}
function $484fbe089c3bc165$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $484fbe089c3bc165$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($484fbe089c3bc165$var$isStateFunction(initialState)) getInitialState = ()=>$484fbe089c3bc165$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $484fbe089c3bc165$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $e5e702a7285c7426$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $e5e702a7285c7426$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($484fbe089c3bc165$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $e5e702a7285c7426$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $484fbe089c3bc165$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $484fbe089c3bc165$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $484fbe089c3bc165$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $484fbe089c3bc165$var$matches = (matcher, action)=>{
    if ($484fbe089c3bc165$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $484fbe089c3bc165$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$484fbe089c3bc165$var$matches(matcher, action));
    };
}
function $484fbe089c3bc165$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$484fbe089c3bc165$var$matches(matcher, action));
    };
}
function $484fbe089c3bc165$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $484fbe089c3bc165$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $484fbe089c3bc165$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$484fbe089c3bc165$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$484fbe089c3bc165$var$isAsyncThunkArray(asyncThunks)) return $484fbe089c3bc165$export$872dec21e9a69476()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.pending);
        const combinedMatcher = $484fbe089c3bc165$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $484fbe089c3bc165$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$484fbe089c3bc165$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$484fbe089c3bc165$var$isAsyncThunkArray(asyncThunks)) return $484fbe089c3bc165$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.rejected);
        const combinedMatcher = $484fbe089c3bc165$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $484fbe089c3bc165$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return (action)=>{
        const combinedMatcher = $484fbe089c3bc165$export$9dd1fb32974da385($484fbe089c3bc165$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$484fbe089c3bc165$var$isAsyncThunkArray(asyncThunks)) return $484fbe089c3bc165$export$fcc3388fb56de601()(asyncThunks[0]);
    return (action)=>{
        const combinedMatcher = $484fbe089c3bc165$export$9dd1fb32974da385($484fbe089c3bc165$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $484fbe089c3bc165$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$484fbe089c3bc165$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$484fbe089c3bc165$var$isAsyncThunkArray(asyncThunks)) return $484fbe089c3bc165$export$1da80a6ef1307441()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled);
        const combinedMatcher = $484fbe089c3bc165$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $484fbe089c3bc165$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$484fbe089c3bc165$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$484fbe089c3bc165$var$isAsyncThunkArray(asyncThunks)) return $484fbe089c3bc165$export$6aa4142d99c1abce()(asyncThunks[0]);
    return (action)=>{
        const matchers = [];
        for (const asyncThunk of asyncThunks)matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        const combinedMatcher = $484fbe089c3bc165$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $484fbe089c3bc165$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $484fbe089c3bc165$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $484fbe089c3bc165$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $484fbe089c3bc165$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $484fbe089c3bc165$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $484fbe089c3bc165$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $484fbe089c3bc165$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $484fbe089c3bc165$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $484fbe089c3bc165$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $484fbe089c3bc165$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $484fbe089c3bc165$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($484fbe089c3bc165$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>abortController.signal.addEventListener("abort", ()=>reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                })));
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $484fbe089c3bc165$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $484fbe089c3bc165$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $484fbe089c3bc165$var$RejectWithValue) throw result;
                                if (result instanceof $484fbe089c3bc165$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $484fbe089c3bc165$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($484fbe089c3bc165$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $484fbe089c3bc165$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $484fbe089c3bc165$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $484fbe089c3bc165$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $484fbe089c3bc165$var$asyncThunkSymbol = Symbol.for("rtk-slice-createasyncthunk");
var $484fbe089c3bc165$export$343355ed40c51c46 = {
    [$484fbe089c3bc165$var$asyncThunkSymbol]: $484fbe089c3bc165$export$6abd22dc03e5063f
};
var $484fbe089c3bc165$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($484fbe089c3bc165$export$23a094319a4b586 || {});
function $484fbe089c3bc165$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $484fbe089c3bc165$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$484fbe089c3bc165$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(11));
        typeof $af1e72d42bed86d2$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($484fbe089c3bc165$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer;
                return contextMethods;
            },
            addMatcher (matcher, reducer) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer) {
                context.sliceCaseReducersByName[name2] = reducer;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $484fbe089c3bc165$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($484fbe089c3bc165$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $484fbe089c3bc165$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $484fbe089c3bc165$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $484fbe089c3bc165$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $484fbe089c3bc165$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        const slice = {
            name: name,
            reducerPath: reducerPath,
            reducer (state, action) {
                if (!_reducer) _reducer = buildReducer();
                return _reducer(state, action);
            },
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState () {
                if (!_reducer) _reducer = buildReducer();
                return _reducer.getInitialState();
            },
            getSelectors (selectState = selectSelf) {
                const selectorCache = $484fbe089c3bc165$var$emplace(injectedSelectorCache, this, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $484fbe089c3bc165$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $484fbe089c3bc165$var$wrapSelector(this, selector, selectState, this !== slice);
                        return map;
                    }
                });
            },
            selectSlice (state) {
                let sliceState = state[this.reducerPath];
                if (typeof sliceState === "undefined") {
                    if (this !== slice) sliceState = this.getInitialState();
                }
                return sliceState;
            },
            get selectors () {
                return this.getSelectors(this.selectSlice);
            },
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const reducerPath2 = pathOpt ?? this.reducerPath;
                injectable.inject({
                    reducerPath: reducerPath2,
                    reducer: this.reducer
                }, config);
                return {
                    ...this,
                    reducerPath: reducerPath2
                };
            }
        };
        return slice;
    };
}
function $484fbe089c3bc165$var$wrapSelector(slice, selector, selectState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState.call(slice, rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = slice.getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $484fbe089c3bc165$export$4d8d9bd83c24ae8b = $484fbe089c3bc165$export$affdea4146de9cf5();
function $484fbe089c3bc165$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $484fbe089c3bc165$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$484fbe089c3bc165$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $484fbe089c3bc165$export$309c7a02b0b0bc62(type, prepareCallback) : $484fbe089c3bc165$export$309c7a02b0b0bc62(type));
}
function $484fbe089c3bc165$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $484fbe089c3bc165$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $484fbe089c3bc165$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $484fbe089c3bc165$var$noop,
        pending: pending || $484fbe089c3bc165$var$noop,
        rejected: rejected || $484fbe089c3bc165$var$noop,
        settled: settled || $484fbe089c3bc165$var$noop
    });
}
function $484fbe089c3bc165$var$noop() {}
// src/entities/entity_state.ts
function $484fbe089c3bc165$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $484fbe089c3bc165$var$createInitialStateFactory() {
    function getInitialState(additionalState = {}) {
        return Object.assign($484fbe089c3bc165$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $484fbe089c3bc165$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $484fbe089c3bc165$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $484fbe089c3bc165$var$isDraftTyped = (0, $e5e702a7285c7426$export$541ac630993a4c84);
function $484fbe089c3bc165$var$createSingleArgumentStateOperator(mutator) {
    const operator = $484fbe089c3bc165$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $484fbe089c3bc165$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $484fbe089c3bc165$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($484fbe089c3bc165$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $e5e702a7285c7426$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $484fbe089c3bc165$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $484fbe089c3bc165$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $484fbe089c3bc165$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $484fbe089c3bc165$var$ensureEntitiesArray(newEntities);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $484fbe089c3bc165$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $484fbe089c3bc165$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $484fbe089c3bc165$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $484fbe089c3bc165$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $484fbe089c3bc165$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $484fbe089c3bc165$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $484fbe089c3bc165$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $484fbe089c3bc165$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$484fbe089c3bc165$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $484fbe089c3bc165$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $484fbe089c3bc165$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $484fbe089c3bc165$var$createStateOperator(addOneMutably),
        addMany: $484fbe089c3bc165$var$createStateOperator(addManyMutably),
        setOne: $484fbe089c3bc165$var$createStateOperator(setOneMutably),
        setMany: $484fbe089c3bc165$var$createStateOperator(setManyMutably),
        setAll: $484fbe089c3bc165$var$createStateOperator(setAllMutably),
        updateOne: $484fbe089c3bc165$var$createStateOperator(updateOneMutably),
        updateMany: $484fbe089c3bc165$var$createStateOperator(updateManyMutably),
        upsertOne: $484fbe089c3bc165$var$createStateOperator(upsertOneMutably),
        upsertMany: $484fbe089c3bc165$var$createStateOperator(upsertManyMutably),
        removeOne: $484fbe089c3bc165$var$createStateOperator(removeOneMutably),
        removeMany: $484fbe089c3bc165$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $484fbe089c3bc165$var$createSortedStateAdapter(selectId, sort) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $484fbe089c3bc165$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $484fbe089c3bc165$var$ensureEntitiesArray(newEntities);
        const models = newEntities.filter((model)=>!($484fbe089c3bc165$var$selectIdValue(model, selectId) in state.entities));
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $484fbe089c3bc165$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $484fbe089c3bc165$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $484fbe089c3bc165$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach((model)=>{
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        const allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        const newSortedIds = allEntities.map(selectId);
        const { ids: ids } = state;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $484fbe089c3bc165$var$createStateOperator(addOneMutably),
        updateOne: $484fbe089c3bc165$var$createStateOperator(updateOneMutably),
        upsertOne: $484fbe089c3bc165$var$createStateOperator(upsertOneMutably),
        setOne: $484fbe089c3bc165$var$createStateOperator(setOneMutably),
        setMany: $484fbe089c3bc165$var$createStateOperator(setManyMutably),
        setAll: $484fbe089c3bc165$var$createStateOperator(setAllMutably),
        addMany: $484fbe089c3bc165$var$createStateOperator(addManyMutably),
        updateMany: $484fbe089c3bc165$var$createStateOperator(updateManyMutably),
        upsertMany: $484fbe089c3bc165$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $484fbe089c3bc165$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateFactory = $484fbe089c3bc165$var$createInitialStateFactory();
    const selectorsFactory = $484fbe089c3bc165$var$createSelectorsFactory();
    const stateAdapter = sortComparer ? $484fbe089c3bc165$var$createSortedStateAdapter(selectId, sortComparer) : $484fbe089c3bc165$var$createUnsortedStateAdapter(selectId);
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/utils.ts
var $484fbe089c3bc165$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($484fbe089c3bc165$export$378fa86b259c0280(32));
};
var $484fbe089c3bc165$var$noop2 = ()=>{};
var $484fbe089c3bc165$var$catchRejection = (promise, onError = $484fbe089c3bc165$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $484fbe089c3bc165$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $484fbe089c3bc165$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $484fbe089c3bc165$var$task = "task";
var $484fbe089c3bc165$var$listener = "listener";
var $484fbe089c3bc165$var$completed = "completed";
var $484fbe089c3bc165$var$cancelled = "cancelled";
var $484fbe089c3bc165$var$taskCancelled = `task-${$484fbe089c3bc165$var$cancelled}`;
var $484fbe089c3bc165$var$taskCompleted = `task-${$484fbe089c3bc165$var$completed}`;
var $484fbe089c3bc165$var$listenerCancelled = `${$484fbe089c3bc165$var$listener}-${$484fbe089c3bc165$var$cancelled}`;
var $484fbe089c3bc165$var$listenerCompleted = `${$484fbe089c3bc165$var$listener}-${$484fbe089c3bc165$var$completed}`;
var $484fbe089c3bc165$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$484fbe089c3bc165$var$task} ${$484fbe089c3bc165$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/task.ts
var $484fbe089c3bc165$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $484fbe089c3bc165$export$cb1bdac908fed7f(reason);
    }
};
function $484fbe089c3bc165$var$raceWithSignal(signal, promise) {
    let cleanup = $484fbe089c3bc165$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $484fbe089c3bc165$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $484fbe089c3bc165$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $484fbe089c3bc165$var$noop2;
    });
}
var $484fbe089c3bc165$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $484fbe089c3bc165$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $484fbe089c3bc165$var$createPause = (signal)=>{
    return (promise)=>{
        return $484fbe089c3bc165$var$catchRejection($484fbe089c3bc165$var$raceWithSignal(signal, promise).then((output)=>{
            $484fbe089c3bc165$var$validateActive(signal);
            return output;
        }));
    };
};
var $484fbe089c3bc165$var$createDelay = (signal)=>{
    const pause = $484fbe089c3bc165$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $484fbe089c3bc165$var$assign } = Object;
var $484fbe089c3bc165$var$INTERNAL_NIL_TOKEN = {};
var $484fbe089c3bc165$var$alm = "listenerMiddleware";
var $484fbe089c3bc165$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$484fbe089c3bc165$var$addAbortSignalListener(parentAbortSignal, ()=>$484fbe089c3bc165$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $484fbe089c3bc165$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $484fbe089c3bc165$var$runTask(async ()=>{
            $484fbe089c3bc165$var$validateActive(parentAbortSignal);
            $484fbe089c3bc165$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $484fbe089c3bc165$var$createPause(childAbortController.signal),
                delay: $484fbe089c3bc165$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $484fbe089c3bc165$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$484fbe089c3bc165$var$abortControllerWithReason(childAbortController, $484fbe089c3bc165$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $484fbe089c3bc165$var$createPause(parentAbortSignal)(result),
            cancel () {
                $484fbe089c3bc165$var$abortControllerWithReason(childAbortController, $484fbe089c3bc165$var$taskCancelled);
            }
        };
    };
};
var $484fbe089c3bc165$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $484fbe089c3bc165$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $484fbe089c3bc165$var$raceWithSignal(signal, Promise.race(promises));
            $484fbe089c3bc165$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$484fbe089c3bc165$var$catchRejection(take(predicate, timeout));
};
var $484fbe089c3bc165$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $484fbe089c3bc165$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($484fbe089c3bc165$export$378fa86b259c0280(21));
    $484fbe089c3bc165$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $484fbe089c3bc165$var$createListenerEntry = (options)=>{
    const { type: type, predicate: predicate, effect: effect } = $484fbe089c3bc165$var$getListenerEntryPropsFrom(options);
    const id = $484fbe089c3bc165$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($484fbe089c3bc165$export$378fa86b259c0280(22));
        }
    };
    return entry;
};
var $484fbe089c3bc165$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $484fbe089c3bc165$var$abortControllerWithReason(controller, $484fbe089c3bc165$var$listenerCancelled);
    });
};
var $484fbe089c3bc165$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($484fbe089c3bc165$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $484fbe089c3bc165$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $484fbe089c3bc165$export$f03a6b845d3fb58b = $484fbe089c3bc165$export$309c7a02b0b0bc62(`${$484fbe089c3bc165$var$alm}/add`);
var $484fbe089c3bc165$export$b1b8022855fb2b71 = $484fbe089c3bc165$export$309c7a02b0b0bc62(`${$484fbe089c3bc165$var$alm}/removeAll`);
var $484fbe089c3bc165$export$b03e9483f936dccb = $484fbe089c3bc165$export$309c7a02b0b0bc62(`${$484fbe089c3bc165$var$alm}/remove`);
var $484fbe089c3bc165$var$defaultErrorHandler = (...args)=>{
    console.error(`${$484fbe089c3bc165$var$alm}/error`, ...args);
};
function $484fbe089c3bc165$export$1228acebbbcb485b(middlewareOptions = {}) {
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $484fbe089c3bc165$var$defaultErrorHandler } = middlewareOptions;
    $484fbe089c3bc165$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $484fbe089c3bc165$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $484fbe089c3bc165$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $484fbe089c3bc165$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $484fbe089c3bc165$var$getListenerEntryPropsFrom(options);
        const entry = $484fbe089c3bc165$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $484fbe089c3bc165$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $484fbe089c3bc165$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $484fbe089c3bc165$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $484fbe089c3bc165$var$createDelay(internalTaskController.signal),
                pause: $484fbe089c3bc165$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $484fbe089c3bc165$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $484fbe089c3bc165$var$abortControllerWithReason(controller, $484fbe089c3bc165$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $484fbe089c3bc165$var$abortControllerWithReason(internalTaskController, $484fbe089c3bc165$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $484fbe089c3bc165$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $484fbe089c3bc165$export$cb1bdac908fed7f)) $484fbe089c3bc165$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.allSettled(autoJoinPromises);
            $484fbe089c3bc165$var$abortControllerWithReason(internalTaskController, $484fbe089c3bc165$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $484fbe089c3bc165$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $9c0d8341932e5849$export$b956e38827fca970)(action)) return next(action);
                if ($484fbe089c3bc165$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($484fbe089c3bc165$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($484fbe089c3bc165$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $484fbe089c3bc165$var$INTERNAL_NIL_TOKEN) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        let currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (let entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $484fbe089c3bc165$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $484fbe089c3bc165$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
var $484fbe089c3bc165$var$createMiddlewareEntry = (middleware)=>({
        id: $484fbe089c3bc165$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $484fbe089c3bc165$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $484fbe089c3bc165$export$4bb1606a79445586 = ()=>{
    const instanceId = $484fbe089c3bc165$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($484fbe089c3bc165$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $484fbe089c3bc165$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $484fbe089c3bc165$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$484fbe089c3bc165$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $9c0d8341932e5849$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $484fbe089c3bc165$export$9dd1fb32974da385(withMiddleware, $484fbe089c3bc165$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $484fbe089c3bc165$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $484fbe089c3bc165$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$484fbe089c3bc165$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $484fbe089c3bc165$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $484fbe089c3bc165$var$isStateProxy = (value)=>!!value && !!value[$484fbe089c3bc165$var$ORIGINAL_STATE];
var $484fbe089c3bc165$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $484fbe089c3bc165$var$createStateProxy = (state, reducerMap)=>$484fbe089c3bc165$var$emplace($484fbe089c3bc165$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $484fbe089c3bc165$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $484fbe089c3bc165$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($484fbe089c3bc165$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $484fbe089c3bc165$var$original = (state)=>{
    if (!$484fbe089c3bc165$var$isStateProxy(state)) throw new Error($484fbe089c3bc165$export$378fa86b259c0280(25));
    return state[$484fbe089c3bc165$var$ORIGINAL_STATE];
};
function $484fbe089c3bc165$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($484fbe089c3bc165$var$getReducers(slices));
    const getReducer = ()=>(0, $9c0d8341932e5849$export$66e4520cdb265d18)(reducerMap);
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $af1e72d42bed86d2$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($484fbe089c3bc165$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $484fbe089c3bc165$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $484fbe089c3bc165$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $466d43ba1de833d2$var$cartSlice = (0, $484fbe089c3bc165$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            state.items.pop();
        },
        clearCart: (state, action)=>{
            // state.items.length=0;
            return {
                items: []
            };
        }
    }
});
const { addItem: $466d43ba1de833d2$export$fb9705de59d96855, removeItem: $466d43ba1de833d2$export$fe2d9b4e03920b4c, clearCart: $466d43ba1de833d2$export$810121176e3e3671 } = $466d43ba1de833d2$var$cartSlice.actions;
var $466d43ba1de833d2$export$2e2bcd8739ae039 = $466d43ba1de833d2$var$cartSlice.reducer;



const $2837efcad0da1eee$var$ItemList = ({ items: items })=>{
    const dispatch = (0, $f3ef210356a0cd51$export$8ad76b76a4c905f8)();
    const handleAddItem = (item)=>{
        // diapatch and action 
        dispatch((0, $466d43ba1de833d2$export$fb9705de59d96855)(item));
    // console.log(item);
    };
    // console.log(items)
    return /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
        children: items.map((item)=>/*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "p-2 m-2  border-black border-b-2 text-left flex justify-between ",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                        className: "w-9/12",
                        children: [
                            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                                className: "py-2",
                                children: [
                                    /*#__PURE__*/ (0, $2RmP6.jsx)("span", {
                                        children: item.card.info.name
                                    }),
                                    /*#__PURE__*/ (0, $2RmP6.jsxs)("span", {
                                        children: [
                                            "      ",
                                            " -\u20B9",
                                            "      ",
                                            " ",
                                            item.card.info.price / 100 || item.card.info.defaultPrice / 100,
                                            "Rs"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2RmP6.jsx)("p", {
                                className: " text-xs",
                                children: item.card.info.description
                            }),
                            /*#__PURE__*/ (0, $2RmP6.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                        className: "w-3/12 p-4",
                        children: [
                            /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
                                className: "absolute",
                                children: /*#__PURE__*/ (0, $2RmP6.jsx)("button", {
                                    className: "p-2 mx-10 rounded-lg bg-white shadow-lg  m-auto",
                                    onClick: ()=>handleAddItem(item),
                                    children: "Add +"
                                })
                            }),
                            /*#__PURE__*/ (0, $2RmP6.jsx)("img", {
                                className: "bg-green-100 rounded-md ",
                                src: (0, $1f80689291b57452$export$cd85698b2b1026a5) + item.card.info.imageId
                            })
                        ]
                    })
                ]
            }, item.card.info.id))
    });
};
var $2837efcad0da1eee$export$2e2bcd8739ae039 //  src={ Menu_API +item.card.info.imageId }
 = $2837efcad0da1eee$var$ItemList;


const $9bae5c93e932a425$var$RestaurantCategory = ({ data: data, showItem: showItem, setshowIndex: setshowIndex })=>{
    //  console.log(data);
    //  const [showItem ,setShowItemss] = useState(false);
    const handleClick = ()=>{
        //  setShowItemss(!showItem);
        setshowIndex();
    };
    return /*#__PURE__*/ (0, $2RmP6.jsx)("div", {
        children: /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
            className: "w-6/12 mx-auto my-4 bg-gray-50 shadow-lg p-4",
            children: [
                /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                    className: " flex justify-between cursor-pointer",
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $2RmP6.jsxs)("span", {
                            className: "text-lg font-bold",
                            children: [
                                data.title,
                                "(",
                                data.itemCards.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2RmP6.jsx)("span", {
                            className: "text-xl",
                            children: "\u2935 "
                        })
                    ]
                }),
                showItem && /*#__PURE__*/ (0, $2RmP6.jsx)((0, $2837efcad0da1eee$export$2e2bcd8739ae039), {
                    items: data.itemCards
                })
            ]
        })
    });
};
var $9bae5c93e932a425$export$2e2bcd8739ae039 = $9bae5c93e932a425$var$RestaurantCategory;


const $870ad46907d278ec$var$RestaurantMenu = ()=>{
    const { resId: resId } = (0, $57f032b757fa5634$export$99eaa27ddbbb95ef)();
    //   console.log(params)
    const resInfo = (0, $b31bde19fc8c4e51$export$2e2bcd8739ae039)(resId);
    const [showIndex, setshowIndex] = (0, $6YKZt.useState)(null);
    if (resInfo === null) return /*#__PURE__*/ (0, $2RmP6.jsx)((0, $b694b696f2bd79bb$export$2e2bcd8739ae039), {});
    const { name: name, cuisines: cuisines, costForTwoMessage: costForTwoMessage, imageId: imageId } = resInfo?.cards[2]?.card?.card?.info;
    const { itemCards: itemCards } = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[3]?.card?.card;
    console.log(itemCards);
    //  console.log(resInfo?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards[3]?.card)
    const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c)=>c.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    console.log(categories);
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "text-center ",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsxs)("h1", {
                className: "font-bold my-6 text-2xl",
                children: [
                    " ",
                    name
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("h3", {
                className: "font-bold   text-lg",
                children: [
                    " ",
                    cuisines.join(", "),
                    "-",
                    costForTwoMessage
                ]
            }),
            /*#__PURE__*/ (0, $2RmP6.jsx)("h3", {
                children: " "
            }),
            categories.map((category, index)=>/*#__PURE__*/ (0, $2RmP6.jsx)((0, $9bae5c93e932a425$export$2e2bcd8739ae039), {
                    data: category?.card?.card,
                    showItem: index === showIndex ? true : false,
                    setshowIndex: ()=>setshowIndex(index)
                }, category?.card?.card.title))
        ]
    });
};
var $870ad46907d278ec$export$2e2bcd8739ae039 //      const categories= resInfo?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter(c=> c.card?.card?.["@type"]===);
 = $870ad46907d278ec$var$RestaurantMenu;






const $dd918c37d789c528$var$appStore = (0, $484fbe089c3bc165$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $466d43ba1de833d2$export$2e2bcd8739ae039)
    }
});
var $dd918c37d789c528$export$2e2bcd8739ae039 = $dd918c37d789c528$var$appStore;



var $2RmP6 = parcelRequire("2RmP6");



const $1edd91d6dd3868e5$var$Cart = ()=>{
    const cartItems = (0, $f3ef210356a0cd51$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $f3ef210356a0cd51$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $466d43ba1de833d2$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
        className: "text-center m-4 p-4 ",
        children: [
            /*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
                className: "text-xl font-bold",
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "w-6/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)("button", {
                        className: "p-2 m-2 bg-black rounded-lg text-white",
                        onClick: handleClearCart,
                        children: "Clear Cart"
                    }),
                    cartItems.length === 0 && /*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
                        children: "cart is empty"
                    }),
                    /*#__PURE__*/ (0, $2RmP6.jsx)((0, $2837efcad0da1eee$export$2e2bcd8739ae039), {
                        items: cartItems
                    })
                ]
            })
        ]
    });
};
var $1edd91d6dd3868e5$export$2e2bcd8739ae039 = $1edd91d6dd3868e5$var$Cart;



/**
 * Header
 * -logo
 * -Nav Item
 * Body 
 * -Search
 * -Card container
 * --Restocard
 *    -Img
 *     -Name of Res , Star Rating , cuisines and deve
 *   
 * 
 * Footer
 * -Copyright
 * -link
 * Address
 * Contact
 */ // <img  className='res-logo'   src= { "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320/e0vvulfbahjxjz6k4uwi" + 
// cloudinaryImageId
// } />    
// const resData = {
//   info: {
//     id: "303893",
//     name: "Haji Biryani House",
//     cloudinaryImageId: "hgzhzbqryqw59tzslics",
//     locality: "Kalyani",
//     areaName: "Kanchrapara Loco",
//     costForTwo: "₹350 for two",
//     cuisines: ["Biryani", "Mughlai", "Indian"],
//     avgRating: 3.7,
//     feeDetails: {
//       restaurantId: "303893",
//       fees: [
//         {
//           name: "BASE_DISTANCE",
//           fee: 1900,
//         },
//         {
//           name: "BASE_TIME",
//         },
//         {
//           name: "ANCILLARY_SURGE_FEE",
//         },
//       ],
//       totalFee: 1900,
//     },
//     parentId: "18592",
//     avgRatingString: "3.7",
//     totalRatingsString: "1K+",
//     sla: {
//       deliveryTime: 18,
//       lastMileTravel: 0.6,
//       serviceability: "SERVICEABLE",
//       slaString: "18 mins",
//       lastMileTravelString: "0.6 km",
//       iconType: "ICON_TYPE_EMPTY",
//     },
//     availability: {
//       nextCloseTime: "2023-09-20 23:59:00",
//       opened: true,
//     },
//     badges: {},
//     isOpen: true,
//     aggregatedDiscountInfoV2: {},
//     type: "F",
//     badgesV2: {
//       entityBadges: {
//         imageBased: {},
//         textBased: {},
//         textExtendedBadges: {},
//       },
//     },
//     orderabilityCommunication: {
//       title: {},
//       subTitle: {},
//       message: {},
//       customIcon: {},
//     },
//     differentiatedUi: {
//       displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//       differentiatedUiMediaDetails: {
//         mediaType: "ADS_MEDIA_ENUM_IMAGE",
//         lottie: {},
//         video: {},
//       },
//     },
//     reviewsSummary: {},
//     displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//     restaurantOfferPresentationInfo: {},
//   },
// };
//  const resData = {
//  "restaurants": [
//   {
//     "info": {
//       "id": "684427",
//       "name": "Cafe Amudham",
//       "cloudinaryImageId": "0bcdca61f3cd1e9135b98328593d044f",
//       "locality": "Lalbhagh  Siddapura",
//       "areaName": "Jayanagar",
//       "costForTwo": "₹400 for two",
//       "cuisines": [
//         "South Indian",
//         "Snacks"
//       ],
//       "avgRating": 4.5,
//       "veg": true,
//       "feeDetails": {
//         "restaurantId": "684427",
//         "fees": [
//           {
//             "name": "BASE_DISTANCE",
//             "fee": 4100
//           },
//           {
//             "name": "BASE_TIME"
//           },
//           {
//             "name": "ANCILLARY_SURGE_FEE"
//           }
//         ],
//         "totalFee": 4100
//       },
//       "parentId": "396620",
//       "avgRatingString": "4.5",
//       "totalRatingsString": "1K+",
//       "sla": {
//         "deliveryTime": 24,
//         "lastMileTravel": 4,
//         "serviceability": "SERVICEABLE",
//         "slaString": "24 mins",
//         "lastMileTravelString": "4.0 km",
//         "iconType": "ICON_TYPE_EMPTY"
//       },
//       "availability": {
//         "nextCloseTime": "2023-10-05 23:59:00",
//         "opened": true
//       },
//       "badges": {
//         "textExtendedBadges": [
//           {
//             "iconId": "guiltfree/GF_Logo_android_3x",
//             "shortDescription": "options available",
//             "fontColor": "#7E808C"
//           }
//         ]
//       },
//       "isOpen": true,
//       "type": "F",
//       "badgesV2": {
//         "entityBadges": {
//           "textBased": {
//           },
//           "imageBased": {
//           },
//           "textExtendedBadges": {
//             "badgeObject": [
//               {
//                 "attributes": {
//                   "iconId": "guiltfree/GF_Logo_android_3x",
//                   "description": "",
//                   "shortDescription": "options available",
//                   "fontColor": "#7E808C"
//                 }
//               }
//             ]
//           }
//         }
//       },
//       "aggregatedDiscountInfoV3": {
//         "header": "20% OFF",
//         "subHeader": "UPTO ₹50"
//       },
//       "differentiatedUi": {
//         "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//         "differentiatedUiMediaDetails": {
//           "mediaType": "ADS_MEDIA_ENUM_IMAGE",
//           "lottie": {
//           },
//           "video": {
//           }
//         }
//       },
//       "reviewsSummary": {
//       },
//       "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//       "restaurantOfferPresentationInfo": {
//       }
//     },
//     "analytics": {
//     },
//     "cta": {
//       "link": "swiggy://menu?restaurant_id=684427",
//       "text": "RESTAURANT_MENU",
//       "type": "DEEPLINK"
//     }
//  },
// ],
//  };
/* <RestaurantCard resData ={resList}/> */ const $e3b1c05950da75d9$var$Grocery = /*#__PURE__*/ (0, $6YKZt.lazy)(()=>(parcelRequire("6I9Dd")));
const $e3b1c05950da75d9$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $6YKZt.useState)();
    (0, $6YKZt.useEffect)(()=>{
        const data = {
            name: "Rakesh Kushwaha"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $2RmP6.jsx)((0, $f3ef210356a0cd51$export$2881499e37b75b9a), {
        store: (0, $dd918c37d789c528$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $68b2826e7e0b4a0a$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $2RmP6.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $2RmP6.jsx)((0, $8ca9c2a02d1b7815$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $2RmP6.jsx)((0, $57f032b757fa5634$export$910ae8079b2c2852), {})
                ]
            })
        })
    });
};
const $e3b1c05950da75d9$var$appRouter = (0, $041a517ada8d798a$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $2RmP6.jsx)($e3b1c05950da75d9$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $9189a9279a2293e1$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $43875d40b4ab981c$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $d5e2a43cca5176d2$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $6YKZt.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2RmP6.jsx)("h1", {
                        children: "Loading ...."
                    }),
                    children: /*#__PURE__*/ (0, $2RmP6.jsx)($e3b1c05950da75d9$var$Grocery, {})
                })
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $870ad46907d278ec$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $1edd91d6dd3868e5$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $2RmP6.jsx)((0, $038171ea419d65e1$export$2e2bcd8739ae039), {})
    }
]);
// const Title =() =>(
//     <h1 className='head' tabIndex="5">
//         Namaste Rakesh using JSX
//     </h1>
//  )
//  const heading = (
//     <h1  className='head'tabIndex="1" >
//          Nanaste Rakesh Kushwaha in JSX</h1>
//          );
//  const HeadingComponent = () =>(
//     <div id= "container">
//         <Title/>
//         {heading}
//         {Title()}
// <h1 className='heading'> Namaste React Fucntional Component  <Title/></h1>
// <Title/>
// </div>
// );
const $e3b1c05950da75d9$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($86f431360e84be50$exports))).createRoot(document.getElementById("root"));
$e3b1c05950da75d9$var$root.render(/*#__PURE__*/ (0, $2RmP6.jsx)((0, $041a517ada8d798a$export$323e4fc2fa4753fb), {
    router: $e3b1c05950da75d9$var$appRouter
}));


//# sourceMappingURL=index.2cc05be4.js.map
